import { j as m } from "./jsx-runtime-944c88e2.js";
import { InfoIcon as Cn } from "@chakra-ui/icons";
import { AccordionButton as Rr, Box as Re, Heading as wt, AccordionIcon as Dr, HStack as An, Text as de, SimpleGrid as Lt, Center as Mr, Input as Ue, Accordion as zt, AccordionItem as nt, AccordionPanel as at, useDisclosure as En, useClipboard as kn, Drawer as jn, DrawerOverlay as Tn, DrawerContent as In, DrawerCloseButton as Rn, DrawerBody as Dn, Breadcrumb as Mn, BreadcrumbItem as ur, Menu as Hn, MenuButton as Gn, BreadcrumbLink as Wn, MenuList as Bn, MenuItem as cr, Flex as Ce, Stack as Ae, StackDivider as Ln, Image as sr, Button as et, Checkbox as zn, Select as Fn, Table as fr, Thead as dr, Tr as Ve, Th as yt, Tbody as pr, Td as Be, VStack as $n, FormControl as vr, FormLabel as hr, Switch as gr, Tooltip as qn, Icon as Nn, DrawerFooter as Vn } from "@chakra-ui/react";
import { g as Hr, a as Un } from "./lodash-9598aa3c.js";
import { bg as Kn, bh as Yn, bi as Xn, bj as Zn, bk as Jn, u as Gr, E as Qn, bl as ea, T as yr, bm as mr } from "./eMyAsurionProvider-d8e4d830.js";
import we, { useState as St, useCallback as ta, useEffect as It } from "react";
import { u as ra } from "./useAccount-2421e215.js";
import { h as na, i as aa, g as ia } from "./domains-bf220bf9.js";
import "./myasurion-shared.mixpanel.es.js";
import { u as oa } from "./features-d3d4bb45.js";
import "./providers-251f5186.js";
import "@tanstack/react-query";
import la from "react-dom";
import { a as ua } from "./html2canvas.esm-1a45aa10.js";
import { getChakraColorScale as ca } from "./myasurion-shared.colors.es.js";
import "react-router-dom";
import "./myasurion-shared.carrier.es.js";
import "./cleave-react-node-c4a374e5.js";
import "@emotion/react";
import "@emotion/styled";
import "framer-motion";
import "@react-oauth/google";
import "./myasurion-shared.widgets.es.js";
import "./myasurion-shared.utils.es.js";
import "./ProfileIcon-8cf21b72.js";
import "./myasurion-shared.profile.es.js";
var sa = Kn, fa = Yn, da = Xn, br = Zn, pa = Jn;
function va(e, t, a, v) {
  if (!br(e))
    return e;
  t = fa(t, e);
  for (var p = -1, S = t.length, j = S - 1, E = e; E != null && ++p < S; ) {
    var z = pa(t[p]), w = a;
    if (z === "__proto__" || z === "constructor" || z === "prototype")
      return e;
    if (p != j) {
      var P = E[z];
      w = v ? v(P, z, E) : void 0, w === void 0 && (w = br(P) ? P : da(t[p + 1]) ? [] : {});
    }
    sa(E, z, w), E = E[z];
  }
  return e;
}
var ha = va, ga = ha;
function ya(e, t, a) {
  return e == null ? e : ga(e, t, a);
}
var ma = ya;
const He = /* @__PURE__ */ Hr(ma), mt = ({ children: e, ...t }) => /* @__PURE__ */ m.jsxs(Rr, { ...t, children: [
  /* @__PURE__ */ m.jsx(Re, { as: "span", flex: "1", textAlign: "left", children: /* @__PURE__ */ m.jsx(wt, { fontSize: "lg", children: e }) }),
  /* @__PURE__ */ m.jsx(Dr, {})
] }), it = ({ children: e, ...t }) => /* @__PURE__ */ m.jsx(An, { justify: "space-between", align: "center", gap: 3, ...t, children: e }), ot = ({ children: e, ...t }) => /* @__PURE__ */ m.jsx(
  de,
  {
    fontWeight: "bold",
    fontSize: "sm",
    color: "gray.400",
    letterSpacing: "wide",
    textTransform: "uppercase",
    ...t,
    children: e
  }
);
var Yt = {}, Te = {}, Se = {}, Ie = {}, ze = {};
Object.defineProperty(ze, "__esModule", {
  value: !0
});
ze.config = void 0;
var ba = {
  barSize: 18,
  crossSize: 18,
  inputSize: 40,
  delay: 150,
  defaultColor: "rgba(175, 51, 242, 1)",
  defaultGradient: "linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(9,9,121,1) 35%, rgba(0,212,255,1) 100%)"
};
ze.config = ba;
var tt = {}, Wr = { exports: {} };
(function(e) {
  (function(t) {
    var a = /^\s+/, v = /\s+$/, p = 0, S = t.round, j = t.min, E = t.max, z = t.random;
    function w(l, g) {
      if (l = l || "", g = g || {}, l instanceof w)
        return l;
      if (!(this instanceof w))
        return new w(l, g);
      var c = P(l);
      this._originalInput = l, this._r = c.r, this._g = c.g, this._b = c.b, this._a = c.a, this._roundA = S(100 * this._a) / 100, this._format = g.format || c.format, this._gradientType = g.gradientType, this._r < 1 && (this._r = S(this._r)), this._g < 1 && (this._g = S(this._g)), this._b < 1 && (this._b = S(this._b)), this._ok = c.ok, this._tc_id = p++;
    }
    w.prototype = {
      isDark: function() {
        return this.getBrightness() < 128;
      },
      isLight: function() {
        return !this.isDark();
      },
      isValid: function() {
        return this._ok;
      },
      getOriginalInput: function() {
        return this._originalInput;
      },
      getFormat: function() {
        return this._format;
      },
      getAlpha: function() {
        return this._a;
      },
      getBrightness: function() {
        var l = this.toRgb();
        return (l.r * 299 + l.g * 587 + l.b * 114) / 1e3;
      },
      getLuminance: function() {
        var l = this.toRgb(), g, c, B, H, k, V;
        return g = l.r / 255, c = l.g / 255, B = l.b / 255, g <= 0.03928 ? H = g / 12.92 : H = t.pow((g + 0.055) / 1.055, 2.4), c <= 0.03928 ? k = c / 12.92 : k = t.pow((c + 0.055) / 1.055, 2.4), B <= 0.03928 ? V = B / 12.92 : V = t.pow((B + 0.055) / 1.055, 2.4), 0.2126 * H + 0.7152 * k + 0.0722 * V;
      },
      setAlpha: function(l) {
        return this._a = q(l), this._roundA = S(100 * this._a) / 100, this;
      },
      toHsv: function() {
        var l = A(this._r, this._g, this._b);
        return { h: l.h * 360, s: l.s, v: l.v, a: this._a };
      },
      toHsvString: function() {
        var l = A(this._r, this._g, this._b), g = S(l.h * 360), c = S(l.s * 100), B = S(l.v * 100);
        return this._a == 1 ? "hsv(" + g + ", " + c + "%, " + B + "%)" : "hsva(" + g + ", " + c + "%, " + B + "%, " + this._roundA + ")";
      },
      toHsl: function() {
        var l = I(this._r, this._g, this._b);
        return { h: l.h * 360, s: l.s, l: l.l, a: this._a };
      },
      toHslString: function() {
        var l = I(this._r, this._g, this._b), g = S(l.h * 360), c = S(l.s * 100), B = S(l.l * 100);
        return this._a == 1 ? "hsl(" + g + ", " + c + "%, " + B + "%)" : "hsla(" + g + ", " + c + "%, " + B + "%, " + this._roundA + ")";
      },
      toHex: function(l) {
        return R(this._r, this._g, this._b, l);
      },
      toHexString: function(l) {
        return "#" + this.toHex(l);
      },
      toHex8: function(l) {
        return X(this._r, this._g, this._b, this._a, l);
      },
      toHex8String: function(l) {
        return "#" + this.toHex8(l);
      },
      toRgb: function() {
        return { r: S(this._r), g: S(this._g), b: S(this._b), a: this._a };
      },
      toRgbString: function() {
        return this._a == 1 ? "rgb(" + S(this._r) + ", " + S(this._g) + ", " + S(this._b) + ")" : "rgba(" + S(this._r) + ", " + S(this._g) + ", " + S(this._b) + ", " + this._roundA + ")";
      },
      toPercentageRgb: function() {
        return { r: S(W(this._r, 255) * 100) + "%", g: S(W(this._g, 255) * 100) + "%", b: S(W(this._b, 255) * 100) + "%", a: this._a };
      },
      toPercentageRgbString: function() {
        return this._a == 1 ? "rgb(" + S(W(this._r, 255) * 100) + "%, " + S(W(this._g, 255) * 100) + "%, " + S(W(this._b, 255) * 100) + "%)" : "rgba(" + S(W(this._r, 255) * 100) + "%, " + S(W(this._g, 255) * 100) + "%, " + S(W(this._b, 255) * 100) + "%, " + this._roundA + ")";
      },
      toName: function() {
        return this._a === 0 ? "transparent" : this._a < 1 ? !1 : O[R(this._r, this._g, this._b, !0)] || !1;
      },
      toFilter: function(l) {
        var g = "#" + Q(this._r, this._g, this._b, this._a), c = g, B = this._gradientType ? "GradientType = 1, " : "";
        if (l) {
          var H = w(l);
          c = "#" + Q(H._r, H._g, H._b, H._a);
        }
        return "progid:DXImageTransform.Microsoft.gradient(" + B + "startColorstr=" + g + ",endColorstr=" + c + ")";
      },
      toString: function(l) {
        var g = !!l;
        l = l || this._format;
        var c = !1, B = this._a < 1 && this._a >= 0, H = !g && B && (l === "hex" || l === "hex6" || l === "hex3" || l === "hex4" || l === "hex8" || l === "name");
        return H ? l === "name" && this._a === 0 ? this.toName() : this.toRgbString() : (l === "rgb" && (c = this.toRgbString()), l === "prgb" && (c = this.toPercentageRgbString()), (l === "hex" || l === "hex6") && (c = this.toHexString()), l === "hex3" && (c = this.toHexString(!0)), l === "hex4" && (c = this.toHex8String(!0)), l === "hex8" && (c = this.toHex8String()), l === "name" && (c = this.toName()), l === "hsl" && (c = this.toHslString()), l === "hsv" && (c = this.toHsvString()), c || this.toHexString());
      },
      clone: function() {
        return w(this.toString());
      },
      _applyModification: function(l, g) {
        var c = l.apply(null, [this].concat([].slice.call(g)));
        return this._r = c._r, this._g = c._g, this._b = c._b, this.setAlpha(c._a), this;
      },
      lighten: function() {
        return this._applyModification(i, arguments);
      },
      brighten: function() {
        return this._applyModification(n, arguments);
      },
      darken: function() {
        return this._applyModification(r, arguments);
      },
      desaturate: function() {
        return this._applyModification(U, arguments);
      },
      saturate: function() {
        return this._applyModification(b, arguments);
      },
      greyscale: function() {
        return this._applyModification(C, arguments);
      },
      spin: function() {
        return this._applyModification(o, arguments);
      },
      _applyCombination: function(l, g) {
        return l.apply(null, [this].concat([].slice.call(g)));
      },
      analogous: function() {
        return this._applyCombination(d, arguments);
      },
      complement: function() {
        return this._applyCombination(s, arguments);
      },
      monochromatic: function() {
        return this._applyCombination(u, arguments);
      },
      splitcomplement: function() {
        return this._applyCombination(_, arguments);
      },
      triad: function() {
        return this._applyCombination(x, arguments);
      },
      tetrad: function() {
        return this._applyCombination(f, arguments);
      }
    }, w.fromRatio = function(l, g) {
      if (typeof l == "object") {
        var c = {};
        for (var B in l)
          l.hasOwnProperty(B) && (B === "a" ? c[B] = l[B] : c[B] = Y(l[B]));
        l = c;
      }
      return w(l, g);
    };
    function P(l) {
      var g = { r: 0, g: 0, b: 0 }, c = 1, B = null, H = null, k = null, V = !1, ie = !1;
      return typeof l == "string" && (l = te(l)), typeof l == "object" && (N(l.r) && N(l.g) && N(l.b) ? (g = L(l.r, l.g, l.b), V = !0, ie = String(l.r).substr(-1) === "%" ? "prgb" : "rgb") : N(l.h) && N(l.s) && N(l.v) ? (B = Y(l.s), H = Y(l.v), g = y(l.h, B, H), V = !0, ie = "hsv") : N(l.h) && N(l.s) && N(l.l) && (B = Y(l.s), k = Y(l.l), g = T(l.h, B, k), V = !0, ie = "hsl"), l.hasOwnProperty("a") && (c = l.a)), c = q(c), {
        ok: V,
        format: l.format || ie,
        r: j(255, E(g.r, 0)),
        g: j(255, E(g.g, 0)),
        b: j(255, E(g.b, 0)),
        a: c
      };
    }
    function L(l, g, c) {
      return {
        r: W(l, 255) * 255,
        g: W(g, 255) * 255,
        b: W(c, 255) * 255
      };
    }
    function I(l, g, c) {
      l = W(l, 255), g = W(g, 255), c = W(c, 255);
      var B = E(l, g, c), H = j(l, g, c), k, V, ie = (B + H) / 2;
      if (B == H)
        k = V = 0;
      else {
        var re = B - H;
        switch (V = ie > 0.5 ? re / (2 - B - H) : re / (B + H), B) {
          case l:
            k = (g - c) / re + (g < c ? 6 : 0);
            break;
          case g:
            k = (c - l) / re + 2;
            break;
          case c:
            k = (l - g) / re + 4;
            break;
        }
        k /= 6;
      }
      return { h: k, s: V, l: ie };
    }
    function T(l, g, c) {
      var B, H, k;
      l = W(l, 360), g = W(g, 100), c = W(c, 100);
      function V(ce, he, F) {
        return F < 0 && (F += 1), F > 1 && (F -= 1), F < 1 / 6 ? ce + (he - ce) * 6 * F : F < 1 / 2 ? he : F < 2 / 3 ? ce + (he - ce) * (2 / 3 - F) * 6 : ce;
      }
      if (g === 0)
        B = H = k = c;
      else {
        var ie = c < 0.5 ? c * (1 + g) : c + g - c * g, re = 2 * c - ie;
        B = V(re, ie, l + 1 / 3), H = V(re, ie, l), k = V(re, ie, l - 1 / 3);
      }
      return { r: B * 255, g: H * 255, b: k * 255 };
    }
    function A(l, g, c) {
      l = W(l, 255), g = W(g, 255), c = W(c, 255);
      var B = E(l, g, c), H = j(l, g, c), k, V, ie = B, re = B - H;
      if (V = B === 0 ? 0 : re / B, B == H)
        k = 0;
      else {
        switch (B) {
          case l:
            k = (g - c) / re + (g < c ? 6 : 0);
            break;
          case g:
            k = (c - l) / re + 2;
            break;
          case c:
            k = (l - g) / re + 4;
            break;
        }
        k /= 6;
      }
      return { h: k, s: V, v: ie };
    }
    function y(l, g, c) {
      l = W(l, 360) * 6, g = W(g, 100), c = W(c, 100);
      var B = t.floor(l), H = l - B, k = c * (1 - g), V = c * (1 - H * g), ie = c * (1 - (1 - H) * g), re = B % 6, ce = [c, V, k, k, ie, c][re], he = [ie, c, c, V, k, k][re], F = [k, k, ie, c, c, V][re];
      return { r: ce * 255, g: he * 255, b: F * 255 };
    }
    function R(l, g, c, B) {
      var H = [
        D(S(l).toString(16)),
        D(S(g).toString(16)),
        D(S(c).toString(16))
      ];
      return B && H[0].charAt(0) == H[0].charAt(1) && H[1].charAt(0) == H[1].charAt(1) && H[2].charAt(0) == H[2].charAt(1) ? H[0].charAt(0) + H[1].charAt(0) + H[2].charAt(0) : H.join("");
    }
    function X(l, g, c, B, H) {
      var k = [
        D(S(l).toString(16)),
        D(S(g).toString(16)),
        D(S(c).toString(16)),
        D(ee(B))
      ];
      return H && k[0].charAt(0) == k[0].charAt(1) && k[1].charAt(0) == k[1].charAt(1) && k[2].charAt(0) == k[2].charAt(1) && k[3].charAt(0) == k[3].charAt(1) ? k[0].charAt(0) + k[1].charAt(0) + k[2].charAt(0) + k[3].charAt(0) : k.join("");
    }
    function Q(l, g, c, B) {
      var H = [
        D(ee(B)),
        D(S(l).toString(16)),
        D(S(g).toString(16)),
        D(S(c).toString(16))
      ];
      return H.join("");
    }
    w.equals = function(l, g) {
      return !l || !g ? !1 : w(l).toRgbString() == w(g).toRgbString();
    }, w.random = function() {
      return w.fromRatio({
        r: z(),
        g: z(),
        b: z()
      });
    };
    function U(l, g) {
      g = g === 0 ? 0 : g || 10;
      var c = w(l).toHsl();
      return c.s -= g / 100, c.s = Z(c.s), w(c);
    }
    function b(l, g) {
      g = g === 0 ? 0 : g || 10;
      var c = w(l).toHsl();
      return c.s += g / 100, c.s = Z(c.s), w(c);
    }
    function C(l) {
      return w(l).desaturate(100);
    }
    function i(l, g) {
      g = g === 0 ? 0 : g || 10;
      var c = w(l).toHsl();
      return c.l += g / 100, c.l = Z(c.l), w(c);
    }
    function n(l, g) {
      g = g === 0 ? 0 : g || 10;
      var c = w(l).toRgb();
      return c.r = E(0, j(255, c.r - S(255 * -(g / 100)))), c.g = E(0, j(255, c.g - S(255 * -(g / 100)))), c.b = E(0, j(255, c.b - S(255 * -(g / 100)))), w(c);
    }
    function r(l, g) {
      g = g === 0 ? 0 : g || 10;
      var c = w(l).toHsl();
      return c.l -= g / 100, c.l = Z(c.l), w(c);
    }
    function o(l, g) {
      var c = w(l).toHsl(), B = (c.h + g) % 360;
      return c.h = B < 0 ? 360 + B : B, w(c);
    }
    function s(l) {
      var g = w(l).toHsl();
      return g.h = (g.h + 180) % 360, w(g);
    }
    function x(l) {
      var g = w(l).toHsl(), c = g.h;
      return [
        w(l),
        w({ h: (c + 120) % 360, s: g.s, l: g.l }),
        w({ h: (c + 240) % 360, s: g.s, l: g.l })
      ];
    }
    function f(l) {
      var g = w(l).toHsl(), c = g.h;
      return [
        w(l),
        w({ h: (c + 90) % 360, s: g.s, l: g.l }),
        w({ h: (c + 180) % 360, s: g.s, l: g.l }),
        w({ h: (c + 270) % 360, s: g.s, l: g.l })
      ];
    }
    function _(l) {
      var g = w(l).toHsl(), c = g.h;
      return [
        w(l),
        w({ h: (c + 72) % 360, s: g.s, l: g.l }),
        w({ h: (c + 216) % 360, s: g.s, l: g.l })
      ];
    }
    function d(l, g, c) {
      g = g || 6, c = c || 30;
      var B = w(l).toHsl(), H = 360 / c, k = [w(l)];
      for (B.h = (B.h - (H * g >> 1) + 720) % 360; --g; )
        B.h = (B.h + H) % 360, k.push(w(B));
      return k;
    }
    function u(l, g) {
      g = g || 6;
      for (var c = w(l).toHsv(), B = c.h, H = c.s, k = c.v, V = [], ie = 1 / g; g--; )
        V.push(w({ h: B, s: H, v: k })), k = (k + ie) % 1;
      return V;
    }
    w.mix = function(l, g, c) {
      c = c === 0 ? 0 : c || 50;
      var B = w(l).toRgb(), H = w(g).toRgb(), k = c / 100, V = {
        r: (H.r - B.r) * k + B.r,
        g: (H.g - B.g) * k + B.g,
        b: (H.b - B.b) * k + B.b,
        a: (H.a - B.a) * k + B.a
      };
      return w(V);
    }, w.readability = function(l, g) {
      var c = w(l), B = w(g);
      return (t.max(c.getLuminance(), B.getLuminance()) + 0.05) / (t.min(c.getLuminance(), B.getLuminance()) + 0.05);
    }, w.isReadable = function(l, g, c) {
      var B = w.readability(l, g), H, k;
      switch (k = !1, H = fe(c), H.level + H.size) {
        case "AAsmall":
        case "AAAlarge":
          k = B >= 4.5;
          break;
        case "AAlarge":
          k = B >= 3;
          break;
        case "AAAsmall":
          k = B >= 7;
          break;
      }
      return k;
    }, w.mostReadable = function(l, g, c) {
      var B = null, H = 0, k, V, ie, re;
      c = c || {}, V = c.includeFallbackColors, ie = c.level, re = c.size;
      for (var ce = 0; ce < g.length; ce++)
        k = w.readability(l, g[ce]), k > H && (H = k, B = w(g[ce]));
      return w.isReadable(l, B, { level: ie, size: re }) || !V ? B : (c.includeFallbackColors = !1, w.mostReadable(l, ["#fff", "#000"], c));
    };
    var h = w.names = {
      aliceblue: "f0f8ff",
      antiquewhite: "faebd7",
      aqua: "0ff",
      aquamarine: "7fffd4",
      azure: "f0ffff",
      beige: "f5f5dc",
      bisque: "ffe4c4",
      black: "000",
      blanchedalmond: "ffebcd",
      blue: "00f",
      blueviolet: "8a2be2",
      brown: "a52a2a",
      burlywood: "deb887",
      burntsienna: "ea7e5d",
      cadetblue: "5f9ea0",
      chartreuse: "7fff00",
      chocolate: "d2691e",
      coral: "ff7f50",
      cornflowerblue: "6495ed",
      cornsilk: "fff8dc",
      crimson: "dc143c",
      cyan: "0ff",
      darkblue: "00008b",
      darkcyan: "008b8b",
      darkgoldenrod: "b8860b",
      darkgray: "a9a9a9",
      darkgreen: "006400",
      darkgrey: "a9a9a9",
      darkkhaki: "bdb76b",
      darkmagenta: "8b008b",
      darkolivegreen: "556b2f",
      darkorange: "ff8c00",
      darkorchid: "9932cc",
      darkred: "8b0000",
      darksalmon: "e9967a",
      darkseagreen: "8fbc8f",
      darkslateblue: "483d8b",
      darkslategray: "2f4f4f",
      darkslategrey: "2f4f4f",
      darkturquoise: "00ced1",
      darkviolet: "9400d3",
      deeppink: "ff1493",
      deepskyblue: "00bfff",
      dimgray: "696969",
      dimgrey: "696969",
      dodgerblue: "1e90ff",
      firebrick: "b22222",
      floralwhite: "fffaf0",
      forestgreen: "228b22",
      fuchsia: "f0f",
      gainsboro: "dcdcdc",
      ghostwhite: "f8f8ff",
      gold: "ffd700",
      goldenrod: "daa520",
      gray: "808080",
      green: "008000",
      greenyellow: "adff2f",
      grey: "808080",
      honeydew: "f0fff0",
      hotpink: "ff69b4",
      indianred: "cd5c5c",
      indigo: "4b0082",
      ivory: "fffff0",
      khaki: "f0e68c",
      lavender: "e6e6fa",
      lavenderblush: "fff0f5",
      lawngreen: "7cfc00",
      lemonchiffon: "fffacd",
      lightblue: "add8e6",
      lightcoral: "f08080",
      lightcyan: "e0ffff",
      lightgoldenrodyellow: "fafad2",
      lightgray: "d3d3d3",
      lightgreen: "90ee90",
      lightgrey: "d3d3d3",
      lightpink: "ffb6c1",
      lightsalmon: "ffa07a",
      lightseagreen: "20b2aa",
      lightskyblue: "87cefa",
      lightslategray: "789",
      lightslategrey: "789",
      lightsteelblue: "b0c4de",
      lightyellow: "ffffe0",
      lime: "0f0",
      limegreen: "32cd32",
      linen: "faf0e6",
      magenta: "f0f",
      maroon: "800000",
      mediumaquamarine: "66cdaa",
      mediumblue: "0000cd",
      mediumorchid: "ba55d3",
      mediumpurple: "9370db",
      mediumseagreen: "3cb371",
      mediumslateblue: "7b68ee",
      mediumspringgreen: "00fa9a",
      mediumturquoise: "48d1cc",
      mediumvioletred: "c71585",
      midnightblue: "191970",
      mintcream: "f5fffa",
      mistyrose: "ffe4e1",
      moccasin: "ffe4b5",
      navajowhite: "ffdead",
      navy: "000080",
      oldlace: "fdf5e6",
      olive: "808000",
      olivedrab: "6b8e23",
      orange: "ffa500",
      orangered: "ff4500",
      orchid: "da70d6",
      palegoldenrod: "eee8aa",
      palegreen: "98fb98",
      paleturquoise: "afeeee",
      palevioletred: "db7093",
      papayawhip: "ffefd5",
      peachpuff: "ffdab9",
      peru: "cd853f",
      pink: "ffc0cb",
      plum: "dda0dd",
      powderblue: "b0e0e6",
      purple: "800080",
      rebeccapurple: "663399",
      red: "f00",
      rosybrown: "bc8f8f",
      royalblue: "4169e1",
      saddlebrown: "8b4513",
      salmon: "fa8072",
      sandybrown: "f4a460",
      seagreen: "2e8b57",
      seashell: "fff5ee",
      sienna: "a0522d",
      silver: "c0c0c0",
      skyblue: "87ceeb",
      slateblue: "6a5acd",
      slategray: "708090",
      slategrey: "708090",
      snow: "fffafa",
      springgreen: "00ff7f",
      steelblue: "4682b4",
      tan: "d2b48c",
      teal: "008080",
      thistle: "d8bfd8",
      tomato: "ff6347",
      turquoise: "40e0d0",
      violet: "ee82ee",
      wheat: "f5deb3",
      white: "fff",
      whitesmoke: "f5f5f5",
      yellow: "ff0",
      yellowgreen: "9acd32"
    }, O = w.hexNames = M(h);
    function M(l) {
      var g = {};
      for (var c in l)
        l.hasOwnProperty(c) && (g[l[c]] = c);
      return g;
    }
    function q(l) {
      return l = parseFloat(l), (isNaN(l) || l < 0 || l > 1) && (l = 1), l;
    }
    function W(l, g) {
      J(l) && (l = "100%");
      var c = $(l);
      return l = j(g, E(0, parseFloat(l))), c && (l = parseInt(l * g, 10) / 100), t.abs(l - g) < 1e-6 ? 1 : l % g / parseFloat(g);
    }
    function Z(l) {
      return j(1, E(0, l));
    }
    function K(l) {
      return parseInt(l, 16);
    }
    function J(l) {
      return typeof l == "string" && l.indexOf(".") != -1 && parseFloat(l) === 1;
    }
    function $(l) {
      return typeof l == "string" && l.indexOf("%") != -1;
    }
    function D(l) {
      return l.length == 1 ? "0" + l : "" + l;
    }
    function Y(l) {
      return l <= 1 && (l = l * 100 + "%"), l;
    }
    function ee(l) {
      return t.round(parseFloat(l) * 255).toString(16);
    }
    function ne(l) {
      return K(l) / 255;
    }
    var ae = function() {
      var l = "[-\\+]?\\d+%?", g = "[-\\+]?\\d*\\.\\d+%?", c = "(?:" + g + ")|(?:" + l + ")", B = "[\\s|\\(]+(" + c + ")[,|\\s]+(" + c + ")[,|\\s]+(" + c + ")\\s*\\)?", H = "[\\s|\\(]+(" + c + ")[,|\\s]+(" + c + ")[,|\\s]+(" + c + ")[,|\\s]+(" + c + ")\\s*\\)?";
      return {
        CSS_UNIT: new RegExp(c),
        rgb: new RegExp("rgb" + B),
        rgba: new RegExp("rgba" + H),
        hsl: new RegExp("hsl" + B),
        hsla: new RegExp("hsla" + H),
        hsv: new RegExp("hsv" + B),
        hsva: new RegExp("hsva" + H),
        hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
        hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
      };
    }();
    function N(l) {
      return !!ae.CSS_UNIT.exec(l);
    }
    function te(l) {
      l = l.replace(a, "").replace(v, "").toLowerCase();
      var g = !1;
      if (h[l])
        l = h[l], g = !0;
      else if (l == "transparent")
        return { r: 0, g: 0, b: 0, a: 0, format: "name" };
      var c;
      return (c = ae.rgb.exec(l)) ? { r: c[1], g: c[2], b: c[3] } : (c = ae.rgba.exec(l)) ? { r: c[1], g: c[2], b: c[3], a: c[4] } : (c = ae.hsl.exec(l)) ? { h: c[1], s: c[2], l: c[3] } : (c = ae.hsla.exec(l)) ? { h: c[1], s: c[2], l: c[3], a: c[4] } : (c = ae.hsv.exec(l)) ? { h: c[1], s: c[2], v: c[3] } : (c = ae.hsva.exec(l)) ? { h: c[1], s: c[2], v: c[3], a: c[4] } : (c = ae.hex8.exec(l)) ? {
        r: K(c[1]),
        g: K(c[2]),
        b: K(c[3]),
        a: ne(c[4]),
        format: g ? "name" : "hex8"
      } : (c = ae.hex6.exec(l)) ? {
        r: K(c[1]),
        g: K(c[2]),
        b: K(c[3]),
        format: g ? "name" : "hex"
      } : (c = ae.hex4.exec(l)) ? {
        r: K(c[1] + "" + c[1]),
        g: K(c[2] + "" + c[2]),
        b: K(c[3] + "" + c[3]),
        a: ne(c[4] + "" + c[4]),
        format: g ? "name" : "hex8"
      } : (c = ae.hex3.exec(l)) ? {
        r: K(c[1] + "" + c[1]),
        g: K(c[2] + "" + c[2]),
        b: K(c[3] + "" + c[3]),
        format: g ? "name" : "hex"
      } : !1;
    }
    function fe(l) {
      var g, c;
      return l = l || { level: "AA", size: "small" }, g = (l.level || "AA").toUpperCase(), c = (l.size || "small").toLowerCase(), g !== "AA" && g !== "AAA" && (g = "AA"), c !== "small" && c !== "large" && (c = "small"), { level: g, size: c };
    }
    e.exports ? e.exports = w : window.tinycolor = w;
  })(Math);
})(Wr);
var Fe = Wr.exports, wr;
function wa() {
  if (wr)
    return tt;
  wr = 1, Object.defineProperty(tt, "__esModule", {
    value: !0
  }), tt.gradientParser = void 0;
  var e = Xe(), t = dt();
  function a(b) {
    "@babel/helpers - typeof";
    return a = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(C) {
      return typeof C;
    } : function(C) {
      return C && typeof Symbol == "function" && C.constructor === Symbol && C !== Symbol.prototype ? "symbol" : typeof C;
    }, a(b);
  }
  function v(b) {
    return j(b) || S(b) || w(b) || p();
  }
  function p() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function S(b) {
    if (typeof Symbol < "u" && b[Symbol.iterator] != null || b["@@iterator"] != null)
      return Array.from(b);
  }
  function j(b) {
    if (Array.isArray(b))
      return P(b);
  }
  function E(b, C) {
    return I(b) || L(b, C) || w(b, C) || z();
  }
  function z() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function w(b, C) {
    if (b) {
      if (typeof b == "string")
        return P(b, C);
      var i = Object.prototype.toString.call(b).slice(8, -1);
      if (i === "Object" && b.constructor && (i = b.constructor.name), i === "Map" || i === "Set")
        return Array.from(b);
      if (i === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i))
        return P(b, C);
    }
  }
  function P(b, C) {
    (C == null || C > b.length) && (C = b.length);
    for (var i = 0, n = new Array(C); i < C; i++)
      n[i] = b[i];
    return n;
  }
  function L(b, C) {
    var i = b == null ? null : typeof Symbol < "u" && b[Symbol.iterator] || b["@@iterator"];
    if (i != null) {
      var n, r, o, s, x = [], f = !0, _ = !1;
      try {
        if (o = (i = i.call(b)).next, C === 0) {
          if (Object(i) !== i)
            return;
          f = !1;
        } else
          for (; !(f = (n = o.call(i)).done) && (x.push(n.value), x.length !== C); f = !0)
            ;
      } catch (d) {
        _ = !0, r = d;
      } finally {
        try {
          if (!f && i.return != null && (s = i.return(), Object(s) !== s))
            return;
        } finally {
          if (_)
            throw r;
        }
      }
      return x;
    }
  }
  function I(b) {
    if (Array.isArray(b))
      return b;
  }
  function T(b, C) {
    var i = Object.keys(b);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(b);
      C && (n = n.filter(function(r) {
        return Object.getOwnPropertyDescriptor(b, r).enumerable;
      })), i.push.apply(i, n);
    }
    return i;
  }
  function A(b) {
    for (var C = 1; C < arguments.length; C++) {
      var i = arguments[C] != null ? arguments[C] : {};
      C % 2 ? T(Object(i), !0).forEach(function(n) {
        y(b, n, i[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(b, Object.getOwnPropertyDescriptors(i)) : T(Object(i)).forEach(function(n) {
        Object.defineProperty(b, n, Object.getOwnPropertyDescriptor(i, n));
      });
    }
    return b;
  }
  function y(b, C, i) {
    return C = R(C), C in b ? Object.defineProperty(b, C, { value: i, enumerable: !0, configurable: !0, writable: !0 }) : b[C] = i, b;
  }
  function R(b) {
    var C = X(b, "string");
    return a(C) === "symbol" ? C : String(C);
  }
  function X(b, C) {
    if (a(b) !== "object" || b === null)
      return b;
    var i = b[Symbol.toPrimitive];
    if (i !== void 0) {
      var n = i.call(b, C || "default");
      if (a(n) !== "object")
        return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (C === "string" ? String : Number)(b);
  }
  var Q = Fe, U = function() {
    var C = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", i = {
      linearGradient: /^(-(webkit|o|ms|moz)-)?(linear-gradient)/i,
      repeatingLinearGradient: /^(-(webkit|o|ms|moz)-)?(repeating-linear-gradient)/i,
      radialGradient: /^(-(webkit|o|ms|moz)-)?(radial-gradient)/i,
      repeatingRadialGradient: /^(-(webkit|o|ms|moz)-)?(repeating-radial-gradient)/i,
      sideOrCorner: /^to (left (top|bottom)|right (top|bottom)|top (left|right)|bottom (left|right)|left|right|top|bottom)/i,
      extentKeywords: /^(closest-side|closest-corner|farthest-side|farthest-corner|contain|cover)/,
      positionKeywords: /^(left|center|right|top|bottom)/i,
      pixelValue: /^(-?(([0-9]*\.[0-9]+)|([0-9]+\.?)))px/,
      percentageValue: /^(-?(([0-9]*\.[0-9]+)|([0-9]+\.?)))%/,
      emValue: /^(-?(([0-9]*\.[0-9]+)|([0-9]+\.?)))em/,
      angleValue: /^(-?(([0-9]*\.[0-9]+)|([0-9]+\.?)))deg/,
      startCall: /^\(/,
      endCall: /^\)/,
      comma: /^,/,
      hexColor: /^#([0-9a-fA-F]+)/,
      literalColor: /^([a-zA-Z]+)/,
      rgbColor: /^rgb/i,
      spacedRgbColor: /^(\d{1,3})\s+(\d{1,3})\s+(\d{1,3})\s+\/\s+([0-1](\.\d+)?)/,
      rgbaColor: /^rgba/i,
      hslColor: /^hsl/i,
      hsvColor: /^hsv/i,
      number: /^(([0-9]*\.[0-9]+)|([0-9]+\.?))/
    };
    function n(F) {
      var G = new Error(C + ": " + F);
      throw G.source = C, G;
    }
    function r() {
      var F, G = o();
      C.length > 0 && n("Invalid input not EOF");
      var oe = G[0], le = oe == null || (F = oe.colorStops) === null || F === void 0 ? void 0 : F.filter(function(ge) {
        return (0, t.isUpperCase)(ge.value);
      }).length, se = function() {
        if (le > 0)
          return oe;
        var ye = function(_e, We) {
          return We === 0 ? (0, e.high)(_e) : (0, e.low)(_e);
        };
        return A(A({}, oe), {}, {
          colorStops: oe.colorStops.map(function(xe, _e) {
            return A(A({}, xe), {}, {
              value: ye(xe, _e)
            });
          })
        });
      };
      return se();
    }
    function o() {
      return $(s);
    }
    function s() {
      return x("linear-gradient", i.linearGradient, _) || x("repeating-linear-gradient", i.repeatingLinearGradient, _) || x("radial-gradient", i.radialGradient, h) || x("repeating-radial-gradient", i.repeatingRadialGradient, h);
    }
    function x(F, G, oe) {
      return f(G, function(le) {
        var se = oe();
        return se && (ce(i.comma) || n("Missing comma before color stops")), {
          type: F,
          orientation: se,
          colorStops: $(D)
        };
      });
    }
    function f(F, G) {
      var oe = ce(F);
      if (oe) {
        ce(i.startCall) || n("Missing (");
        var le = G(oe);
        return ce(i.endCall) || n("Missing )"), le;
      }
    }
    function _() {
      return d() || u();
    }
    function d() {
      return re("directional", i.sideOrCorner, 1);
    }
    function u() {
      return re("angular", i.angleValue, 1);
    }
    function h() {
      var F, G = O(), oe;
      return G && (F = [], F.push(G), oe = C, ce(i.comma) && (G = O(), G ? F.push(G) : C = oe)), F;
    }
    function O() {
      var F = M() || q();
      if (F)
        F.at = Z();
      else {
        var G = W();
        if (G) {
          F = G;
          var oe = Z();
          oe && (F.at = oe);
        } else {
          var le = K();
          le && (F = {
            type: "default-radial",
            at: le
          });
        }
      }
      return F;
    }
    function M() {
      var F = re("shape", /^(circle)/i, 0);
      return F && (F.style = ie() || W()), F;
    }
    function q() {
      var F = re("shape", /^(ellipse)/i, 0);
      return F && (F.style = k() || W()), F;
    }
    function W() {
      return re("extent-keyword", i.extentKeywords, 1);
    }
    function Z() {
      if (re("position", /^at/, 0)) {
        var F = K();
        return F || n("Missing positioning value"), F;
      }
    }
    function K() {
      var F = J();
      if (F.x || F.y)
        return {
          type: "position",
          value: F
        };
    }
    function J() {
      return {
        x: k(),
        y: k()
      };
    }
    function $(F) {
      var G = F(), oe = [];
      if (G)
        for (oe.push(G); ce(i.comma); )
          G = F(), G ? oe.push(G) : n("One extra comma");
      return oe;
    }
    function D() {
      var F, G = Y();
      return G || n("Expected color definition"), G.left = parseInt((F = k()) === null || F === void 0 ? void 0 : F.value), G;
    }
    function Y() {
      return ne() || N() || B() || g() || ee() || fe();
    }
    function ee() {
      var F = re("literal", i.literalColor, 0);
      if (F != null && F.value) {
        var G = Q(F == null ? void 0 : F.value).toRgb(), oe = G.r, le = G.g, se = G.b, ge = G.a;
        return {
          value: "rgba(".concat(oe, ", ").concat(le, ", ").concat(se, ", ").concat(ge, ")")
        };
      }
    }
    function ne() {
      var F = re("hex", i.hexColor, 1);
      if (F != null && F.value) {
        var G = Q(F == null ? void 0 : F.value).toRgb(), oe = G.r, le = G.g, se = G.b, ge = G.a;
        return {
          value: "rgba(".concat(oe, ", ").concat(le, ", ").concat(se, ", ").concat(ge, ")")
        };
      }
    }
    var ae = function(G) {
      var oe = (0, t.isUpperCase)(G == null ? void 0 : G[0]), le = $(H), se = Q({
        h: le[0],
        s: le[1],
        l: le[2],
        a: le[3] || 1
      }).toRgb(), ge = se.r, ye = se.g, xe = se.b, _e = se.a;
      return {
        value: "".concat(oe ? "RGBA" : "rgba", "(").concat(ge, ", ").concat(ye, ", ").concat(xe, ", ").concat(_e, ")")
      };
    };
    function N() {
      return f(i.hslColor, ae);
    }
    var te = function(G) {
      var oe = (0, t.isUpperCase)(G == null ? void 0 : G[0]), le = $(H), se = Q({
        h: le[0],
        s: le[1],
        v: le[2],
        a: le[3] || 1
      }).toRgb(), ge = se.r, ye = se.g, xe = se.b, _e = se.a;
      return {
        value: "".concat(oe ? "RGBA" : "rgba", "(").concat(ge, ", ").concat(ye, ", ").concat(xe, ", ").concat(_e, ")")
      };
    };
    function fe() {
      return f(i.hsvColor, te);
    }
    var l = function(G) {
      var oe = (0, t.isUpperCase)(G == null ? void 0 : G[0]), le = ce(i.spacedRgbColor), se = le || [null].concat(v($(H))), ge = E(se, 5), ye = ge[1], xe = ge[2], _e = ge[3], We = ge[4], Ge = We === void 0 ? 1 : We;
      return {
        value: "".concat(oe ? "RGBA" : "rgba", "(").concat(ye, ", ").concat(xe, ", ").concat(_e, ", ").concat(Ge, ")")
      };
    };
    function g() {
      return f(i.rgbColor, l);
    }
    var c = function(G) {
      var oe = (0, t.isUpperCase)(G == null ? void 0 : G[0]);
      return {
        value: "".concat(oe ? "RGBA" : "rgba", "(").concat($(H), ")")
      };
    };
    function B() {
      return f(i.rgbaColor, c);
    }
    function H() {
      return ce(i.number)[1];
    }
    function k() {
      return re("%", i.percentageValue, 1) || V() || ie();
    }
    function V() {
      return re("position-keyword", i.positionKeywords, 1);
    }
    function ie() {
      return re("px", i.pixelValue, 1) || re("em", i.emValue, 1);
    }
    function re(F, G, oe) {
      var le = ce(G);
      if (le)
        return {
          type: F,
          value: le[oe]
        };
    }
    function ce(F) {
      var G, oe;
      return oe = /^[\n\r\t\s]+/.exec(C), oe && he(oe[0].length), G = F.exec(C), G && he(G[0].length), G;
    }
    function he(F) {
      C = C.substr(F);
    }
    return r();
  };
  return tt.gradientParser = U, tt;
}
var Sr;
function Xe() {
  if (Sr)
    return Ie;
  Sr = 1, Object.defineProperty(Ie, "__esModule", {
    value: !0
  }), Ie.low = Ie.high = Ie.getColors = Ie.formatInputValues = void 0;
  var e = ze, t = wa();
  e.config.defaultColor;
  var a = e.config.defaultGradient, v = function(w) {
    return w.value.toLowerCase();
  };
  Ie.low = v;
  var p = function(w) {
    return w.value.toUpperCase();
  };
  Ie.high = p;
  var S = function(w) {
    var P = w == null ? void 0 : w.includes("gradient");
    if (P) {
      var L = w == null ? void 0 : w.includes("conic"), I = !L && j() ? w : a;
      L && console.log("Sorry we cant handle conic gradients yet");
      var T = (0, t.gradientParser)(I);
      return T == null ? void 0 : T.colorStops;
    } else {
      var A = w;
      return [{
        value: A
      }];
    }
  };
  Ie.getColors = S;
  var j = function(w) {
    return !0;
  }, E = function(w, P, L) {
    return isNaN(w) || w < P ? P : w > L ? L : w;
  };
  return Ie.formatInputValues = E, Ie;
}
var _r;
function dt() {
  if (_r)
    return Se;
  _r = 1, Object.defineProperty(Se, "__esModule", {
    value: !0
  }), Se.compareGradients = void 0, Se.computePickerPosition = E, Se.computeSquareXY = j, Se.getGradientType = Se.getDegrees = void 0, Se.getHandleValue = S, Se.safeBounds = Se.isUpperCase = Se.getNewHsl = void 0;
  var e = Xe(), t = ze, a = Fe, v = t.config.barSize, p = t.config.crossSize;
  function S(A) {
    var y = L(A), R = y.offsetLeft, X = y.clientWidth, Q = A.clientX - R - v / 2, U = X - 18, b = (0, e.formatInputValues)(Q, 0, U);
    return Math.round(b / (U / 100));
  }
  function j(A, y, R) {
    var X = A[1] * 100, Q = A[2] * 100, U = X * (Q < 50 ? Q : 100 - Q) / 100, b = Math.round(200 * U / (Q + U)) | 0, C = Math.round(U + Q), i = y / 100 * b - p / 2, n = R - R / 100 * C - p / 2;
    return [i, n];
  }
  function E(A) {
    var y = L(A), R = y.offsetLeft, X = y.offsetTop, Q = y.clientWidth, U = y.clientHeight, b = function() {
      var n = A.clientX - R - p / 2;
      return (0, e.formatInputValues)(n, -9, Q - 10);
    }, C = function() {
      var n = A.clientY - X - p / 2;
      return (0, e.formatInputValues)(n, -9, U - 10);
    };
    return [b(), C()];
  }
  var z = function(y) {
    var R, X = y == null ? void 0 : y.split(",")[0];
    return parseInt(X == null || (R = X.split("(")[1]) === null || R === void 0 ? void 0 : R.slice(0, -3));
  };
  Se.getDegrees = z;
  var w = function(y) {
    return y == null ? void 0 : y.split("(")[0];
  };
  Se.getGradientType = w;
  var P = function(y, R, X, Q, U) {
    U(y);
    var b = a({
      h: y,
      s: R,
      l: X
    }), C = b.toRgb(), i = C.r, n = C.g, r = C.b;
    return "rgba(".concat(i, ", ").concat(n, ", ").concat(r, ", ").concat(Q, ")");
  };
  Se.getNewHsl = P;
  var L = function(y) {
    var R = y.target.parentNode.getBoundingClientRect(), X = y.target.className, Q = X === "c-resize ps-rl" ? 15 : 0;
    return {
      offsetLeft: (R == null ? void 0 : R.x) + Q,
      offsetTop: R == null ? void 0 : R.y,
      clientWidth: R == null ? void 0 : R.width,
      clientHeight: R == null ? void 0 : R.height
    };
  };
  Se.safeBounds = L;
  var I = function(y) {
    var R;
    return (y == null ? void 0 : y[0]) === (y == null || (R = y[0]) === null || R === void 0 ? void 0 : R.toUpperCase());
  };
  Se.isUpperCase = I;
  var T = function(y, R) {
    var X, Q, U = y == null || (X = y.toLowerCase()) === null || X === void 0 ? void 0 : X.replaceAll(" ", ""), b = R == null || (Q = R.toLowerCase()) === null || Q === void 0 ? void 0 : Q.replaceAll(" ", "");
    return U === b;
  };
  return Se.compareGradients = T, Se;
}
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = s, e.usePicker = x;
  var t = j(we), a = dt(), v = Xe(), p = ze;
  function S(f) {
    if (typeof WeakMap != "function")
      return null;
    var _ = /* @__PURE__ */ new WeakMap(), d = /* @__PURE__ */ new WeakMap();
    return (S = function(h) {
      return h ? d : _;
    })(f);
  }
  function j(f, _) {
    if (!_ && f && f.__esModule)
      return f;
    if (f === null || E(f) !== "object" && typeof f != "function")
      return { default: f };
    var d = S(_);
    if (d && d.has(f))
      return d.get(f);
    var u = {}, h = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var O in f)
      if (O !== "default" && Object.prototype.hasOwnProperty.call(f, O)) {
        var M = h ? Object.getOwnPropertyDescriptor(f, O) : null;
        M && (M.get || M.set) ? Object.defineProperty(u, O, M) : u[O] = f[O];
      }
    return u.default = f, d && d.set(f, u), u;
  }
  function E(f) {
    "@babel/helpers - typeof";
    return E = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(_) {
      return typeof _;
    } : function(_) {
      return _ && typeof Symbol == "function" && _.constructor === Symbol && _ !== Symbol.prototype ? "symbol" : typeof _;
    }, E(f);
  }
  function z(f) {
    return L(f) || P(f) || A(f) || w();
  }
  function w() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function P(f) {
    if (typeof Symbol < "u" && f[Symbol.iterator] != null || f["@@iterator"] != null)
      return Array.from(f);
  }
  function L(f) {
    if (Array.isArray(f))
      return y(f);
  }
  function I(f, _) {
    return X(f) || R(f, _) || A(f, _) || T();
  }
  function T() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function A(f, _) {
    if (f) {
      if (typeof f == "string")
        return y(f, _);
      var d = Object.prototype.toString.call(f).slice(8, -1);
      if (d === "Object" && f.constructor && (d = f.constructor.name), d === "Map" || d === "Set")
        return Array.from(f);
      if (d === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(d))
        return y(f, _);
    }
  }
  function y(f, _) {
    (_ == null || _ > f.length) && (_ = f.length);
    for (var d = 0, u = new Array(_); d < _; d++)
      u[d] = f[d];
    return u;
  }
  function R(f, _) {
    var d = f == null ? null : typeof Symbol < "u" && f[Symbol.iterator] || f["@@iterator"];
    if (d != null) {
      var u, h, O, M, q = [], W = !0, Z = !1;
      try {
        if (O = (d = d.call(f)).next, _ === 0) {
          if (Object(d) !== d)
            return;
          W = !1;
        } else
          for (; !(W = (u = O.call(d)).done) && (q.push(u.value), q.length !== _); W = !0)
            ;
      } catch (K) {
        Z = !0, h = K;
      } finally {
        try {
          if (!W && d.return != null && (M = d.return(), Object(M) !== M))
            return;
        } finally {
          if (Z)
            throw h;
        }
      }
      return q;
    }
  }
  function X(f) {
    if (Array.isArray(f))
      return f;
  }
  function Q(f, _) {
    var d = Object.keys(f);
    if (Object.getOwnPropertySymbols) {
      var u = Object.getOwnPropertySymbols(f);
      _ && (u = u.filter(function(h) {
        return Object.getOwnPropertyDescriptor(f, h).enumerable;
      })), d.push.apply(d, u);
    }
    return d;
  }
  function U(f) {
    for (var _ = 1; _ < arguments.length; _++) {
      var d = arguments[_] != null ? arguments[_] : {};
      _ % 2 ? Q(Object(d), !0).forEach(function(u) {
        b(f, u, d[u]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(f, Object.getOwnPropertyDescriptors(d)) : Q(Object(d)).forEach(function(u) {
        Object.defineProperty(f, u, Object.getOwnPropertyDescriptor(d, u));
      });
    }
    return f;
  }
  function b(f, _, d) {
    return _ = C(_), _ in f ? Object.defineProperty(f, _, { value: d, enumerable: !0, configurable: !0, writable: !0 }) : f[_] = d, f;
  }
  function C(f) {
    var _ = i(f, "string");
    return E(_) === "symbol" ? _ : String(_);
  }
  function i(f, _) {
    if (E(f) !== "object" || f === null)
      return f;
    var d = f[Symbol.toPrimitive];
    if (d !== void 0) {
      var u = d.call(f, _ || "default");
      if (E(u) !== "object")
        return u;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (_ === "string" ? String : Number)(f);
  }
  var n = Fe, r = p.config.crossSize, o = /* @__PURE__ */ (0, t.createContext)();
  function s(f) {
    var _ = f.children, d = f.bounds, u = f.value, h = f.onChange, O = f.squareSize, M = f.squareHeight, q = f.hideOpacity, W = d == null ? void 0 : d.x, Z = u == null ? void 0 : u.includes("gradient"), K = (0, a.getGradientType)(u), J = (0, a.getDegrees)(u), $ = K === "linear-gradient" ? "".concat(J, "deg") : "circle", D = (0, v.getColors)(u), Y = D == null ? void 0 : D.map(function(Oe, ve) {
      return U(U({}, Oe), {}, {
        index: ve
      });
    }), ee = (Y == null ? void 0 : Y.filter(function(Oe) {
      return (0, a.isUpperCase)(Oe.value);
    })[0]) || Y[0], ne = ee == null ? void 0 : ee.value, ae = ee == null ? void 0 : ee.index, N = ee == null ? void 0 : ee.left, te = (0, t.useState)(n(ne)), fe = I(te, 2), l = fe[0], g = fe[1], c = (0, t.useState)("rgb"), B = I(c, 2), H = B[0], k = B[1], V = l.toRgb(), ie = V.r, re = V.g, ce = V.b, he = V.a, F = l.toHsl(), G = F.h, oe = F.s, le = F.l, se = l.toHsv(), ge = se.s, ye = se.v, xe = (0, t.useState)(Math.round(G)), _e = I(xe, 2), We = _e[0], Ge = _e[1], pt = Math.round(G), an = (0, a.computeSquareXY)([pt, oe, le], O, M), er = I(an, 2), on = er[0], ln = er[1], un = (0, t.useState)([]), tr = I(un, 2), vt = tr[0], cn = tr[1], sn = (0, t.useState)([]), rr = I(sn, 2), Je = rr[0], fn = rr[1], dn = (0, t.useState)(null), nr = I(dn, 2), ar = nr[0], Qe = nr[1], kt = function(ve) {
      ve !== u && (Z ? (0, a.compareGradients)(Je[0], u) || fn([u].concat(z(Je == null ? void 0 : Je.slice(0, 8)))) : cn([u].concat(z(vt == null ? void 0 : vt.slice(0, 8)))), h(ve));
    };
    (0, t.useEffect)(function() {
      g(n(ne)), Ge(pt);
    }, [ne, pt]);
    var ht = function(ve) {
      var me = ve.sort(function(be, De) {
        return be.left - De.left;
      }), pe = me == null ? void 0 : me.map(function(be) {
        return "".concat(be == null ? void 0 : be.value, " ").concat(be.left, "%");
      });
      kt("".concat(K, "(").concat($, ", ").concat(pe.join(", "), ")"));
    }, ir = function(ve) {
      var me = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : N, pe = D == null ? void 0 : D.filter(function(De) {
        return !(0, a.isUpperCase)(De.value);
      }), be = [{
        value: ve.toUpperCase(),
        left: me
      }].concat(z(pe));
      ht(be);
    }, gt = function(ve) {
      Z ? ir(ve) : kt(ve);
    }, pn = function(ve) {
      var me = (0, a.getHandleValue)(ve) / 100, pe = "rgba(".concat(ie, ", ").concat(re, ", ").concat(ce, ", ").concat(me, ")");
      gt(pe);
    }, vn = function(ve) {
      var me = (0, a.getHandleValue)(ve) * 3.6, pe = (0, a.getNewHsl)(me, oe, le, he, Ge);
      gt(pe);
    }, hn = function(ve, me) {
      var pe = (0, a.computePickerPosition)(ve, M), be = I(pe, 2), De = be[0], jt = be[1], wn = Math.min(De + r / 2, O - 1), Sn = Math.min(jt + r / 2, M - 1), Tt = I(me.getImageData(wn, Sn, 1, 1).data, 3), _n = Tt[0], xn = Tt[1], On = Tt[2], Pn = "rgba(".concat(_n, ", ").concat(xn, ", ").concat(On, ", ").concat(he, ")");
      gt(Pn);
    }, or = function(ve) {
      var me = D == null ? void 0 : D.map(function(pe, be) {
        return U(U({}, pe), {}, {
          value: be === ve ? (0, v.high)(pe) : (0, v.low)(pe)
        });
      });
      ht(me);
    }, gn = function(ve) {
      var me, pe = (0, a.getHandleValue)(ve, W), be = (me = [].concat(z(D.map(function(De) {
        return U(U({}, De), {}, {
          value: (0, v.low)(De)
        });
      })), [{
        value: ne,
        left: pe
      }])) === null || me === void 0 ? void 0 : me.sort(function(De, jt) {
        return De.left - jt.left;
      });
      ht(be);
    }, yn = function() {
      if ((D == null ? void 0 : D.length) > 2) {
        var ve = D == null ? void 0 : D.map(function(pe, be) {
          return U(U({}, pe), {}, {
            value: be === ae - 1 ? (0, v.high)(pe) : (0, v.low)(pe)
          });
        }), me = ve == null ? void 0 : ve.filter(function(pe, be) {
          return be !== ae;
        });
        ht(me);
      }
    }, mn = function() {
      ae !== (D == null ? void 0 : D.length) - 1 && or(ae + 1);
    };
    (0, t.useEffect)(function() {
      return window.addEventListener("click", lr), function() {
        window.removeEventListener("click", lr);
      };
    }, [ar, u]);
    var lr = function(ve) {
      var me, pe = ve == null || (me = ve.path) === null || me === void 0 ? void 0 : me.map(function(be) {
        return be.id;
      });
      pe != null && pe.includes("gradient-bar") ? Qe("gpoint") : pe != null && pe.includes("rbgcp-input") ? Qe("input") : pe != null && pe.includes("rbgcp-wrapper") ? Qe("picker") : Qe(null);
    }, bn = {
      x: on,
      y: ln,
      s: oe,
      l: le,
      r: ie,
      g: re,
      b: ce,
      hue: pt,
      hsvS: ge,
      hsvV: ye,
      value: u,
      colors: D,
      degrees: J,
      inFocus: ar,
      opacity: he,
      onChange: h,
      addPoint: gn,
      inputType: H,
      nextPoint: mn,
      tinyColor: l,
      handleHue: vn,
      setInFocus: Qe,
      isGradient: Z,
      offsetLeft: W,
      squareSize: O,
      hideOpacity: q,
      handleColor: hn,
      currentLeft: N,
      deletePoint: yn,
      internalHue: We,
      squareHeight: M,
      setInputType: k,
      gradientType: K,
      handleChange: gt,
      currentColor: ne,
      selectedColor: ae,
      handleOpacity: pn,
      setInternalHue: Ge,
      previousColors: vt,
      handleGradient: ir,
      setSelectedColor: or,
      internalOnChange: kt,
      previousGraidents: Je
    };
    return /* @__PURE__ */ t.default.createElement(o.Provider, {
      value: bn
    }, _);
  }
  function x() {
    return (0, t.useContext)(o);
  }
})(Te);
var Br = {}, Lr = {}, Xt = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.usePaintSat = e.usePaintLight = e.usePaintBright = e.default = void 0;
  var t = we, a = Fe, v = function(w, P) {
    (0, t.useEffect)(function() {
      var L, I = w == null || (L = w.current) === null || L === void 0 ? void 0 : L.getContext("2d", {
        willReadFrequently: !0
      });
      I.rect(0, 0, P, 14);
      for (var T = I.createLinearGradient(0, 0, P, 0), A = 0; A <= 360; A += 30)
        T.addColorStop(A / 360, "hsl(".concat(A, ", 100%, 50%)"));
      I.fillStyle = T, I.fill();
    }, [w, P]);
  }, p = v;
  e.default = p;
  var S = function(w, P, L, I) {
    (0, t.useEffect)(function() {
      var T, A = w == null || (T = w.current) === null || T === void 0 ? void 0 : T.getContext("2d", {
        willReadFrequently: !0
      });
      if (A) {
        A.rect(0, 0, I, 14);
        for (var y = A.createLinearGradient(0, 0, I, 0), R = 0; R <= 100; R += 10)
          y.addColorStop(R / 100, "hsl(".concat(P, ", ").concat(R, "%, ").concat(L, "%)"));
        A.fillStyle = y, A.fill();
      }
    }, [w, P, L, I]);
  };
  e.usePaintSat = S;
  var j = function(w, P, L, I) {
    (0, t.useEffect)(function() {
      var T, A = w == null || (T = w.current) === null || T === void 0 ? void 0 : T.getContext("2d", {
        willReadFrequently: !0
      });
      if (A) {
        A.rect(0, 0, I, 14);
        for (var y = A.createLinearGradient(0, 0, I, 0), R = 0; R <= 100; R += 10)
          y.addColorStop(R / 100, "hsl(".concat(P, ", ").concat(L, "%, ").concat(R, "%)"));
        A.fillStyle = y, A.fill();
      }
    }, [w, P, L, I]);
  };
  e.usePaintLight = j;
  var E = function(w, P, L, I) {
    (0, t.useEffect)(function() {
      var T, A = w == null || (T = w.current) === null || T === void 0 ? void 0 : T.getContext("2d", {
        willReadFrequently: !0
      });
      if (A) {
        A.rect(0, 0, I, 14);
        for (var y = A.createLinearGradient(0, 0, I, 0), R = 0; R <= 100; R += 10) {
          var X = a({
            h: P,
            s: L,
            v: R
          });
          y.addColorStop(R / 100, X.toHslString());
        }
        A.fillStyle = y, A.fill();
      }
    }, [w, P, L, I]);
  };
  e.usePaintBright = E;
})(Xt);
var ue = {};
Object.defineProperty(ue, "__esModule", {
  value: !0
});
ue.psRl = ue.opacityOverlay = ue.npe = ue.jsb = ue.jfe = ue.jc = ue.inputWrap = ue.inputLabel = ue.inputDropdown = ue.input = ue.handle = ue.gradientHandleWrap = ue.gradientHandle = ue.df = ue.degreeInput = ue.controlBtnsWrap = ue.controlBtn = ue.checkered = ue.canvasWrapper = ue.cResize = ue.cCross = ue.borderBox = ue.ac = void 0;
var Sa = {
  display: "flex"
};
ue.df = Sa;
var _a = {
  alignItems: "center"
};
ue.ac = _a;
var xa = {
  justifyContent: "center"
};
ue.jc = xa;
var Oa = {
  justifyContent: "flex-end"
};
ue.jfe = Oa;
var Pa = {
  justifyContent: "space-between"
};
ue.jsb = Pa;
var Ca = {
  position: "relative"
};
ue.psRl = Ca;
var Aa = {
  cursor: "crosshair"
};
ue.cCross = Aa;
var Ea = {
  borderRadius: 6,
  overflow: "hidden",
  height: 294
};
ue.canvasWrapper = Ea;
var ka = {
  cursor: "ew-resize"
};
ue.cResize = ka;
var ja = {
  position: "absolute",
  left: 0,
  top: 0,
  width: "100%",
  height: "100%",
  borderRadius: 10
};
ue.opacityOverlay = ja;
var Ta = {
  boxSizing: "border-box"
};
ue.borderBox = Ta;
var Ia = {
  position: "absolute",
  border: "2px solid white",
  borderRadius: "50%",
  boxShadow: "0px 0px 3px rgba(0,0,0,.5)",
  width: 18,
  height: 18,
  zIndex: 1e3,
  transition: "all 10ms linear",
  boxSizing: "border-box"
};
ue.handle = Ia;
var Ra = {
  position: "absolute",
  zIndex: 1e4,
  top: -2,
  outline: "none"
};
ue.gradientHandleWrap = Ra;
var Da = {
  border: "2px solid white",
  borderRadius: "50%",
  boxShadow: "0px 0px 3px rgba(0,0,0,.5)",
  width: 18,
  height: 18,
  boxSizing: "border-box"
};
ue.gradientHandle = Da;
var Ma = {
  pointerEvents: "none"
};
ue.npe = Ma;
var Ha = {
  height: 24,
  borderRadius: 4,
  border: "none",
  outline: "none",
  textAlign: "center",
  width: 34,
  fontWeight: 500,
  color: "rgb(50, 49, 54)",
  fontSize: 13,
  background: "transparent"
};
ue.degreeInput = Ha;
var Ga = {
  height: 32,
  borderRadius: 6,
  border: "1px solid #bebebe",
  width: "100%",
  padding: 2,
  outline: "none",
  color: "black",
  fontWeight: 400,
  textAlign: "center",
  boxSizing: "border-box"
};
ue.inputWrap = Ga;
var Wa = {
  textAlign: "center",
  lineHeight: 1.2,
  fontWeight: 700,
  color: "rgb(86,86,86)",
  fontSize: 11
};
ue.inputLabel = Wa;
var Ba = {
  paddingLeft: 8,
  paddingRight: 8,
  lineHeight: 1,
  borderRadius: 4,
  fontWeight: 700,
  color: "",
  fontSize: 12,
  height: 24,
  transition: "all 160ms ease",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "rgba(255,255,255,0)",
  boxShadow: "1px 1px 3px rgba(0,0,0,0)"
};
ue.controlBtn = Ba;
var La = {
  height: 28,
  background: "#e9e9f5",
  borderRadius: 6,
  padding: 2
};
ue.controlBtnsWrap = La;
var za = {
  position: "absolute",
  right: -2,
  top: 34,
  padding: 5,
  background: "#e9e9f5",
  zIndex: 1e8,
  borderRadius: 6,
  boxShadow: "1px 1px 14px 1px rgba(0,0,0,.25)"
};
ue.inputDropdown = za;
var Fa = {
  fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif"
};
ue.input = Fa;
var $a = {
  // background: '-webkit-linear-gradient(45deg, rgba(0, 0, 0, 0.18) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, 0.18) 75%, rgba(0, 0, 0, 0.18) 0), -webkit-linear-gradient(45deg, rgba(0, 0, 0, 0.18) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, 0.18) 75%, rgba(0, 0, 0, 0.18) 0), white',
  // background: '-moz-linear-gradient(45deg, rgba(0, 0, 0, 0.18) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, 0.18) 75%, rgba(0, 0, 0, 0.18) 0), -moz-linear-gradient(45deg, rgba(0, 0, 0, 0.18) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, 0.18) 75%, rgba(0, 0, 0, 0.18) 0), white',
  background: "linear-gradient(45deg, rgba(0, 0, 0, 0.18) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, 0.18) 75%, rgba(0, 0, 0, 0.18) 0), linear-gradient(45deg, rgba(0, 0, 0, 0.18) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, 0.18) 75%, rgba(0, 0, 0, 0.18) 0), white",
  backgroundRepeat: "repeat, repeat",
  backgroundPosition: "0px 0, 7px 7px",
  WebkitTransformOrigin: "0 0 0",
  transformOrigin: "0 0 0",
  WebkitBackgroundOrigin: "padding-box, padding-box",
  backgroundOrigin: "padding-box, padding-box",
  WebkitBackgroundClip: "border-box, border-box",
  backgroundClip: "border-box, border-box",
  WebkitBackgroundSize: "14px 14px, 14px 14px",
  backgroundSize: "14px 14px, 14px 14px",
  WebkitBoxShadow: "none",
  boxShadow: "none",
  textShadow: "none",
  WebkitTransition: "none",
  MozTransition: "none",
  OTransition: "none",
  transition: "none",
  WebkitTransform: "scaleX(1) scaleY(1) scaleZ(1)",
  transform: "scaleX(1) scaleY(1) scaleZ(1)",
  borderRadius: 10
};
ue.checkered = $a;
(function(e) {
  function t(i) {
    "@babel/helpers - typeof";
    return t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
      return typeof n;
    } : function(n) {
      return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
    }, t(i);
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = z(we), v = Te, p = j(Xt), S = ue;
  function j(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function E(i) {
    if (typeof WeakMap != "function")
      return null;
    var n = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
    return (E = function(s) {
      return s ? r : n;
    })(i);
  }
  function z(i, n) {
    if (!n && i && i.__esModule)
      return i;
    if (i === null || t(i) !== "object" && typeof i != "function")
      return { default: i };
    var r = E(n);
    if (r && r.has(i))
      return r.get(i);
    var o = {}, s = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var x in i)
      if (x !== "default" && Object.prototype.hasOwnProperty.call(i, x)) {
        var f = s ? Object.getOwnPropertyDescriptor(i, x) : null;
        f && (f.get || f.set) ? Object.defineProperty(o, x, f) : o[x] = i[x];
      }
    return o.default = i, r && r.set(i, o), o;
  }
  function w(i, n) {
    var r = Object.keys(i);
    if (Object.getOwnPropertySymbols) {
      var o = Object.getOwnPropertySymbols(i);
      n && (o = o.filter(function(s) {
        return Object.getOwnPropertyDescriptor(i, s).enumerable;
      })), r.push.apply(r, o);
    }
    return r;
  }
  function P(i) {
    for (var n = 1; n < arguments.length; n++) {
      var r = arguments[n] != null ? arguments[n] : {};
      n % 2 ? w(Object(r), !0).forEach(function(o) {
        L(i, o, r[o]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(i, Object.getOwnPropertyDescriptors(r)) : w(Object(r)).forEach(function(o) {
        Object.defineProperty(i, o, Object.getOwnPropertyDescriptor(r, o));
      });
    }
    return i;
  }
  function L(i, n, r) {
    return n = I(n), n in i ? Object.defineProperty(i, n, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : i[n] = r, i;
  }
  function I(i) {
    var n = T(i, "string");
    return t(n) === "symbol" ? n : String(n);
  }
  function T(i, n) {
    if (t(i) !== "object" || i === null)
      return i;
    var r = i[Symbol.toPrimitive];
    if (r !== void 0) {
      var o = r.call(i, n || "default");
      if (t(o) !== "object")
        return o;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (n === "string" ? String : Number)(i);
  }
  function A(i, n) {
    return U(i) || Q(i, n) || R(i, n) || y();
  }
  function y() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function R(i, n) {
    if (i) {
      if (typeof i == "string")
        return X(i, n);
      var r = Object.prototype.toString.call(i).slice(8, -1);
      if (r === "Object" && i.constructor && (r = i.constructor.name), r === "Map" || r === "Set")
        return Array.from(i);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
        return X(i, n);
    }
  }
  function X(i, n) {
    (n == null || n > i.length) && (n = i.length);
    for (var r = 0, o = new Array(n); r < n; r++)
      o[r] = i[r];
    return o;
  }
  function Q(i, n) {
    var r = i == null ? null : typeof Symbol < "u" && i[Symbol.iterator] || i["@@iterator"];
    if (r != null) {
      var o, s, x, f, _ = [], d = !0, u = !1;
      try {
        if (x = (r = r.call(i)).next, n === 0) {
          if (Object(r) !== r)
            return;
          d = !1;
        } else
          for (; !(d = (o = x.call(r)).done) && (_.push(o.value), _.length !== n); d = !0)
            ;
      } catch (h) {
        u = !0, s = h;
      } finally {
        try {
          if (!d && r.return != null && (f = r.return(), Object(f) !== f))
            return;
        } finally {
          if (u)
            throw s;
        }
      }
      return _;
    }
  }
  function U(i) {
    if (Array.isArray(i))
      return i;
  }
  var b = function() {
    var n = (0, a.useRef)(null), r = (0, v.usePicker)(), o = r.handleHue, s = r.internalHue, x = r.squareSize, f = (0, a.useState)(!1), _ = A(f, 2), d = _[0], u = _[1];
    (0, p.default)(n, x);
    var h = (0, a.useState)(2), O = A(h, 2), M = O[0], q = O[1];
    (0, a.useEffect)(function() {
      var $;
      q((n == null || ($ = n.current) === null || $ === void 0 ? void 0 : $.offsetTop) - 2);
    }, [n]);
    var W = function() {
      u(!1);
    }, Z = function() {
      u(!0);
    }, K = function(D) {
      d && o(D);
    }, J = function(D) {
      d || o(D);
    };
    return (0, a.useEffect)(function() {
      var $ = function() {
        W();
      };
      return window.addEventListener("mouseup", $), function() {
        window.removeEventListener("mouseup", $);
      };
    }, []), /* @__PURE__ */ a.default.createElement("div", {
      style: P(P(P(P({}, S.psRl), S.cResize), S.borderBox), {}, {
        height: 14,
        marginTop: 17,
        marginBottom: 4
      }),
      onMouseMove: function(D) {
        return K(D);
      }
    }, /* @__PURE__ */ a.default.createElement("div", {
      style: P(P({}, S.handle), {}, {
        left: s * ((x - 18) / 360),
        top: M
      }),
      onMouseDown: Z
    }), /* @__PURE__ */ a.default.createElement("canvas", {
      ref: n,
      width: "".concat(x, "px"),
      height: "14px",
      style: {
        position: "relative",
        borderRadius: 14,
        verticalAlign: "top"
      },
      onClick: function(D) {
        return J(D);
      }
    }));
  }, C = b;
  e.default = C;
})(Lr);
var zr = {}, Ze = {};
Object.defineProperty(Ze, "__esModule", {
  value: !0
});
Ze.cmykToRgb = void 0;
Ze.rgb2cmyk = qa;
function qa(e, t, a) {
  var v = 0, p = 0, S = 0, j = 0;
  if (e === null || t === null || a === null || isNaN(e) || isNaN(t) || isNaN(a)) {
    alert("Please enter numeric RGB values!");
    return;
  }
  if (e < 0 || t < 0 || a < 0 || e > 255 || t > 255 || a > 255) {
    alert("RGB values must be in the range 0 to 255.");
    return;
  }
  if (e === 0 && t === 0 && a === 0)
    return j = 1, [0, 0, 0, 1];
  v = 1 - e / 255, p = 1 - t / 255, S = 1 - a / 255;
  var E = Math.min(v, Math.min(p, S));
  return v = (v - E) / (1 - E), p = (p - E) / (1 - E), S = (S - E) / (1 - E), j = E, {
    c: v,
    m: p,
    y: S,
    k: j
  };
}
var Na = function(t) {
  var a = t.c, v = t.m, p = t.y, S = t.k, j = 255 * (1 - a) * (1 - S), E = 255 * (1 - v) * (1 - S), z = 255 * (1 - p) * (1 - S);
  return {
    r: j,
    g: E,
    b: z
  };
};
Ze.cmykToRgb = Na;
(function(e) {
  function t(d) {
    "@babel/helpers - typeof";
    return t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(u) {
      return typeof u;
    } : function(u) {
      return u && typeof Symbol == "function" && u.constructor === Symbol && u !== Symbol.prototype ? "symbol" : typeof u;
    }, t(d);
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = z(we), v = Ze, p = Xe(), S = Te, j = ue;
  function E(d) {
    if (typeof WeakMap != "function")
      return null;
    var u = /* @__PURE__ */ new WeakMap(), h = /* @__PURE__ */ new WeakMap();
    return (E = function(M) {
      return M ? h : u;
    })(d);
  }
  function z(d, u) {
    if (!u && d && d.__esModule)
      return d;
    if (d === null || t(d) !== "object" && typeof d != "function")
      return { default: d };
    var h = E(u);
    if (h && h.has(d))
      return h.get(d);
    var O = {}, M = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var q in d)
      if (q !== "default" && Object.prototype.hasOwnProperty.call(d, q)) {
        var W = M ? Object.getOwnPropertyDescriptor(d, q) : null;
        W && (W.get || W.set) ? Object.defineProperty(O, q, W) : O[q] = d[q];
      }
    return O.default = d, h && h.set(d, O), O;
  }
  function w(d, u) {
    var h = Object.keys(d);
    if (Object.getOwnPropertySymbols) {
      var O = Object.getOwnPropertySymbols(d);
      u && (O = O.filter(function(M) {
        return Object.getOwnPropertyDescriptor(d, M).enumerable;
      })), h.push.apply(h, O);
    }
    return h;
  }
  function P(d) {
    for (var u = 1; u < arguments.length; u++) {
      var h = arguments[u] != null ? arguments[u] : {};
      u % 2 ? w(Object(h), !0).forEach(function(O) {
        L(d, O, h[O]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(d, Object.getOwnPropertyDescriptors(h)) : w(Object(h)).forEach(function(O) {
        Object.defineProperty(d, O, Object.getOwnPropertyDescriptor(h, O));
      });
    }
    return d;
  }
  function L(d, u, h) {
    return u = I(u), u in d ? Object.defineProperty(d, u, { value: h, enumerable: !0, configurable: !0, writable: !0 }) : d[u] = h, d;
  }
  function I(d) {
    var u = T(d, "string");
    return t(u) === "symbol" ? u : String(u);
  }
  function T(d, u) {
    if (t(d) !== "object" || d === null)
      return d;
    var h = d[Symbol.toPrimitive];
    if (h !== void 0) {
      var O = h.call(d, u || "default");
      if (t(O) !== "object")
        return O;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (u === "string" ? String : Number)(d);
  }
  function A(d, u) {
    return U(d) || Q(d, u) || R(d, u) || y();
  }
  function y() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function R(d, u) {
    if (d) {
      if (typeof d == "string")
        return X(d, u);
      var h = Object.prototype.toString.call(d).slice(8, -1);
      if (h === "Object" && d.constructor && (h = d.constructor.name), h === "Map" || h === "Set")
        return Array.from(d);
      if (h === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(h))
        return X(d, u);
    }
  }
  function X(d, u) {
    (u == null || u > d.length) && (u = d.length);
    for (var h = 0, O = new Array(u); h < u; h++)
      O[h] = d[h];
    return O;
  }
  function Q(d, u) {
    var h = d == null ? null : typeof Symbol < "u" && d[Symbol.iterator] || d["@@iterator"];
    if (h != null) {
      var O, M, q, W, Z = [], K = !0, J = !1;
      try {
        if (q = (h = h.call(d)).next, u === 0) {
          if (Object(h) !== h)
            return;
          K = !1;
        } else
          for (; !(K = (O = q.call(h)).done) && (Z.push(O.value), Z.length !== u); K = !0)
            ;
      } catch ($) {
        J = !0, M = $;
      } finally {
        try {
          if (!K && h.return != null && (W = h.return(), Object(W) !== W))
            return;
        } finally {
          if (J)
            throw M;
        }
      }
      return Z;
    }
  }
  function U(d) {
    if (Array.isArray(d))
      return d;
  }
  var b = Fe, C = function() {
    var u = (0, S.usePicker)(), h = u.handleChange, O = u.r, M = u.g, q = u.b, W = u.opacity, Z = u.inputType, K = u.hideOpacity;
    return /* @__PURE__ */ a.default.createElement("div", {
      style: {
        display: "flex",
        justifyContent: "space-between",
        paddingTop: 14
      }
    }, Z !== "cmyk" && /* @__PURE__ */ a.default.createElement(n, null), Z === "hsl" && /* @__PURE__ */ a.default.createElement(o, null), Z === "rgb" && /* @__PURE__ */ a.default.createElement(r, null), Z === "hsv" && /* @__PURE__ */ a.default.createElement(s, null), Z === "cmyk" && /* @__PURE__ */ a.default.createElement(x, null), !K && /* @__PURE__ */ a.default.createElement(f, {
      value: W * 100,
      callback: function($) {
        return h("rgba(".concat(O, ", ").concat(M, ", ").concat(q, ", ").concat($ / 100, ")"));
      },
      label: "A"
    }));
  }, i = C;
  e.default = i;
  var n = function() {
    var u = (0, S.usePicker)(), h = u.handleChange, O = u.tinyColor, M = u.opacity, q = (0, a.useState)(""), W = A(q, 2), Z = W[0], K = W[1], J = O.toHex(), $ = (0, a.useState)(J), D = A($, 2), Y = D[0], ee = D[1];
    (0, a.useEffect)(function() {
      Z !== "hex" && ee(J);
    }, [O, Z, J]);
    var ne = function() {
      K("hex");
    }, ae = function() {
      K("");
    }, N = function(fe) {
      var l = b(fe.target.value);
      if (ee(fe.target.value), l.isValid()) {
        var g = l.toRgb(), c = g.r, B = g.g, H = g.b, k = "rgba(".concat(c, ", ").concat(B, ", ").concat(H, ", ").concat(M, ")");
        h(k);
      }
    };
    return /* @__PURE__ */ a.default.createElement("div", {
      style: {
        width: "23%"
      }
    }, /* @__PURE__ */ a.default.createElement("input", {
      style: P({}, j.inputWrap),
      value: Y,
      onChange: function(fe) {
        return N(fe);
      },
      id: "rbgcp-input",
      onFocus: ne,
      onBlur: ae
    }), /* @__PURE__ */ a.default.createElement("div", {
      style: P({}, j.inputLabel)
    }, "HEX"));
  }, r = function() {
    var u = (0, S.usePicker)(), h = u.handleChange, O = u.r, M = u.g, q = u.b, W = u.opacity, Z = function(J) {
      var $ = J.r, D = J.g, Y = J.b;
      h("rgba(".concat($, ", ").concat(D, ", ").concat(Y, ", ").concat(W, ")"));
    };
    return /* @__PURE__ */ a.default.createElement(a.default.Fragment, null, /* @__PURE__ */ a.default.createElement(f, {
      value: O,
      callback: function(J) {
        return Z({
          r: J,
          g: M,
          b: q
        });
      },
      label: "R",
      max: 255
    }), /* @__PURE__ */ a.default.createElement(f, {
      value: M,
      callback: function(J) {
        return Z({
          r: O,
          g: J,
          b: q
        });
      },
      label: "G",
      max: 255
    }), /* @__PURE__ */ a.default.createElement(f, {
      value: q,
      callback: function(J) {
        return Z({
          r: O,
          g: M,
          b: J
        });
      },
      label: "B",
      max: 255
    }));
  }, o = function() {
    var u = (0, S.usePicker)(), h = u.handleChange, O = u.s, M = u.l, q = u.internalHue, W = u.opacity, Z = u.setInternalHue, K = function(D, Y, ee) {
      Z(D);
      var ne = b({
        h: D,
        s: Y,
        l: ee
      }).toRgb(), ae = ne.r, N = ne.g, te = ne.b;
      h("rgba(".concat(ae, ", ").concat(N, ", ").concat(te, ", ").concat(W, ")"));
    }, J = function(D) {
      var Y = b(D).toRgb(), ee = Y.r, ne = Y.g, ae = Y.b;
      h("rgba(".concat(ee, ", ").concat(ne, ", ").concat(ae, ", ").concat(W, ")"));
    };
    return /* @__PURE__ */ a.default.createElement(a.default.Fragment, null, /* @__PURE__ */ a.default.createElement(f, {
      value: _(q),
      callback: function(D) {
        return K(D, O, M);
      },
      label: "H",
      max: 360
    }), /* @__PURE__ */ a.default.createElement(f, {
      value: _(O * 100),
      callback: function(D) {
        return J({
          h: q,
          s: D,
          l: M
        });
      },
      label: "S"
    }), /* @__PURE__ */ a.default.createElement(f, {
      value: _(M * 100),
      callback: function(D) {
        return J({
          h: q,
          s: O,
          l: D
        });
      },
      label: "L"
    }));
  }, s = function() {
    var u = (0, S.usePicker)(), h = u.handleChange, O = u.hsvS, M = u.hsvV, q = u.internalHue, W = u.setInternalHue, Z = u.opacity, K = function(D, Y, ee) {
      W(D);
      var ne = b({
        h: D,
        s: Y,
        v: ee
      }).toRgb(), ae = ne.r, N = ne.g, te = ne.b;
      h("rgba(".concat(ae, ", ").concat(N, ", ").concat(te, ", ").concat(Z, ")"));
    }, J = function(D) {
      var Y = b(D).toRgb(), ee = Y.r, ne = Y.g, ae = Y.b;
      h("rgba(".concat(ee, ", ").concat(ne, ", ").concat(ae, ", ").concat(Z, ")"));
    };
    return /* @__PURE__ */ a.default.createElement(a.default.Fragment, null, /* @__PURE__ */ a.default.createElement(f, {
      value: _(q),
      callback: function(D) {
        return K(D, O, M);
      },
      label: "H",
      max: 360
    }), /* @__PURE__ */ a.default.createElement(f, {
      value: _(O * 100),
      callback: function(D) {
        return J({
          h: q,
          s: D,
          v: M
        });
      },
      label: "S"
    }), /* @__PURE__ */ a.default.createElement(f, {
      value: _(M * 100),
      callback: function(D) {
        return J({
          h: q,
          s: O,
          v: D
        });
      },
      label: "V"
    }));
  }, x = function() {
    var u = (0, S.usePicker)(), h = u.handleChange, O = u.r, M = u.g, q = u.b, W = u.opacity, Z = (0, v.rgb2cmyk)(O, M, q), K = Z.c, J = Z.m, $ = Z.k, D = Z.y, Y = function(ne) {
      var ae = (0, v.cmykToRgb)(ne), N = ae.r, te = ae.g, fe = ae.b;
      h("rgba(".concat(N, ", ").concat(te, ", ").concat(fe, ", ").concat(W, ")"));
    };
    return /* @__PURE__ */ a.default.createElement(a.default.Fragment, null, /* @__PURE__ */ a.default.createElement(f, {
      value: _(K * 100),
      callback: function(ne) {
        return Y({
          c: ne,
          m: J,
          y: D,
          k: $
        });
      },
      label: "C"
    }), /* @__PURE__ */ a.default.createElement(f, {
      value: _(J * 100),
      callback: function(ne) {
        return Y({
          c: K,
          m: ne,
          y: D,
          k: $
        });
      },
      label: "M"
    }), /* @__PURE__ */ a.default.createElement(f, {
      value: _(D * 100),
      callback: function(ne) {
        return Y({
          c: K,
          m: J,
          y: ne,
          k: $
        });
      },
      label: "Y"
    }), /* @__PURE__ */ a.default.createElement(f, {
      value: _($ * 100),
      callback: function(ne) {
        return Y({
          c: K,
          m: J,
          y: D,
          k: ne
        });
      },
      label: "K"
    }));
  }, f = function(u) {
    var h = u.value, O = u.callback, M = u.max, q = M === void 0 ? 100 : M, W = u.label, Z = (0, a.useState)(h), K = A(Z, 2), J = K[0], $ = K[1], D = (0, S.usePicker)(), Y = D.hideOpacity, ee = Y ? "22%" : "18%";
    (0, a.useEffect)(function() {
      $(h);
    }, [h]);
    var ne = function(N) {
      var te = (0, p.formatInputValues)(parseFloat(N.target.value), 0, q);
      $(te), O(te);
    };
    return /* @__PURE__ */ a.default.createElement("div", {
      style: {
        width: ee
      }
    }, /* @__PURE__ */ a.default.createElement("input", {
      id: "rbgcp-input",
      style: P({}, j.inputWrap),
      value: J,
      onChange: function(N) {
        return ne(N);
      }
    }), /* @__PURE__ */ a.default.createElement("div", {
      style: P({}, j.inputLabel)
    }, W));
  }, _ = function(u) {
    return Math.round(u, 2);
  };
})(zr);
var Fr = {}, $r = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = we, a = function(S, j, E, z) {
    (0, t.useEffect)(function() {
      var w = S.current.getContext("2d", {
        willReadFrequently: !0
      });
      w.fillStyle = "hsl(".concat(j, ", 100%, 50%)"), w.fillRect(0, 0, E, z);
      var P = w.createLinearGradient(0, 0, E, 0);
      P.addColorStop(0, "rgba(255, 255, 255, 1)"), P.addColorStop(1, "rgba(255, 255, 255, 0)"), w.fillStyle = P, w.fillRect(0, 0, E, z);
      var L = w.createLinearGradient(0, 0, 0, z);
      L.addColorStop(0, "rgba(0, 0, 0, 0)"), L.addColorStop(1, "rgba(0, 0, 0, 1)"), w.fillStyle = L, w.fillRect(0, 0, E, z);
    }, [S, j, E, z]);
  }, v = a;
  e.default = v;
})($r);
(function(e) {
  function t(i) {
    "@babel/helpers - typeof";
    return t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
      return typeof n;
    } : function(n) {
      return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
    }, t(i);
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = z(we), v = j($r), p = Te, S = ue;
  function j(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function E(i) {
    if (typeof WeakMap != "function")
      return null;
    var n = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
    return (E = function(s) {
      return s ? r : n;
    })(i);
  }
  function z(i, n) {
    if (!n && i && i.__esModule)
      return i;
    if (i === null || t(i) !== "object" && typeof i != "function")
      return { default: i };
    var r = E(n);
    if (r && r.has(i))
      return r.get(i);
    var o = {}, s = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var x in i)
      if (x !== "default" && Object.prototype.hasOwnProperty.call(i, x)) {
        var f = s ? Object.getOwnPropertyDescriptor(i, x) : null;
        f && (f.get || f.set) ? Object.defineProperty(o, x, f) : o[x] = i[x];
      }
    return o.default = i, r && r.set(i, o), o;
  }
  function w(i, n) {
    var r = Object.keys(i);
    if (Object.getOwnPropertySymbols) {
      var o = Object.getOwnPropertySymbols(i);
      n && (o = o.filter(function(s) {
        return Object.getOwnPropertyDescriptor(i, s).enumerable;
      })), r.push.apply(r, o);
    }
    return r;
  }
  function P(i) {
    for (var n = 1; n < arguments.length; n++) {
      var r = arguments[n] != null ? arguments[n] : {};
      n % 2 ? w(Object(r), !0).forEach(function(o) {
        L(i, o, r[o]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(i, Object.getOwnPropertyDescriptors(r)) : w(Object(r)).forEach(function(o) {
        Object.defineProperty(i, o, Object.getOwnPropertyDescriptor(r, o));
      });
    }
    return i;
  }
  function L(i, n, r) {
    return n = I(n), n in i ? Object.defineProperty(i, n, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : i[n] = r, i;
  }
  function I(i) {
    var n = T(i, "string");
    return t(n) === "symbol" ? n : String(n);
  }
  function T(i, n) {
    if (t(i) !== "object" || i === null)
      return i;
    var r = i[Symbol.toPrimitive];
    if (r !== void 0) {
      var o = r.call(i, n || "default");
      if (t(o) !== "object")
        return o;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (n === "string" ? String : Number)(i);
  }
  function A(i, n) {
    return U(i) || Q(i, n) || R(i, n) || y();
  }
  function y() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function R(i, n) {
    if (i) {
      if (typeof i == "string")
        return X(i, n);
      var r = Object.prototype.toString.call(i).slice(8, -1);
      if (r === "Object" && i.constructor && (r = i.constructor.name), r === "Map" || r === "Set")
        return Array.from(i);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
        return X(i, n);
    }
  }
  function X(i, n) {
    (n == null || n > i.length) && (n = i.length);
    for (var r = 0, o = new Array(n); r < n; r++)
      o[r] = i[r];
    return o;
  }
  function Q(i, n) {
    var r = i == null ? null : typeof Symbol < "u" && i[Symbol.iterator] || i["@@iterator"];
    if (r != null) {
      var o, s, x, f, _ = [], d = !0, u = !1;
      try {
        if (x = (r = r.call(i)).next, n === 0) {
          if (Object(r) !== r)
            return;
          d = !1;
        } else
          for (; !(d = (o = x.call(r)).done) && (_.push(o.value), _.length !== n); d = !0)
            ;
      } catch (h) {
        u = !0, s = h;
      } finally {
        try {
          if (!d && r.return != null && (f = r.return(), Object(f) !== f))
            return;
        } finally {
          if (u)
            throw s;
        }
      }
      return _;
    }
  }
  function U(i) {
    if (Array.isArray(i))
      return i;
  }
  var b = function() {
    var n = (0, p.usePicker)(), r = n.x, o = n.y, s = n.handleColor, x = n.internalHue, f = n.squareSize, _ = n.squareHeight, d = (0, a.useState)(!1), u = A(d, 2), h = u[0], O = u[1], M = (0, a.useRef)(null);
    (0, v.default)(M, x, f, _);
    var q = function(Y) {
      var ee, ne = M == null || (ee = M.current) === null || ee === void 0 ? void 0 : ee.getContext("2d", {
        willReadFrequently: !0
      });
      s(Y, ne);
    }, W = function() {
      O(!1);
    }, Z = function(Y) {
      h && q(Y);
    }, K = function(Y) {
      h || q(Y);
    }, J = function() {
      O(!0);
    }, $ = function(Y) {
      O(!0), q(Y);
    };
    return (0, a.useEffect)(function() {
      var D = function() {
        W();
      };
      return window.addEventListener("mouseup", D), function() {
        window.removeEventListener("mouseup", D);
      };
    }, []), /* @__PURE__ */ a.default.createElement("div", {
      style: S.psRl
    }, /* @__PURE__ */ a.default.createElement("div", {
      style: P(P({}, S.psRl), S.cCross),
      onMouseDown: $,
      onMouseMove: function(Y) {
        return Z(Y);
      },
      onMouseUp: W
    }, /* @__PURE__ */ a.default.createElement("div", {
      style: P({
        left: r,
        top: o
      }, S.handle),
      onMouseDown: J
    }), /* @__PURE__ */ a.default.createElement("div", {
      style: P(P({}, S.canvasWrapper), {}, {
        height: _
      }),
      onClick: function(Y) {
        return K(Y);
      }
    }, /* @__PURE__ */ a.default.createElement("canvas", {
      ref: M,
      width: "".concat(f, "px"),
      height: "".concat(_, "px"),
      id: "paintSquare"
    }))));
  }, C = b;
  e.default = C;
})(Fr);
var qr = {};
(function(e) {
  function t(b) {
    "@babel/helpers - typeof";
    return t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(C) {
      return typeof C;
    } : function(C) {
      return C && typeof Symbol == "function" && C.constructor === Symbol && C !== Symbol.prototype ? "symbol" : typeof C;
    }, t(b);
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = j(we), v = Te, p = ue;
  function S(b) {
    if (typeof WeakMap != "function")
      return null;
    var C = /* @__PURE__ */ new WeakMap(), i = /* @__PURE__ */ new WeakMap();
    return (S = function(r) {
      return r ? i : C;
    })(b);
  }
  function j(b, C) {
    if (!C && b && b.__esModule)
      return b;
    if (b === null || t(b) !== "object" && typeof b != "function")
      return { default: b };
    var i = S(C);
    if (i && i.has(b))
      return i.get(b);
    var n = {}, r = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var o in b)
      if (o !== "default" && Object.prototype.hasOwnProperty.call(b, o)) {
        var s = r ? Object.getOwnPropertyDescriptor(b, o) : null;
        s && (s.get || s.set) ? Object.defineProperty(n, o, s) : n[o] = b[o];
      }
    return n.default = b, i && i.set(b, n), n;
  }
  function E(b, C) {
    var i = Object.keys(b);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(b);
      C && (n = n.filter(function(r) {
        return Object.getOwnPropertyDescriptor(b, r).enumerable;
      })), i.push.apply(i, n);
    }
    return i;
  }
  function z(b) {
    for (var C = 1; C < arguments.length; C++) {
      var i = arguments[C] != null ? arguments[C] : {};
      C % 2 ? E(Object(i), !0).forEach(function(n) {
        w(b, n, i[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(b, Object.getOwnPropertyDescriptors(i)) : E(Object(i)).forEach(function(n) {
        Object.defineProperty(b, n, Object.getOwnPropertyDescriptor(i, n));
      });
    }
    return b;
  }
  function w(b, C, i) {
    return C = P(C), C in b ? Object.defineProperty(b, C, { value: i, enumerable: !0, configurable: !0, writable: !0 }) : b[C] = i, b;
  }
  function P(b) {
    var C = L(b, "string");
    return t(C) === "symbol" ? C : String(C);
  }
  function L(b, C) {
    if (t(b) !== "object" || b === null)
      return b;
    var i = b[Symbol.toPrimitive];
    if (i !== void 0) {
      var n = i.call(b, C || "default");
      if (t(n) !== "object")
        return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (C === "string" ? String : Number)(b);
  }
  function I(b, C) {
    return X(b) || R(b, C) || A(b, C) || T();
  }
  function T() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function A(b, C) {
    if (b) {
      if (typeof b == "string")
        return y(b, C);
      var i = Object.prototype.toString.call(b).slice(8, -1);
      if (i === "Object" && b.constructor && (i = b.constructor.name), i === "Map" || i === "Set")
        return Array.from(b);
      if (i === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i))
        return y(b, C);
    }
  }
  function y(b, C) {
    (C == null || C > b.length) && (C = b.length);
    for (var i = 0, n = new Array(C); i < C; i++)
      n[i] = b[i];
    return n;
  }
  function R(b, C) {
    var i = b == null ? null : typeof Symbol < "u" && b[Symbol.iterator] || b["@@iterator"];
    if (i != null) {
      var n, r, o, s, x = [], f = !0, _ = !1;
      try {
        if (o = (i = i.call(b)).next, C === 0) {
          if (Object(i) !== i)
            return;
          f = !1;
        } else
          for (; !(f = (n = o.call(i)).done) && (x.push(n.value), x.length !== C); f = !0)
            ;
      } catch (d) {
        _ = !0, r = d;
      } finally {
        try {
          if (!f && i.return != null && (s = i.return(), Object(s) !== s))
            return;
        } finally {
          if (_)
            throw r;
        }
      }
      return x;
    }
  }
  function X(b) {
    if (Array.isArray(b))
      return b;
  }
  var Q = function() {
    var C = (0, v.usePicker)(), i = C.handleOpacity, n = C.opacity, r = C.tinyColor, o = C.squareSize, s = (0, a.useState)(!1), x = I(s, 2), f = x[0], _ = x[1], d = r.toRgb(), u = d.r, h = d.g, O = d.b, M = "linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(".concat(u, ",").concat(h, ",").concat(O, ",.5) 100%)"), q = function() {
      _(!1);
    }, W = function() {
      _(!0);
    }, Z = function(D) {
      f && i(D);
    }, K = function(D) {
      f || i(D);
    }, J = o - 18;
    return (0, a.useEffect)(function() {
      var $ = function() {
        q();
      };
      return window.addEventListener("mouseup", $), function() {
        window.removeEventListener("mouseup", $);
      };
    }, []), /* @__PURE__ */ a.default.createElement("div", {
      onMouseDown: W,
      onMouseMove: function(D) {
        return Z(D);
      },
      style: z(z(z(z({}, p.cResize), p.psRl), {}, {
        height: 14
      }, p.borderBox), {}, {
        marginTop: 17,
        marginBottom: 4
      })
    }, /* @__PURE__ */ a.default.createElement("div", {
      style: z(z({}, p.checkered), {}, {
        width: "100%",
        height: 14
      })
    }), /* @__PURE__ */ a.default.createElement("div", {
      style: z({
        left: J * n,
        top: -2
      }, p.handle)
    }), /* @__PURE__ */ a.default.createElement("div", {
      style: z({
        background: M
      }, p.opacityOverlay),
      onClick: function(D) {
        return K(D);
      }
    }));
  }, U = Q;
  e.default = U;
})(qr);
var Nr = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = v(we), a = Te;
  function v(E) {
    return E && E.__esModule ? E : { default: E };
  }
  var p = function(z) {
    var w = z.presets, P = w === void 0 ? [] : w, L = (0, a.usePicker)(), I = L.value, T = L.onChange, A = L.handleChange, y = L.squareSize, R = function() {
      return (P == null ? void 0 : P.length) > 0 ? P == null ? void 0 : P.slice(0, 18) : j;
    }, X = function(U) {
      U != null && U.includes("gradient") ? T(U) : A(U);
    };
    return /* @__PURE__ */ t.default.createElement("div", {
      style: {
        display: "flex",
        marginTop: 14,
        justifyContent: "space-between"
      }
    }, /* @__PURE__ */ t.default.createElement("div", {
      style: {
        width: 50,
        height: 50,
        background: I,
        borderRadius: 6,
        flexShrink: 0
      }
    }), /* @__PURE__ */ t.default.createElement("div", {
      style: {
        display: "flex",
        flexWrap: "wrap",
        width: y - 66,
        justifyContent: "space-between"
      }
    }, R().map(function(Q, U) {
      return /* @__PURE__ */ t.default.createElement("div", {
        key: U,
        style: {
          height: 23,
          width: "10.2%",
          borderRadius: 4,
          background: Q,
          marginBottom: 2,
          border: Q === "rgba(255,255,255, 1)" ? "1px solid #96959c" : ""
        },
        onClick: function() {
          return X(Q);
        }
      });
    })));
  }, S = p;
  e.default = S;
  var j = ["rgba(0,0,0,1)", "rgba(128,128,128, 1)", "rgba(192,192,192, 1)", "rgba(255,255,255, 1)", "rgba(0,0,128,1)", "rgba(0,0,255,1)", "rgba(0,255,255, 1)", "rgba(0,128,0,1)", "rgba(128,128,0, 1)", "rgba(0,128,128,1)", "rgba(0,255,0, 1)", "rgba(128,0,0, 1)", "rgba(128,0,128, 1)", "rgba(175, 51, 242, 1)", "rgba(255,0,255, 1)", "rgba(255,0,0, 1)", "rgba(240, 103, 46, 1)", "rgba(255,255,0, 1)"];
})(Nr);
var Rt = {}, Zt = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = e.StopIcon = e.SlidersIcon = e.RadialIcon = e.PaletteIcon = e.LinearIcon = e.InputsIcon = e.DegreesIcon = void 0;
  var t = a(we);
  function a(I) {
    return I && I.__esModule ? I : { default: I };
  }
  var v = function() {
    var T = {
      fill: "none",
      stroke: "rgb(50, 49, 54)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.8px"
    };
    return /* @__PURE__ */ t.default.createElement("svg", {
      id: "Layer_1",
      "data-name": "Layer 1",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      style: {
        width: 15
      }
    }, /* @__PURE__ */ t.default.createElement("polyline", {
      style: T,
      points: "17.96 4.31 2.04 4.3 3.75 4.3 4.81 17.29 5.16 17.96 5.74 18.47 6.59 18.62 13.64 18.62 14.52 18.32 15.07 17.68 15.29 17.12 16.28 4.3 12.87 4.3 12.87 2.38 12.48 1.75 11.83 1.46 8.4 1.46 7.64 1.68 7.26 2.21 7.16 2.52 7.17 4.23"
    }));
  }, p = v;
  e.default = p;
  var S = function(T) {
    var A = T.color, y = A || "#323136", R = {
      fill: "none",
      stroke: y,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.8px"
    };
    return /* @__PURE__ */ t.default.createElement("svg", {
      id: "Layer_1",
      "data-name": "Layer 1",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      style: {
        width: 14
      }
    }, /* @__PURE__ */ t.default.createElement("polyline", {
      style: R,
      points: "0.9 12.73 0.9 19.1 7.27 19.1 0.9 19.1 19.1 0.9 12.73 0.9 19.1 0.9 19.1 7.27"
    }));
  };
  e.LinearIcon = S;
  var j = function(T) {
    var A = T.color, y = A || "#323136", R = {
      fill: "none",
      stroke: y,
      strokeMiterlimit: 10,
      strokeWidth: "1.8px"
    };
    return /* @__PURE__ */ t.default.createElement("svg", {
      id: "Layer_1",
      "data-name": "Layer 1",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      style: {
        width: 15
      }
    }, /* @__PURE__ */ t.default.createElement("circle", {
      style: R,
      cx: "10",
      cy: "10",
      r: "9"
    }), /* @__PURE__ */ t.default.createElement("circle", {
      style: R,
      cx: "10",
      cy: "10",
      r: "5"
    }));
  };
  e.RadialIcon = j;
  var E = function(T) {
    var A = T.color, y = A || "#323136", R = {
      fill: "none",
      stroke: y,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.8px",
      fillRule: "evenodd"
    }, X = {
      fill: y,
      stroke: y,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.8px"
    };
    return /* @__PURE__ */ t.default.createElement("svg", {
      id: "Layer_1",
      "data-name": "Layer 1",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      style: {
        width: 17
      }
    }, /* @__PURE__ */ t.default.createElement("polyline", {
      style: R,
      points: "3.74 2.75 3.74 12.69 0.9 12.71 6.59 12.71"
    }), /* @__PURE__ */ t.default.createElement("line", {
      style: X,
      x1: "3.74",
      y1: "17.26",
      x2: "3.74",
      y2: "15.21"
    }), /* @__PURE__ */ t.default.createElement("polyline", {
      style: R,
      points: "10.1 17.25 10.1 7.31 12.95 7.29 7.26 7.29"
    }), /* @__PURE__ */ t.default.createElement("line", {
      style: X,
      x1: "10.1",
      y1: "2.74",
      x2: "10.1",
      y2: "4.79"
    }), /* @__PURE__ */ t.default.createElement("polyline", {
      style: R,
      points: "16.26 2.75 16.26 12.69 13.41 12.71 19.1 12.71"
    }), /* @__PURE__ */ t.default.createElement("line", {
      style: X,
      x1: "16.26",
      y1: "17.26",
      x2: "16.26",
      y2: "15.21"
    }));
  };
  e.SlidersIcon = E;
  var z = function(T) {
    var A = T.color, y = A || "#323136", R = {
      fill: "none",
      stroke: y,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.8px"
    };
    return /* @__PURE__ */ t.default.createElement("svg", {
      id: "Layer_1",
      "data-name": "Layer 1",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      style: {
        width: 17
      }
    }, /* @__PURE__ */ t.default.createElement("path", {
      style: R,
      d: "M6.35,2.72a4.85,4.85,0,0,1,1.86.16,7.94,7.94,0,0,1,.88.43,3.66,3.66,0,0,0,.85.49c.25,0,.58-.27.81-.39A8.25,8.25,0,0,1,11.7,3a4,4,0,0,1,1.79-.23,3.21,3.21,0,0,0-1.34.09,6.39,6.39,0,0,0-1.47.63c-.45.25-.7.3-.7.86s0,1.18,0,1.78c0,1.3,0,2.61,0,3.92h0v5.63a2.46,2.46,0,0,1,0,.47c-.07.28-.43.42-.7.57a5.29,5.29,0,0,1-2.94.61A9.3,9.3,0,0,0,8,17.15l1.09-.37.89-.52c.06,0,.48.21.56.25.32.14.64.27,1,.38a8.54,8.54,0,0,0,2.12.4"
    }), /* @__PURE__ */ t.default.createElement("path", {
      style: R,
      d: "M7.57,5.73C6,5.7,4.5,5.65,3,5.77a2.28,2.28,0,0,0-1.76.74A2.3,2.3,0,0,0,.94,7.83l0,3.82A4.73,4.73,0,0,0,1,12.9a1.64,1.64,0,0,0,.68,1,2.44,2.44,0,0,0,1,.27,25,25,0,0,0,4.74.09"
    }), /* @__PURE__ */ t.default.createElement("path", {
      style: R,
      d: "M12.43,14.32a44.12,44.12,0,0,0,4.6,0,2.24,2.24,0,0,0,1.76-.74,2.29,2.29,0,0,0,.27-1.32l0-3.81A4.81,4.81,0,0,0,19,7.15a1.62,1.62,0,0,0-.68-1,2.31,2.31,0,0,0-1-.28,26.8,26.8,0,0,0-4.74-.09"
    }));
  };
  e.InputsIcon = z;
  var w = function(T) {
    var A = T.color, y = A || "#323136", R = {
      fill: y
    }, X = {
      fill: y,
      stroke: y,
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    };
    return /* @__PURE__ */ t.default.createElement("svg", {
      id: "Layer_1",
      "data-name": "Layer 1",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      style: {
        width: 17
      }
    }, /* @__PURE__ */ t.default.createElement("circle", {
      style: R,
      cx: "9.36",
      cy: "5.07",
      r: "1.71"
    }), /* @__PURE__ */ t.default.createElement("circle", {
      style: R,
      cx: "13.93",
      cy: "6.91",
      r: "1.71"
    }), /* @__PURE__ */ t.default.createElement("circle", {
      style: R,
      cx: "5.8",
      cy: "7.55",
      r: "1.71"
    }), /* @__PURE__ */ t.default.createElement("circle", {
      style: R,
      cx: "5.45",
      cy: "12.04",
      r: "1.71"
    }), /* @__PURE__ */ t.default.createElement("path", {
      style: X,
      d: "M19.1,10c0,3.58-2.12,2.94-4.06,2.35-1.15-.34-2.24-.67-2.77-.08-.68.78-.54,2.07-.39,3.33.2,1.79.39,3.5-1.88,3.5A9.1,9.1,0,1,1,19.1,10ZM10,18c.7,0,.74-.19.75-.2a2.67,2.67,0,0,0,.07-1.27c0-.19,0-.42-.06-.67-.06-.53-.13-1.15-.14-1.67a3.82,3.82,0,0,1,.8-2.63,2.14,2.14,0,0,1,1.45-.7,4.36,4.36,0,0,1,1.32.12c.39.08.8.21,1.16.32h0c.39.12.74.23,1.08.3.74.17,1,.1,1.13,0S18,11.32,18,10a8,8,0,1,0-8,8Z"
    }));
  };
  e.PaletteIcon = w;
  var P = function(T) {
    var A = T.color, y = A || "#323136", R = {
      fill: "none",
      stroke: y,
      strokeMiterlimit: 10,
      strokeWidth: "1.8px",
      strokeLinecap: "round"
    };
    return /* @__PURE__ */ t.default.createElement("svg", {
      id: "Layer_1",
      "data-name": "Layer 1",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      style: {
        width: 15
      }
    }, /* @__PURE__ */ t.default.createElement("polyline", {
      style: R,
      points: "13.86 2.01 1.7 16.99 18.77 16.99"
    }), /* @__PURE__ */ t.default.createElement("polyline", {
      style: R,
      points: "10.96 16.38 10.96 16.38 10.74 15.7 10.44 14.97 10.06 14.21 9.72 13.63 9.21 12.89 8.85 12.44 8.41 11.95 7.91 11.45 7.51 11.1"
    }));
  };
  e.DegreesIcon = P;
  var L = function() {
    return /* @__PURE__ */ t.default.createElement("svg", {
      id: "Layer_1",
      "data-name": "Layer 1",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      style: {
        width: 20,
        marginRight: 1
      }
    }, /* @__PURE__ */ t.default.createElement("path", {
      d: "M2.39,8c-.63,0-1,.21-1,.63A.49.49,0,0,0,1.67,9a6.48,6.48,0,0,0,1.11.43A3,3,0,0,1,4,10.09a1.47,1.47,0,0,1,.35,1.09,1.75,1.75,0,0,1-.57,1.42,2.21,2.21,0,0,1-1.48.48,8.32,8.32,0,0,1-1.68-.21l-.31-.06.12-.94a13.7,13.7,0,0,0,1.8.16c.61,0,.92-.26.92-.77a.52.52,0,0,0-.21-.44,3.13,3.13,0,0,0-.85-.34A3.32,3.32,0,0,1,.66,9.79a1.43,1.43,0,0,1-.42-1.1A1.6,1.6,0,0,1,.78,7.36a2.32,2.32,0,0,1,1.49-.44,10.46,10.46,0,0,1,1.64.17l.32.07-.1.95C3.31,8,2.73,8,2.39,8Z"
    }), /* @__PURE__ */ t.default.createElement("path", {
      d: "M4.79,8.09V7H9.16V8.09H7.59V13H6.38V8.09Z"
    }), /* @__PURE__ */ t.default.createElement("path", {
      d: "M14,12.34a2.25,2.25,0,0,1-1.91.74,2.24,2.24,0,0,1-1.91-.74A3.85,3.85,0,0,1,9.61,10a4,4,0,0,1,.56-2.34,2.2,2.2,0,0,1,1.91-.77A2.21,2.21,0,0,1,14,7.69,4,4,0,0,1,14.55,10,3.85,3.85,0,0,1,14,12.34Zm-2.88-.77a1,1,0,0,0,1,.46,1,1,0,0,0,1-.46A3.25,3.25,0,0,0,13.3,10,3.45,3.45,0,0,0,13,8.46a1,1,0,0,0-1-.49,1,1,0,0,0-1,.49A3.43,3.43,0,0,0,10.85,10,3.38,3.38,0,0,0,11.11,11.57Z"
    }), /* @__PURE__ */ t.default.createElement("path", {
      d: "M17.77,11.24h-1V13H15.58V7h2.19a1.85,1.85,0,0,1,2.11,2.07,2.21,2.21,0,0,1-.54,1.6A2.07,2.07,0,0,1,17.77,11.24Zm-1-1h1c.6,0,.9-.37.9-1.12a1.18,1.18,0,0,0-.22-.79.88.88,0,0,0-.68-.24h-1Z"
    }));
  };
  e.StopIcon = L;
})(Zt);
var Dt = {}, Vr = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = we, a = la;
  function v(L, I) {
    return z(L) || E(L, I) || S(L, I) || p();
  }
  function p() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function S(L, I) {
    if (L) {
      if (typeof L == "string")
        return j(L, I);
      var T = Object.prototype.toString.call(L).slice(8, -1);
      if (T === "Object" && L.constructor && (T = L.constructor.name), T === "Map" || T === "Set")
        return Array.from(L);
      if (T === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(T))
        return j(L, I);
    }
  }
  function j(L, I) {
    (I == null || I > L.length) && (I = L.length);
    for (var T = 0, A = new Array(I); T < I; T++)
      A[T] = L[T];
    return A;
  }
  function E(L, I) {
    var T = L == null ? null : typeof Symbol < "u" && L[Symbol.iterator] || L["@@iterator"];
    if (T != null) {
      var A, y, R, X, Q = [], U = !0, b = !1;
      try {
        if (R = (T = T.call(L)).next, I === 0) {
          if (Object(T) !== T)
            return;
          U = !1;
        } else
          for (; !(U = (A = R.call(T)).done) && (Q.push(A.value), Q.length !== I); U = !0)
            ;
      } catch (C) {
        b = !0, y = C;
      } finally {
        try {
          if (!U && T.return != null && (X = T.return(), Object(X) !== X))
            return;
        } finally {
          if (b)
            throw y;
        }
      }
      return Q;
    }
  }
  function z(L) {
    if (Array.isArray(L))
      return L;
  }
  var w = function(I) {
    var T = I.children, A = "id" + Math.random().toString(16).slice(2), y = (0, t.useRef)(document.getElementById(A) || document.createElement("div")), R = (0, t.useState)(!y.current.parentElement), X = v(R, 1), Q = X[0];
    return (0, t.useEffect)(function() {
      var U = y.current;
      return Q && (y.current.id = A, document.body.appendChild(y.current)), function() {
        Q && U.parentElement && U.parentElement.removeChild(U);
      };
    }, [A]), /* @__PURE__ */ (0, a.createPortal)(T, y.current);
  }, P = /* @__PURE__ */ (0, t.memo)(w);
  e.default = P;
})(Vr);
const Va = /* @__PURE__ */ Un(ua);
var xr;
function Ua() {
  return xr || (xr = 1, function(e) {
    function t(r) {
      "@babel/helpers - typeof";
      return t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o) {
        return typeof o;
      } : function(o) {
        return o && typeof Symbol == "function" && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
      }, t(r);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var a = z(we), v = j(Vr), p = j(Va), S = Jt();
    function j(r) {
      return r && r.__esModule ? r : { default: r };
    }
    function E(r) {
      if (typeof WeakMap != "function")
        return null;
      var o = /* @__PURE__ */ new WeakMap(), s = /* @__PURE__ */ new WeakMap();
      return (E = function(f) {
        return f ? s : o;
      })(r);
    }
    function z(r, o) {
      if (!o && r && r.__esModule)
        return r;
      if (r === null || t(r) !== "object" && typeof r != "function")
        return { default: r };
      var s = E(o);
      if (s && s.has(r))
        return s.get(r);
      var x = {}, f = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var _ in r)
        if (_ !== "default" && Object.prototype.hasOwnProperty.call(r, _)) {
          var d = f ? Object.getOwnPropertyDescriptor(r, _) : null;
          d && (d.get || d.set) ? Object.defineProperty(x, _, d) : x[_] = r[_];
        }
      return x.default = r, s && s.set(r, x), x;
    }
    function w(r, o) {
      var s = Object.keys(r);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(r);
        o && (x = x.filter(function(f) {
          return Object.getOwnPropertyDescriptor(r, f).enumerable;
        })), s.push.apply(s, x);
      }
      return s;
    }
    function P(r) {
      for (var o = 1; o < arguments.length; o++) {
        var s = arguments[o] != null ? arguments[o] : {};
        o % 2 ? w(Object(s), !0).forEach(function(x) {
          L(r, x, s[x]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(s)) : w(Object(s)).forEach(function(x) {
          Object.defineProperty(r, x, Object.getOwnPropertyDescriptor(s, x));
        });
      }
      return r;
    }
    function L(r, o, s) {
      return o = I(o), o in r ? Object.defineProperty(r, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : r[o] = s, r;
    }
    function I(r) {
      var o = T(r, "string");
      return t(o) === "symbol" ? o : String(o);
    }
    function T(r, o) {
      if (t(r) !== "object" || r === null)
        return r;
      var s = r[Symbol.toPrimitive];
      if (s !== void 0) {
        var x = s.call(r, o || "default");
        if (t(x) !== "object")
          return x;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (o === "string" ? String : Number)(r);
    }
    function A(r, o) {
      return U(r) || Q(r, o) || R(r, o) || y();
    }
    function y() {
      throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    function R(r, o) {
      if (r) {
        if (typeof r == "string")
          return X(r, o);
        var s = Object.prototype.toString.call(r).slice(8, -1);
        if (s === "Object" && r.constructor && (s = r.constructor.name), s === "Map" || s === "Set")
          return Array.from(r);
        if (s === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(s))
          return X(r, o);
      }
    }
    function X(r, o) {
      (o == null || o > r.length) && (o = r.length);
      for (var s = 0, x = new Array(o); s < o; s++)
        x[s] = r[s];
      return x;
    }
    function Q(r, o) {
      var s = r == null ? null : typeof Symbol < "u" && r[Symbol.iterator] || r["@@iterator"];
      if (s != null) {
        var x, f, _, d, u = [], h = !0, O = !1;
        try {
          if (_ = (s = s.call(r)).next, o === 0) {
            if (Object(s) !== s)
              return;
            h = !1;
          } else
            for (; !(h = (x = _.call(s)).done) && (u.push(x.value), u.length !== o); h = !0)
              ;
        } catch (M) {
          O = !0, f = M;
        } finally {
          try {
            if (!h && s.return != null && (d = s.return(), Object(d) !== d))
              return;
          } finally {
            if (O)
              throw f;
          }
        }
        return u;
      }
    }
    function U(r) {
      if (Array.isArray(r))
        return r;
    }
    var b = Fe, C = function(o) {
      var s = o.color, x = s || "#323136", f = {
        fill: "none",
        stroke: x,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.4px"
      }, _ = {
        fill: x,
        stroke: x,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.4px"
      };
      return /* @__PURE__ */ a.default.createElement("svg", {
        id: "Layer_1",
        "data-name": "Layer 1",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        style: {
          width: 16
        }
      }, /* @__PURE__ */ a.default.createElement("path", {
        style: f,
        d: "M15.6,7h0L7.78,14.86c-.37.37-1.61.38-2,.75s-.5,1.53-.76,2a3.53,3.53,0,0,1-.52.52,1.6,1.6,0,0,1-2.27-.06l-.32-.32a1.61,1.61,0,0,1-.06-2.27A3.25,3.25,0,0,1,2.4,15c.47-.26,1.65-.35,2-.73s.34-1.64.71-2c1.68-1.73,5.61-5.65,7.91-7.93h0l1.14,1.38L15.6,7Z"
      }), /* @__PURE__ */ a.default.createElement("polygon", {
        style: _,
        points: "15.7 8.87 11.13 4.29 12.69 2.73 17.25 7.31 15.7 8.87"
      }), /* @__PURE__ */ a.default.createElement("path", {
        style: _,
        d: "M18.18,3.71,16.36,5.53a1.33,1.33,0,0,1-1.88,0h0a1.34,1.34,0,0,1,0-1.89l1.81-1.82a1.34,1.34,0,0,1,1.89,0h0A1.34,1.34,0,0,1,18.18,3.71Z"
      }));
    }, i = function(o) {
      var s = o.onSelect, x = o.buttonStyle, f = (0, a.useState)(""), _ = A(f, 2), d = _[0], u = _[1], h = (0, a.useState)(!1), O = A(h, 2), M = O[0], q = O[1], W = function() {
        var $ = document.getElementById("root");
        q(!0), (0, p.default)($).then(function(D) {
          var Y = document.createElement("canvas"), ee = Y.getContext("2d", {
            willReadFrequently: !0
          });
          Y.width = $.offsetWidth * 2, Y.height = $.offsetHeight * 2, ee.drawImage(D, 0, 0), u(ee);
        });
      }, Z = function($) {
        $.stopPropagation();
        var D = $.pageX, Y = $.pageY, ee = D * 2, ne = Y * 2, ae = A(d.getImageData(ee, ne, 1, 1).data, 3), N = ae[0], te = ae[1], fe = ae[2];
        s("rgba(".concat(N, ", ").concat(te, ", ").concat(fe, ", 1)")), q(!1);
      }, K = function() {
        if (!window.EyeDropper)
          W();
        else {
          var $ = new window.EyeDropper(), D = new window.AbortController();
          $.open({
            signal: D.signal
          }).then(function(Y) {
            var ee = b(Y.sRGBHex), ne = ee.toRgb(), ae = ne.r, N = ne.g, te = ne.b;
            s("rgba(".concat(ae, ", ").concat(N, ", ").concat(te, ", 1)"));
          }).catch(function(Y) {
            console.log(Y);
          });
        }
      };
      return /* @__PURE__ */ a.default.createElement("div", null, /* @__PURE__ */ a.default.createElement("div", {
        style: P(P({}, x), (0, S.controlBtnStyles)(M)),
        onClick: K
      }, /* @__PURE__ */ a.default.createElement(C, {
        color: M ? "rgb(86, 140, 245)" : ""
      })), M && /* @__PURE__ */ a.default.createElement(v.default, {
        id: "eyeDropCover"
      }, /* @__PURE__ */ a.default.createElement("div", {
        style: {
          position: "fixed",
          left: 0,
          top: 0,
          zIndex: 1e8,
          width: window.innerWidth,
          height: window.innerHeight,
          cursor: "copy"
        },
        onClick: function($) {
          return Z($);
        }
      })));
    }, n = i;
    e.default = n;
  }(Dt)), Dt;
}
var Ur = {};
(function(e) {
  function t(r) {
    "@babel/helpers - typeof";
    return t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o) {
      return typeof o;
    } : function(o) {
      return o && typeof Symbol == "function" && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, t(r);
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = z(we), v = Te, p = dt(), S = Xt, j = ue;
  function E(r) {
    if (typeof WeakMap != "function")
      return null;
    var o = /* @__PURE__ */ new WeakMap(), s = /* @__PURE__ */ new WeakMap();
    return (E = function(f) {
      return f ? s : o;
    })(r);
  }
  function z(r, o) {
    if (!o && r && r.__esModule)
      return r;
    if (r === null || t(r) !== "object" && typeof r != "function")
      return { default: r };
    var s = E(o);
    if (s && s.has(r))
      return s.get(r);
    var x = {}, f = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var _ in r)
      if (_ !== "default" && Object.prototype.hasOwnProperty.call(r, _)) {
        var d = f ? Object.getOwnPropertyDescriptor(r, _) : null;
        d && (d.get || d.set) ? Object.defineProperty(x, _, d) : x[_] = r[_];
      }
    return x.default = r, s && s.set(r, x), x;
  }
  function w(r, o) {
    var s = Object.keys(r);
    if (Object.getOwnPropertySymbols) {
      var x = Object.getOwnPropertySymbols(r);
      o && (x = x.filter(function(f) {
        return Object.getOwnPropertyDescriptor(r, f).enumerable;
      })), s.push.apply(s, x);
    }
    return s;
  }
  function P(r) {
    for (var o = 1; o < arguments.length; o++) {
      var s = arguments[o] != null ? arguments[o] : {};
      o % 2 ? w(Object(s), !0).forEach(function(x) {
        L(r, x, s[x]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(s)) : w(Object(s)).forEach(function(x) {
        Object.defineProperty(r, x, Object.getOwnPropertyDescriptor(s, x));
      });
    }
    return r;
  }
  function L(r, o, s) {
    return o = I(o), o in r ? Object.defineProperty(r, o, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : r[o] = s, r;
  }
  function I(r) {
    var o = T(r, "string");
    return t(o) === "symbol" ? o : String(o);
  }
  function T(r, o) {
    if (t(r) !== "object" || r === null)
      return r;
    var s = r[Symbol.toPrimitive];
    if (s !== void 0) {
      var x = s.call(r, o || "default");
      if (t(x) !== "object")
        return x;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (o === "string" ? String : Number)(r);
  }
  function A(r, o) {
    return U(r) || Q(r, o) || R(r, o) || y();
  }
  function y() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function R(r, o) {
    if (r) {
      if (typeof r == "string")
        return X(r, o);
      var s = Object.prototype.toString.call(r).slice(8, -1);
      if (s === "Object" && r.constructor && (s = r.constructor.name), s === "Map" || s === "Set")
        return Array.from(r);
      if (s === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(s))
        return X(r, o);
    }
  }
  function X(r, o) {
    (o == null || o > r.length) && (o = r.length);
    for (var s = 0, x = new Array(o); s < o; s++)
      x[s] = r[s];
    return x;
  }
  function Q(r, o) {
    var s = r == null ? null : typeof Symbol < "u" && r[Symbol.iterator] || r["@@iterator"];
    if (s != null) {
      var x, f, _, d, u = [], h = !0, O = !1;
      try {
        if (_ = (s = s.call(r)).next, o === 0) {
          if (Object(s) !== s)
            return;
          h = !1;
        } else
          for (; !(h = (x = _.call(s)).done) && (u.push(x.value), u.length !== o); h = !0)
            ;
      } catch (M) {
        O = !0, f = M;
      } finally {
        try {
          if (!h && s.return != null && (d = s.return(), Object(d) !== d))
            return;
        } finally {
          if (O)
            throw f;
        }
      }
      return u;
    }
  }
  function U(r) {
    if (Array.isArray(r))
      return r;
  }
  var b = Fe, C = function(o) {
    var s = o.openAdvanced, x = (0, v.usePicker)(), f = x.tinyColor, _ = x.hue, d = x.l, u = x.handleChange, h = x.s, O = x.opacity, M = x.squareSize, q = f.toHsv(), W = q.v, Z = q.s, K = (0, a.useRef)(null), J = (0, a.useRef)(null), $ = (0, a.useRef)(null);
    (0, S.usePaintSat)(K, _, d * 100, M), (0, S.usePaintLight)(J, _, h * 100, M), (0, S.usePaintBright)($, _, h * 100, M);
    var D = function(ae) {
      var N = b({
        h: _,
        s: ae / 100,
        l: d
      }).toRgb(), te = N.r, fe = N.g, l = N.b;
      u("rgba(".concat(te, ",").concat(fe, ",").concat(l, ",").concat(O, ")"));
    }, Y = function(ae) {
      var N = b({
        h: _,
        s: h,
        l: ae / 100
      }).toRgb(), te = N.r, fe = N.g, l = N.b;
      u("rgba(".concat(te, ",").concat(fe, ",").concat(l, ",").concat(O, ")"));
    }, ee = function(ae) {
      var N = b({
        h: _,
        s: Z * 100,
        v: ae
      }).toRgb(), te = N.r, fe = N.g, l = N.b;
      u("rgba(".concat(te, ",").concat(fe, ",").concat(l, ",").concat(O, ")"));
    };
    return /* @__PURE__ */ a.default.createElement("div", {
      style: {
        height: s ? 98 : 0,
        width: "100%",
        transition: "all 120ms linear"
      }
    }, /* @__PURE__ */ a.default.createElement("div", {
      style: {
        paddingTop: 11,
        display: s ? "" : "none"
      }
    }, /* @__PURE__ */ a.default.createElement(n, {
      value: h,
      reffy: K,
      callback: D,
      openAdvanced: s,
      label: "Saturation"
    }), /* @__PURE__ */ a.default.createElement(n, {
      value: d,
      reffy: J,
      label: "Lightness",
      callback: Y,
      openAdvanced: s
    }), /* @__PURE__ */ a.default.createElement(n, {
      value: W,
      reffy: $,
      label: "Brightness",
      callback: ee,
      openAdvanced: s
    })));
  }, i = C;
  e.default = i;
  var n = function(o) {
    var s = o.value, x = o.callback, f = o.reffy, _ = o.openAdvanced, d = o.label, u = (0, v.usePicker)(), h = u.squareSize, O = (0, a.useState)(!1), M = A(O, 2), q = M[0], W = M[1], Z = (0, a.useState)(2), K = A(Z, 2), J = K[0], $ = K[1], D = s * (h - 18);
    (0, a.useEffect)(function() {
      var N;
      $((f == null || (N = f.current) === null || N === void 0 ? void 0 : N.offsetTop) - 2);
    }, [_, f]);
    var Y = function() {
      W(!1);
    }, ee = function(te) {
      q && x((0, p.getHandleValue)(te));
    }, ne = function(te) {
      q || x((0, p.getHandleValue)(te));
    }, ae = function() {
      W(!0);
    };
    return (0, a.useEffect)(function() {
      var N = function() {
        Y();
      };
      return window.addEventListener("mouseup", N), function() {
        window.removeEventListener("mouseup", N);
      };
    }, []), /* @__PURE__ */ a.default.createElement("div", {
      style: P(P({}, j.borderBox), {}, {
        width: "100%",
        padding: "3px 0px 3px 0px"
      })
    }, /* @__PURE__ */ a.default.createElement("div", {
      className: "c-resize ps-rl",
      onMouseMove: function(te) {
        return ee(te);
      },
      style: P(P({}, j.cResize), j.psRl)
    }, /* @__PURE__ */ a.default.createElement("div", {
      style: P(P({}, j.handle), {}, {
        left: D,
        top: J
      }),
      onMouseDown: ae
    }), /* @__PURE__ */ a.default.createElement("div", {
      style: {
        textAlign: "center",
        color: "#fff",
        fontSize: 12,
        fontWeight: 500,
        lineHeight: 1,
        position: "absolute",
        left: "50%",
        transform: "translate(-50%, 0%)",
        top: J + 2,
        zIndex: 10,
        textShadow: "1px 1px 1px rgba(0,0,0,.6)"
      },
      onMouseMove: function(te) {
        return ee(te);
      },
      onClick: function(te) {
        return ne(te);
      }
    }, d), /* @__PURE__ */ a.default.createElement("canvas", {
      ref: f,
      width: "".concat(h, "px"),
      height: "14px",
      style: {
        position: "relative",
        borderRadius: 14
      },
      onClick: function(te) {
        return ne(te);
      }
    })));
  };
})(Ur);
var Kr = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = p(we), a = Te, v = ue;
  function p(T) {
    return T && T.__esModule ? T : { default: T };
  }
  function S(T) {
    "@babel/helpers - typeof";
    return S = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(A) {
      return typeof A;
    } : function(A) {
      return A && typeof Symbol == "function" && A.constructor === Symbol && A !== Symbol.prototype ? "symbol" : typeof A;
    }, S(T);
  }
  function j(T, A) {
    var y = Object.keys(T);
    if (Object.getOwnPropertySymbols) {
      var R = Object.getOwnPropertySymbols(T);
      A && (R = R.filter(function(X) {
        return Object.getOwnPropertyDescriptor(T, X).enumerable;
      })), y.push.apply(y, R);
    }
    return y;
  }
  function E(T) {
    for (var A = 1; A < arguments.length; A++) {
      var y = arguments[A] != null ? arguments[A] : {};
      A % 2 ? j(Object(y), !0).forEach(function(R) {
        z(T, R, y[R]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(T, Object.getOwnPropertyDescriptors(y)) : j(Object(y)).forEach(function(R) {
        Object.defineProperty(T, R, Object.getOwnPropertyDescriptor(y, R));
      });
    }
    return T;
  }
  function z(T, A, y) {
    return A = w(A), A in T ? Object.defineProperty(T, A, { value: y, enumerable: !0, configurable: !0, writable: !0 }) : T[A] = y, T;
  }
  function w(T) {
    var A = P(T, "string");
    return S(A) === "symbol" ? A : String(A);
  }
  function P(T, A) {
    if (S(T) !== "object" || T === null)
      return T;
    var y = T[Symbol.toPrimitive];
    if (y !== void 0) {
      var R = y.call(T, A || "default");
      if (S(R) !== "object")
        return R;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (A === "string" ? String : Number)(T);
  }
  var L = function(A) {
    var y = A.openComparibles, R = (0, a.usePicker)(), X = R.tinyColor, Q = R.handleChange, U = X.analogous(), b = X.monochromatic(), C = X.triad(), i = X.tetrad(), n = function(o) {
      var s = o.toRgb(), x = s.r, f = s.g, _ = s.b, d = s.a;
      Q("rgba(".concat(x, ",").concat(f, ",").concat(_, ",").concat(d, ")"));
    };
    return /* @__PURE__ */ t.default.createElement("div", {
      style: {
        height: y ? 216 : 0,
        width: "100%",
        transition: "all 120ms linear"
      }
    }, /* @__PURE__ */ t.default.createElement("div", {
      style: E({
        paddingTop: 11,
        display: y ? "" : "none"
      }, v.psRl)
    }, /* @__PURE__ */ t.default.createElement("div", {
      style: {
        textAlign: "center",
        color: "#323136",
        fontSize: 13,
        fontWeight: 600,
        position: "absolute",
        top: 6.5,
        left: 2
      }
    }, "Color Guide"), /* @__PURE__ */ t.default.createElement("div", {
      style: {
        textAlign: "center",
        color: "#323136",
        fontSize: 12,
        fontWeight: 500,
        marginTop: 3
      }
    }, "Analogous"), /* @__PURE__ */ t.default.createElement("div", {
      style: E({
        borderRadius: 5,
        overflow: "hidden"
      }, v.df)
    }, U == null ? void 0 : U.map(function(r, o) {
      return /* @__PURE__ */ t.default.createElement("div", {
        key: o,
        style: {
          width: "20%",
          height: 30,
          background: r.toHexString()
        },
        onClick: function() {
          return n(r);
        }
      });
    })), /* @__PURE__ */ t.default.createElement("div", {
      style: {
        textAlign: "center",
        color: "#323136",
        fontSize: 12,
        fontWeight: 500,
        marginTop: 3
      }
    }, "Monochromatic"), /* @__PURE__ */ t.default.createElement("div", {
      style: E(E({
        borderRadius: 5,
        overflow: "hidden"
      }, v.df), v.jfe)
    }, b == null ? void 0 : b.map(function(r, o) {
      return /* @__PURE__ */ t.default.createElement("div", {
        key: o,
        style: {
          width: "20%",
          height: 30,
          background: r.toHexString()
        },
        onClick: function() {
          return n(r);
        }
      });
    })), /* @__PURE__ */ t.default.createElement("div", {
      style: {
        textAlign: "center",
        color: "#323136",
        fontSize: 12,
        fontWeight: 500,
        marginTop: 3
      }
    }, "Triad"), /* @__PURE__ */ t.default.createElement("div", {
      style: E(E({
        borderRadius: 5,
        overflow: "hidden"
      }, v.df), v.jfe)
    }, C == null ? void 0 : C.map(function(r, o) {
      return /* @__PURE__ */ t.default.createElement("div", {
        key: o,
        style: {
          width: "calc(100% / 3)",
          height: 28,
          background: r.toHexString()
        },
        onClick: function() {
          return n(r);
        }
      });
    })), /* @__PURE__ */ t.default.createElement("div", {
      style: {
        textAlign: "center",
        color: "#323136",
        fontSize: 12,
        fontWeight: 500,
        marginTop: 3
      }
    }, "Tetrad"), /* @__PURE__ */ t.default.createElement("div", {
      style: E(E({
        borderRadius: 5,
        overflow: "hidden"
      }, v.df), v.jfe)
    }, i == null ? void 0 : i.map(function(r, o) {
      return /* @__PURE__ */ t.default.createElement("div", {
        key: o,
        style: {
          width: "25%",
          height: 28,
          background: r.toHexString()
        },
        onClick: function() {
          return n(r);
        }
      });
    }))));
  }, I = L;
  e.default = I;
})(Kr);
var Mt = {}, Or;
function Ka() {
  return Or || (Or = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var t = w(we), a = Te, v = Xe(), p = Jt(), S = z(Zt), j = ue;
    function E(i) {
      if (typeof WeakMap != "function")
        return null;
      var n = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
      return (E = function(s) {
        return s ? r : n;
      })(i);
    }
    function z(i, n) {
      if (!n && i && i.__esModule)
        return i;
      if (i === null || P(i) !== "object" && typeof i != "function")
        return { default: i };
      var r = E(n);
      if (r && r.has(i))
        return r.get(i);
      var o = {}, s = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var x in i)
        if (x !== "default" && Object.prototype.hasOwnProperty.call(i, x)) {
          var f = s ? Object.getOwnPropertyDescriptor(i, x) : null;
          f && (f.get || f.set) ? Object.defineProperty(o, x, f) : o[x] = i[x];
        }
      return o.default = i, r && r.set(i, o), o;
    }
    function w(i) {
      return i && i.__esModule ? i : { default: i };
    }
    function P(i) {
      "@babel/helpers - typeof";
      return P = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
        return typeof n;
      } : function(n) {
        return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
      }, P(i);
    }
    function L(i, n) {
      var r = Object.keys(i);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(i);
        n && (o = o.filter(function(s) {
          return Object.getOwnPropertyDescriptor(i, s).enumerable;
        })), r.push.apply(r, o);
      }
      return r;
    }
    function I(i) {
      for (var n = 1; n < arguments.length; n++) {
        var r = arguments[n] != null ? arguments[n] : {};
        n % 2 ? L(Object(r), !0).forEach(function(o) {
          T(i, o, r[o]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(i, Object.getOwnPropertyDescriptors(r)) : L(Object(r)).forEach(function(o) {
          Object.defineProperty(i, o, Object.getOwnPropertyDescriptor(r, o));
        });
      }
      return i;
    }
    function T(i, n, r) {
      return n = A(n), n in i ? Object.defineProperty(i, n, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : i[n] = r, i;
    }
    function A(i) {
      var n = y(i, "string");
      return P(n) === "symbol" ? n : String(n);
    }
    function y(i, n) {
      if (P(i) !== "object" || i === null)
        return i;
      var r = i[Symbol.toPrimitive];
      if (r !== void 0) {
        var o = r.call(i, n || "default");
        if (P(o) !== "object")
          return o;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (n === "string" ? String : Number)(i);
    }
    var R = function(n) {
      var r = n.hideGradientType, o = n.hideGradientAngle, s = n.hideGradientStop, x = (0, a.usePicker)(), f = x.gradientType;
      return /* @__PURE__ */ t.default.createElement("div", {
        style: I(I(I(I({}, j.df), j.jsb), {}, {
          marginTop: 12,
          marginBottom: -4,
          background: "#e9e9f5",
          borderRadius: 6
        }, j.borderBox), {}, {
          paddingLeft: r ? 4 : 0
        })
      }, !r && /* @__PURE__ */ t.default.createElement(Q, null), /* @__PURE__ */ t.default.createElement("div", {
        style: {
          width: 53
        }
      }, !o && f === "linear-gradient" && /* @__PURE__ */ t.default.createElement(b, null)), !s && /* @__PURE__ */ t.default.createElement(U, null), /* @__PURE__ */ t.default.createElement(C, null));
    }, X = R;
    e.default = X;
    var Q = function() {
      var n = (0, a.usePicker)(), r = n.gradientType, o = n.internalOnChange, s = n.value, x = r === "linear-gradient", f = r === "radial-gradient", _ = function() {
        var h = s.split(/,(.+)/)[1];
        o("linear-gradient(90deg, ".concat(h));
      }, d = function() {
        var h = s.split(/,(.+)/)[1];
        o("radial-gradient(circle, ".concat(h));
      };
      return /* @__PURE__ */ t.default.createElement("div", {
        style: I(I(I(I({}, j.df), j.ac), j.controlBtnsWrap), j.borderBox)
      }, /* @__PURE__ */ t.default.createElement("div", {
        onClick: _,
        style: I(I({}, j.controlBtn), (0, p.controlBtnStyles)(x))
      }, /* @__PURE__ */ t.default.createElement(S.LinearIcon, {
        color: x ? "#568CF5" : ""
      })), /* @__PURE__ */ t.default.createElement("div", {
        onClick: d,
        style: I(I({}, j.controlBtn), (0, p.controlBtnStyles)(f))
      }, /* @__PURE__ */ t.default.createElement(S.RadialIcon, {
        color: f ? "#568CF5" : ""
      })));
    }, U = function() {
      var n = (0, a.usePicker)(), r = n.currentLeft, o = n.handleGradient, s = n.currentColor, x = function(_) {
        o(s, (0, v.formatInputValues)(_, 0, 100));
      };
      return /* @__PURE__ */ t.default.createElement("div", {
        style: I(I(I(I({}, j.df), j.ac), j.controlBtnsWrap), {}, {
          paddingLeft: 8
        })
      }, /* @__PURE__ */ t.default.createElement(S.StopIcon, null), /* @__PURE__ */ t.default.createElement("input", {
        id: "rbgcp-input",
        style: j.degreeInput,
        value: r,
        onChange: function(_) {
          return x(_.target.value || 0);
        }
      }));
    }, b = function() {
      var n = (0, a.usePicker)(), r = n.degrees, o = n.internalOnChange, s = n.value, x = function(_) {
        var d = (0, v.formatInputValues)(_.target.value, 0, 360), u = s.split(/,(.+)/)[1];
        o("linear-gradient(".concat(d || 0, "deg, ").concat(u));
      };
      return /* @__PURE__ */ t.default.createElement("div", {
        style: I(I(I(I({}, j.psRl), j.controlBtnsWrap), j.df), j.ac)
      }, /* @__PURE__ */ t.default.createElement(S.DegreesIcon, null), /* @__PURE__ */ t.default.createElement("input", {
        id: "rbgcp-input",
        style: j.degreeInput,
        value: r,
        onChange: function(_) {
          return x(_);
        }
      }), /* @__PURE__ */ t.default.createElement("div", {
        style: {
          position: "absolute",
          right: r > 99 ? 0 : r < 10 ? 7 : 3,
          top: 1,
          fontWeight: 400,
          fontSize: 13
        }
      }, "°"));
    }, C = function() {
      var n = (0, a.usePicker)(), r = n.deletePoint;
      return /* @__PURE__ */ t.default.createElement("div", {
        onClick: r,
        style: I(I(I(I(I(I({}, j.df), j.jc), j.ac), j.controlBtnsWrap), {}, {
          width: 30
        }, (0, p.controlBtnStyles)(!1)), {}, {
          marginRight: 1
        })
      }, /* @__PURE__ */ t.default.createElement(S.default, null));
    };
  }(Mt)), Mt;
}
var Pr;
function Jt() {
  return Pr || (Pr = 1, function(e) {
    function t(u) {
      "@babel/helpers - typeof";
      return t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(h) {
        return typeof h;
      } : function(h) {
        return h && typeof Symbol == "function" && h.constructor === Symbol && h !== Symbol.prototype ? "symbol" : typeof h;
      }, t(u);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = e.controlBtnStyles = void 0;
    var a = T(we), v = Zt, p = Te, S = L(Ua()), j = ze, E = L(Ur), z = L(Kr), w = L(Ka()), P = ue;
    function L(u) {
      return u && u.__esModule ? u : { default: u };
    }
    function I(u) {
      if (typeof WeakMap != "function")
        return null;
      var h = /* @__PURE__ */ new WeakMap(), O = /* @__PURE__ */ new WeakMap();
      return (I = function(q) {
        return q ? O : h;
      })(u);
    }
    function T(u, h) {
      if (!h && u && u.__esModule)
        return u;
      if (u === null || t(u) !== "object" && typeof u != "function")
        return { default: u };
      var O = I(h);
      if (O && O.has(u))
        return O.get(u);
      var M = {}, q = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var W in u)
        if (W !== "default" && Object.prototype.hasOwnProperty.call(u, W)) {
          var Z = q ? Object.getOwnPropertyDescriptor(u, W) : null;
          Z && (Z.get || Z.set) ? Object.defineProperty(M, W, Z) : M[W] = u[W];
        }
      return M.default = u, O && O.set(u, M), M;
    }
    function A(u, h) {
      var O = Object.keys(u);
      if (Object.getOwnPropertySymbols) {
        var M = Object.getOwnPropertySymbols(u);
        h && (M = M.filter(function(q) {
          return Object.getOwnPropertyDescriptor(u, q).enumerable;
        })), O.push.apply(O, M);
      }
      return O;
    }
    function y(u) {
      for (var h = 1; h < arguments.length; h++) {
        var O = arguments[h] != null ? arguments[h] : {};
        h % 2 ? A(Object(O), !0).forEach(function(M) {
          R(u, M, O[M]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(u, Object.getOwnPropertyDescriptors(O)) : A(Object(O)).forEach(function(M) {
          Object.defineProperty(u, M, Object.getOwnPropertyDescriptor(O, M));
        });
      }
      return u;
    }
    function R(u, h, O) {
      return h = X(h), h in u ? Object.defineProperty(u, h, { value: O, enumerable: !0, configurable: !0, writable: !0 }) : u[h] = O, u;
    }
    function X(u) {
      var h = Q(u, "string");
      return t(h) === "symbol" ? h : String(h);
    }
    function Q(u, h) {
      if (t(u) !== "object" || u === null)
        return u;
      var O = u[Symbol.toPrimitive];
      if (O !== void 0) {
        var M = O.call(u, h || "default");
        if (t(M) !== "object")
          return M;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (h === "string" ? String : Number)(u);
    }
    function U(u, h) {
      return r(u) || n(u, h) || C(u, h) || b();
    }
    function b() {
      throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    function C(u, h) {
      if (u) {
        if (typeof u == "string")
          return i(u, h);
        var O = Object.prototype.toString.call(u).slice(8, -1);
        if (O === "Object" && u.constructor && (O = u.constructor.name), O === "Map" || O === "Set")
          return Array.from(u);
        if (O === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(O))
          return i(u, h);
      }
    }
    function i(u, h) {
      (h == null || h > u.length) && (h = u.length);
      for (var O = 0, M = new Array(h); O < h; O++)
        M[O] = u[O];
      return M;
    }
    function n(u, h) {
      var O = u == null ? null : typeof Symbol < "u" && u[Symbol.iterator] || u["@@iterator"];
      if (O != null) {
        var M, q, W, Z, K = [], J = !0, $ = !1;
        try {
          if (W = (O = O.call(u)).next, h === 0) {
            if (Object(O) !== O)
              return;
            J = !1;
          } else
            for (; !(J = (M = W.call(O)).done) && (K.push(M.value), K.length !== h); J = !0)
              ;
        } catch (D) {
          $ = !0, q = D;
        } finally {
          try {
            if (!J && O.return != null && (Z = O.return(), Object(Z) !== Z))
              return;
          } finally {
            if ($)
              throw q;
          }
        }
        return K;
      }
    }
    function r(u) {
      if (Array.isArray(u))
        return u;
    }
    var o = j.config.defaultColor, s = j.config.defaultGradient, x = function(h) {
      var O = h.hideEyeDrop, M = h.hideAdvancedSliders, q = h.hideColorGuide, W = h.hideInputType, Z = h.hideColorTypeBtns, K = h.hideGradientControls, J = h.hideGradientType, $ = h.hideGradientAngle, D = h.hideGradientStop, Y = (0, p.usePicker)(), ee = Y.isGradient, ne = Y.internalOnChange, ae = Y.previousColors, N = Y.previousGraidents, te = Y.handleChange, fe = (0, a.useState)(!1), l = U(fe, 2), g = l[0], c = l[1], B = (0, a.useState)(!1), H = U(B, 2), k = H[0], V = H[1], ie = (0, a.useState)(!1), re = U(ie, 2), ce = re[0], he = re[1], F = O && M && q && W, G = (ae == null ? void 0 : ae[0]) || o, oe = (N == null ? void 0 : N[0]) || s, le = function() {
        ne(G);
      }, se = function() {
        ne(oe);
      }, ge = O && M && q && W;
      return /* @__PURE__ */ a.default.createElement("div", {
        style: {
          paddingTop: 12,
          paddingBottom: 4
        }
      }, /* @__PURE__ */ a.default.createElement("div", {
        style: y(y(y({
          width: "100%"
        }, P.df), P.jsb), P.ac)
      }, /* @__PURE__ */ a.default.createElement("div", {
        style: y(y(y(y({
          height: 28,
          background: Z ? "" : "#e9e9f5",
          borderRadius: 6,
          padding: 2
        }, P.df), P.jc), P.ac), P.borderBox)
      }, !Z && /* @__PURE__ */ a.default.createElement(a.default.Fragment, null, /* @__PURE__ */ a.default.createElement("div", {
        style: y(y(y(y({}, P.controlBtn), d(!ee)), P.df), P.ac),
        onClick: le
      }, "Solid"), /* @__PURE__ */ a.default.createElement("div", {
        style: y(y(y(y({}, P.controlBtn), d(ee)), P.df), P.ac),
        onClick: se
      }, "Gradient"))), !ge && /* @__PURE__ */ a.default.createElement("div", {
        style: y(y(y(y({}, P.ac), P.jfe), {}, {
          height: 28,
          background: "#e9e9f5",
          borderRadius: 6,
          padding: 2,
          display: F ? "none" : ""
        }, P.df), P.borderBox)
      }, !O && /* @__PURE__ */ a.default.createElement(S.default, {
        onSelect: te,
        buttonStyle: {
          width: 30,
          height: 24,
          borderRadius: 4,
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }
      }), /* @__PURE__ */ a.default.createElement("div", {
        style: y(y(y({
          width: 30
        }, d(g)), {}, {
          height: 24,
          borderRadius: 4,
          display: M ? "none" : "flex"
        }, P.jc), P.ac),
        onClick: function() {
          return c(!g);
        }
      }, /* @__PURE__ */ a.default.createElement(v.SlidersIcon, {
        color: g ? "#568CF5" : ""
      })), /* @__PURE__ */ a.default.createElement("div", {
        style: y(y(y({
          width: 30
        }, d(k)), {}, {
          height: 24,
          borderRadius: 4,
          display: q ? "none" : "flex"
        }, P.jc), P.ac),
        onClick: function() {
          return V(!k);
        }
      }, /* @__PURE__ */ a.default.createElement(v.PaletteIcon, {
        color: k ? "#568CF5" : ""
      })), /* @__PURE__ */ a.default.createElement("div", {
        style: y(y(y(y({
          width: 30
        }, d(ce)), {}, {
          height: 24,
          borderRadius: 4,
          display: W ? "none" : "flex"
        }, P.jc), P.ac), P.psRl),
        onClick: function() {
          return he(!ce);
        }
      }, /* @__PURE__ */ a.default.createElement(v.InputsIcon, {
        color: ce ? "#568CF5" : ""
      }), /* @__PURE__ */ a.default.createElement(_, {
        openInputType: ce,
        setOpenInputType: he
      })))), !M && /* @__PURE__ */ a.default.createElement(E.default, {
        openAdvanced: g
      }), !q && /* @__PURE__ */ a.default.createElement(z.default, {
        openComparibles: k
      }), ee && !K && /* @__PURE__ */ a.default.createElement(w.default, {
        hideGradientType: J,
        hideGradientAngle: $,
        hideGradientStop: D
      }));
    }, f = x;
    e.default = f;
    var _ = function(h) {
      var O = h.openInputType, M = h.setOpenInputType, q = (0, p.usePicker)(), W = q.inputType, Z = q.setInputType, K = O ? "visibility 0ms linear" : "visibility 100ms linear 150ms", J = O ? "z-index 0ms linear" : "z-index 100ms linear 150ms", $ = O ? "opacity 120ms linear" : "opacity 150ms linear 50ms", D = function(ee, ne) {
        O && (ee.stopPropagation(), Z(ne), M(!1));
      };
      return /* @__PURE__ */ a.default.createElement("div", {
        style: y({
          visibility: O ? "visible" : "hidden",
          zIndex: O ? "" : -100,
          opacity: O ? 1 : 0,
          transition: "".concat($, ", ").concat(K, ", ").concat(J)
        }, P.inputDropdown)
      }, /* @__PURE__ */ a.default.createElement("div", {
        style: y(y(y(y(y({}, P.df), P.ac), P.psRl), P.controlBtn), d(W === "rgb")),
        onClick: function(ee) {
          return D(ee, "rgb");
        }
      }, "RGB"), /* @__PURE__ */ a.default.createElement("div", {
        style: y(y(y(y({}, P.df), P.ac), P.controlBtn), d(W === "hsl")),
        onClick: function(ee) {
          return D(ee, "hsl");
        }
      }, "HSL"), /* @__PURE__ */ a.default.createElement("div", {
        style: y(y(y(y({}, P.df), P.ac), P.controlBtn), d(W === "hsv")),
        onClick: function(ee) {
          return D(ee, "hsv");
        }
      }, "HSV"), /* @__PURE__ */ a.default.createElement("div", {
        style: y(y(y(y({}, P.df), P.ac), P.controlBtn), d(W === "cmyk")),
        onClick: function(ee) {
          return D(ee, "cmyk");
        }
      }, "CMYK"));
    }, d = function(h) {
      return {
        background: h ? "white" : "rgba(255,255,255,0)",
        color: h ? "#568CF5" : "rgb(86,86,86)",
        boxShadow: h ? "1px 1px 3px rgba(0,0,0,.2)" : "1px 1px 3px rgba(0,0,0,0)"
      };
    };
    e.controlBtnStyles = d;
  }(Rt)), Rt;
}
var Yr = {};
(function(e) {
  function t(n) {
    "@babel/helpers - typeof";
    return t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
      return typeof r;
    } : function(r) {
      return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
    }, t(n);
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = e.Handle = void 0;
  var a = E(we), v = dt(), p = Te, S = ue;
  function j(n) {
    if (typeof WeakMap != "function")
      return null;
    var r = /* @__PURE__ */ new WeakMap(), o = /* @__PURE__ */ new WeakMap();
    return (j = function(x) {
      return x ? o : r;
    })(n);
  }
  function E(n, r) {
    if (!r && n && n.__esModule)
      return n;
    if (n === null || t(n) !== "object" && typeof n != "function")
      return { default: n };
    var o = j(r);
    if (o && o.has(n))
      return o.get(n);
    var s = {}, x = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var f in n)
      if (f !== "default" && Object.prototype.hasOwnProperty.call(n, f)) {
        var _ = x ? Object.getOwnPropertyDescriptor(n, f) : null;
        _ && (_.get || _.set) ? Object.defineProperty(s, f, _) : s[f] = n[f];
      }
    return s.default = n, o && o.set(n, s), s;
  }
  function z(n, r) {
    var o = Object.keys(n);
    if (Object.getOwnPropertySymbols) {
      var s = Object.getOwnPropertySymbols(n);
      r && (s = s.filter(function(x) {
        return Object.getOwnPropertyDescriptor(n, x).enumerable;
      })), o.push.apply(o, s);
    }
    return o;
  }
  function w(n) {
    for (var r = 1; r < arguments.length; r++) {
      var o = arguments[r] != null ? arguments[r] : {};
      r % 2 ? z(Object(o), !0).forEach(function(s) {
        P(n, s, o[s]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(o)) : z(Object(o)).forEach(function(s) {
        Object.defineProperty(n, s, Object.getOwnPropertyDescriptor(o, s));
      });
    }
    return n;
  }
  function P(n, r, o) {
    return r = L(r), r in n ? Object.defineProperty(n, r, { value: o, enumerable: !0, configurable: !0, writable: !0 }) : n[r] = o, n;
  }
  function L(n) {
    var r = I(n, "string");
    return t(r) === "symbol" ? r : String(r);
  }
  function I(n, r) {
    if (t(n) !== "object" || n === null)
      return n;
    var o = n[Symbol.toPrimitive];
    if (o !== void 0) {
      var s = o.call(n, r || "default");
      if (t(s) !== "object")
        return s;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (r === "string" ? String : Number)(n);
  }
  function T(n, r) {
    return Q(n) || X(n, r) || y(n, r) || A();
  }
  function A() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function y(n, r) {
    if (n) {
      if (typeof n == "string")
        return R(n, r);
      var o = Object.prototype.toString.call(n).slice(8, -1);
      if (o === "Object" && n.constructor && (o = n.constructor.name), o === "Map" || o === "Set")
        return Array.from(n);
      if (o === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o))
        return R(n, r);
    }
  }
  function R(n, r) {
    (r == null || r > n.length) && (r = n.length);
    for (var o = 0, s = new Array(r); o < r; o++)
      s[o] = n[o];
    return s;
  }
  function X(n, r) {
    var o = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
    if (o != null) {
      var s, x, f, _, d = [], u = !0, h = !1;
      try {
        if (f = (o = o.call(n)).next, r === 0) {
          if (Object(o) !== o)
            return;
          u = !1;
        } else
          for (; !(u = (s = f.call(o)).done) && (d.push(s.value), d.length !== r); u = !0)
            ;
      } catch (O) {
        h = !0, x = O;
      } finally {
        try {
          if (!u && o.return != null && (_ = o.return(), Object(_) !== _))
            return;
        } finally {
          if (h)
            throw x;
        }
      }
      return d;
    }
  }
  function Q(n) {
    if (Array.isArray(n))
      return n;
  }
  var U = function() {
    var r = (0, p.usePicker)(), o = r.currentColor, s = r.addPoint, x = r.colors, f = r.value, _ = r.handleGradient, d = r.squareSize, u = r.deletePoint, h = r.isGradient, O = r.selectedColor, M = r.inFocus, q = r.setInFocus, W = (0, a.useState)(!1), Z = T(W, 2), K = Z[0], J = Z[1];
    function $(N) {
      return N.replace(/(radial|linear)-gradient\([^,]+,/, "linear-gradient(90deg,");
    }
    (0, a.useEffect)(function() {
      var N, te, fe = (N = window) === null || N === void 0 || (te = N.document) === null || te === void 0 ? void 0 : te.getElementById("gradient-handle-".concat(O));
      fe.focus();
    }, [O]);
    var D = function() {
      J(!1);
    }, Y = function(te) {
      K || (s(te), J(!0));
    }, ee = function(te) {
      K && _(o, (0, v.getHandleValue)(te));
    }, ne = function(te) {
      h && te.keyCode === 8 && M === "gpoint" && u();
    }, ae = function() {
      D();
    };
    return (0, a.useEffect)(function() {
      var N;
      return window.addEventListener("mouseup", ae), (N = window) === null || N === void 0 || N.addEventListener("keydown", ne), function() {
        var te;
        window.removeEventListener("mouseup", ae), (te = window) === null || te === void 0 || te.removeEventListener("keydown", ne);
      };
    }), /* @__PURE__ */ a.default.createElement("div", {
      style: w(w(w({
        width: "100%"
      }, S.psRl), S.borderBox), {}, {
        marginTop: 17,
        marginBottom: 4
      }),
      id: "gradient-bar"
    }, /* @__PURE__ */ a.default.createElement("div", {
      style: {
        width: d,
        height: 14,
        backgroundImage: $(f),
        borderRadius: 10
      },
      onMouseDown: function(te) {
        return Y(te);
      },
      onMouseMove: function(te) {
        return ee(te);
      }
    }), x == null ? void 0 : x.map(function(N, te) {
      return /* @__PURE__ */ a.default.createElement(C, {
        i: te,
        left: N.left,
        key: "".concat(te, "-").concat(N),
        setInFocus: q,
        setDragging: J
      });
    }));
  }, b = U;
  e.default = b;
  var C = function(r) {
    var o = r.left, s = r.i, x = r.setDragging, f = r.setInFocus, _ = (0, p.usePicker)(), d = _.setSelectedColor, u = _.selectedColor, h = _.squareSize, O = u === s, M = (h - 18) / 100, q = function(J) {
      J.stopPropagation(), d(s), x(!0);
    }, W = function() {
      f("gpoint"), d(s);
    }, Z = function() {
      f(null);
    };
    return /* @__PURE__ */ a.default.createElement("div", {
      tabIndex: 0,
      onBlur: Z,
      onFocus: W,
      id: "gradient-handle-".concat(s),
      onMouseDown: function(J) {
        return q(J);
      },
      style: w({
        left: o * M
      }, S.gradientHandleWrap)
    }, /* @__PURE__ */ a.default.createElement("div", {
      style: w(w(w(w(w({}, i(O)), S.gradientHandle), S.df), S.jc), S.ac)
    }, O && /* @__PURE__ */ a.default.createElement("div", {
      style: {
        width: 5,
        height: 5,
        borderRadius: "50%",
        background: "white"
      }
    })));
  };
  e.Handle = C;
  var i = function(r) {
    return {
      boxShadow: r ? "0px 0px 5px 1px rgba(86, 140, 245,.95)" : "",
      border: r ? "2px solid white" : "2px solid rgba(255,255,255,.75)"
    };
  };
})(Yr);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = P(we), a = P(Lr), v = P(zr), p = P(Fr), S = P(qr), j = P(Nr), E = P(Jt()), z = P(Yr), w = Te;
  function P(T) {
    return T && T.__esModule ? T : { default: T };
  }
  var L = function(A) {
    var y = A.hideControls, R = A.hideInputs, X = A.hidePresets, Q = A.hideOpacity, U = A.hideHue, b = A.presets, C = A.hideEyeDrop, i = A.hideAdvancedSliders, n = A.hideColorGuide, r = A.hideInputType, o = A.hideColorTypeBtns, s = A.hideGradientType, x = A.hideGradientAngle, f = A.hideGradientStop, _ = A.hideGradientControls, d = (0, w.usePicker)(), u = d.isGradient;
    return /* @__PURE__ */ t.default.createElement("div", {
      style: {
        userSelect: "none"
      },
      id: "rbgcp-wrapper"
    }, /* @__PURE__ */ t.default.createElement(p.default, null), !y && /* @__PURE__ */ t.default.createElement(E.default, {
      hideEyeDrop: C,
      hideAdvancedSliders: i,
      hideColorGuide: n,
      hideInputType: r,
      hideColorTypeBtns: o,
      hideGradientControls: _,
      hideGradientType: s,
      hideGradientAngle: x,
      hideGradientStop: f
    }), u && /* @__PURE__ */ t.default.createElement(z.default, null), !U && /* @__PURE__ */ t.default.createElement(a.default, null), !Q && /* @__PURE__ */ t.default.createElement(S.default, null), !R && /* @__PURE__ */ t.default.createElement(v.default, null), !X && /* @__PURE__ */ t.default.createElement(j.default, {
      presets: b
    }));
  }, I = L;
  e.default = I;
})(Br);
var Ot = {};
Object.defineProperty(Ot, "__esModule", {
  value: !0
});
Ot.useColorPicker = void 0;
var Cr = we, bt = dt(), Ee = Xe(), Ya = Ze, Xr = ze;
function lt(e) {
  "@babel/helpers - typeof";
  return lt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, lt(e);
}
function Ht(e) {
  return Ja(e) || Za(e) || Zr(e) || Xa();
}
function Xa() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Za(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function Ja(e) {
  if (Array.isArray(e))
    return Ft(e);
}
function Qa(e, t) {
  return ri(e) || ti(e, t) || Zr(e, t) || ei();
}
function ei() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Zr(e, t) {
  if (e) {
    if (typeof e == "string")
      return Ft(e, t);
    var a = Object.prototype.toString.call(e).slice(8, -1);
    if (a === "Object" && e.constructor && (a = e.constructor.name), a === "Map" || a === "Set")
      return Array.from(e);
    if (a === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a))
      return Ft(e, t);
  }
}
function Ft(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var a = 0, v = new Array(t); a < t; a++)
    v[a] = e[a];
  return v;
}
function ti(e, t) {
  var a = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (a != null) {
    var v, p, S, j, E = [], z = !0, w = !1;
    try {
      if (S = (a = a.call(e)).next, t === 0) {
        if (Object(a) !== a)
          return;
        z = !1;
      } else
        for (; !(z = (v = S.call(a)).done) && (E.push(v.value), E.length !== t); z = !0)
          ;
    } catch (P) {
      w = !0, p = P;
    } finally {
      try {
        if (!z && a.return != null && (j = a.return(), Object(j) !== j))
          return;
      } finally {
        if (w)
          throw p;
      }
    }
    return E;
  }
}
function ri(e) {
  if (Array.isArray(e))
    return e;
}
function Ar(e, t) {
  var a = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var v = Object.getOwnPropertySymbols(e);
    t && (v = v.filter(function(p) {
      return Object.getOwnPropertyDescriptor(e, p).enumerable;
    })), a.push.apply(a, v);
  }
  return a;
}
function Me(e) {
  for (var t = 1; t < arguments.length; t++) {
    var a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ar(Object(a), !0).forEach(function(v) {
      ni(e, v, a[v]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : Ar(Object(a)).forEach(function(v) {
      Object.defineProperty(e, v, Object.getOwnPropertyDescriptor(a, v));
    });
  }
  return e;
}
function ni(e, t, a) {
  return t = ai(t), t in e ? Object.defineProperty(e, t, { value: a, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = a, e;
}
function ai(e) {
  var t = ii(e, "string");
  return lt(t) === "symbol" ? t : String(t);
}
function ii(e, t) {
  if (lt(e) !== "object" || e === null)
    return e;
  var a = e[Symbol.toPrimitive];
  if (a !== void 0) {
    var v = a.call(e, t || "default");
    if (lt(v) !== "object")
      return v;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var oi = Xr.config.defaultColor, li = Xr.config.defaultGradient, rt = Fe, ui = function(t, a) {
  (!t || !a) && console.log("RBGCP ERROR - YOU MUST PASS A VALUE AND CALLBACK TO THE useColorPicker HOOK");
  var v = t == null ? void 0 : t.includes("gradient"), p = (0, bt.getGradientType)(t), S = (0, bt.getDegrees)(t), j = p === "linear-gradient" ? "".concat(S, "deg") : "circle", E = (0, Ee.getColors)(t), z = E == null ? void 0 : E.map(function(H, k) {
    return Me(Me({}, H), {}, {
      index: k
    });
  }), w = (z == null ? void 0 : z.filter(function(H) {
    return (0, bt.isUpperCase)(H.value);
  })[0]) || z[0], P = w == null ? void 0 : w.value, L = w == null ? void 0 : w.index, I = w == null ? void 0 : w.left, T = (0, Cr.useState)([]), A = Qa(T, 2), y = A[0], R = A[1], X = function() {
    if (t)
      return v ? {
        isGradient: !0,
        gradientType: p,
        degrees: j,
        colors: E == null ? void 0 : E.map(function(k) {
          var V;
          return Me(Me({}, k), {}, {
            value: (V = k.value) === null || V === void 0 ? void 0 : V.toLowerCase()
          });
        })
      } : {
        isGradient: !1,
        gradientType: null,
        degrees: null,
        colors: E == null ? void 0 : E.map(function(k) {
          var V;
          return Me(Me({}, k), {}, {
            value: (V = k.value) === null || V === void 0 ? void 0 : V.toLowerCase()
          });
        })
      };
    console.log("RBGCP ERROR - YOU MUST PASS A VALUE AND CALLBACK TO THE useColorPicker HOOK");
  }, Q = rt(P), U = Q.toRgb(), b = U.r, C = U.g, i = U.b, n = U.a, r = Q.toHsl(), o = r.h, s = r.s, x = r.l;
  (0, Cr.useEffect)(function() {
    var H;
    (H = rt(P)) !== null && H !== void 0 && H.isValid() && y[0] !== P && R([P].concat(Ht(y == null ? void 0 : y.slice(0, 19))));
  }, [P, y]);
  var f = function() {
    var k = t.split(/,(.+)/)[1];
    a("linear-gradient(90deg, ".concat(k));
  }, _ = function() {
    var k = t.split(/,(.+)/)[1];
    a("radial-gradient(circle, ".concat(k));
  }, d = function(k) {
    var V = t.split(/,(.+)/)[1];
    a("linear-gradient(".concat((0, Ee.formatInputValues)(k, 0, 360), "deg, ").concat(V)), p !== "linear-gradient" && console.log("Warning: you are updating degrees when the gradient type is not linear. This will change the gradients type which may be undesired");
  }, u = function(k) {
    var V = k || oi;
    a(V);
  }, h = function(k) {
    var V = k || li;
    a(V);
  }, O = function(k) {
    var V = k.sort(function(re, ce) {
      return re.left - ce.left;
    }), ie = V == null ? void 0 : V.map(function(re) {
      return "".concat(re == null ? void 0 : re.value, " ").concat(re.left, "%");
    });
    a("".concat(p, "(").concat(j, ", ").concat(ie.join(", "), ")"));
  }, M = function(k) {
    var V = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : I, ie = E == null ? void 0 : E.filter(function(ce) {
      return !(0, bt.isUpperCase)(ce.value);
    }), re = [{
      value: k.toUpperCase(),
      left: V
    }].concat(Ht(ie));
    O(re);
  }, q = function(k) {
    v ? M(k) : a(k);
  }, W = function(k) {
    var V = (0, Ee.formatInputValues)(k, 0, 255);
    q("rgba(".concat(V, ", ").concat(C, ", ").concat(i, ", ").concat(n, ")"));
  }, Z = function(k) {
    var V = (0, Ee.formatInputValues)(k, 0, 255);
    q("rgba(".concat(b, ", ").concat(V, ", ").concat(i, ", ").concat(n, ")"));
  }, K = function(k) {
    var V = (0, Ee.formatInputValues)(k, 0, 255);
    q("rgba(".concat(b, ", ").concat(C, ", ").concat(V, ", ").concat(n, ")"));
  }, J = function(k) {
    var V = (0, Ee.formatInputValues)(k, 0, 100);
    q("rgba(".concat(b, ", ").concat(C, ", ").concat(i, ", ").concat(V / 100, ")"));
  }, $ = function(k) {
    var V = (0, Ee.formatInputValues)(k, 0, 360), ie = rt({
      h: V,
      s,
      l: x
    }), re = ie.toRgb(), ce = re.r, he = re.g, F = re.b;
    q("rgba(".concat(ce, ", ").concat(he, ", ").concat(F, ", ").concat(n, ")"));
  }, D = function(k) {
    var V = (0, Ee.formatInputValues)(k, 0, 100), ie = rt({
      h: o,
      s: V / 100,
      l: x
    }), re = ie.toRgb(), ce = re.r, he = re.g, F = re.b;
    q("rgba(".concat(ce, ", ").concat(he, ", ").concat(F, ", ").concat(n, ")"));
  }, Y = function(k) {
    var V = (0, Ee.formatInputValues)(k, 0, 100), ie = rt({
      h: o,
      s,
      l: V / 100
    });
    if (ie != null && ie.isValid()) {
      var re = ie.toRgb(), ce = re.r, he = re.g, F = re.b;
      q("rgba(".concat(ce, ", ").concat(he, ", ").concat(F, ", ").concat(n, ")"));
    } else
      console.log("The new color was invalid, perhaps the lightness you passed in was a decimal? Please pass the new value between 0 - 100");
  }, ee = function() {
    return Q.toHslString();
  }, ne = function() {
    return Q.toHsvString();
  }, ae = function() {
    return Q.toHexString();
  }, N = function() {
    var k = (0, Ya.rgb2cmyk)(b, C, i), V = k.c, ie = k.m, re = k.y, ce = k.k;
    return "cmyk(".concat(V, ", ").concat(ie, ", ").concat(re, ", ").concat(ce, ")");
  }, te = function(k) {
    if (v) {
      var V = E == null ? void 0 : E.map(function(ie, re) {
        return Me(Me({}, ie), {}, {
          value: re === k ? (0, Ee.high)(ie) : (0, Ee.low)(ie)
        });
      });
      O(V);
    } else
      console.log("This function is only relevant when the picker is in gradient mode");
  }, fe = function(k) {
    var V = [].concat(Ht(E.map(function(ie) {
      return Me(Me({}, ie), {}, {
        value: (0, Ee.low)(ie)
      });
    })), [{
      value: P,
      left: k
    }]);
    O(V), k || console.log("You did not pass a stop value (left amount) for the new color point so it defaulted to 50");
  }, l = function(k) {
    if ((E == null ? void 0 : E.length) > 2) {
      var V = k || L, ie = E == null ? void 0 : E.filter(function(re, ce) {
        return ce !== V;
      });
      O(ie), k || console.log("You did not pass in the index of the point you wanted to delete so the function default to the currently selected point");
    } else
      console.log("A gradient must have atleast two colors, disable your delete button when necessary");
  }, g = function(k) {
    M(P, (0, Ee.formatInputValues)(k, 0, 100));
  }, c = [b, C, i, n], B = [o, s, x];
  return {
    setLinear: f,
    setRadial: _,
    setDegrees: d,
    setSolid: u,
    setGradient: h,
    setR: W,
    setG: Z,
    setB: K,
    setA: J,
    setHue: $,
    setSaturation: D,
    setLightness: Y,
    valueToHSL: ee,
    valueToHSV: ne,
    valueToHex: ae,
    valueToCmyk: N,
    setSelectedPoint: te,
    addPoint: fe,
    deletePoint: l,
    selectedPoint: L,
    isGradient: v,
    gradientType: p,
    degrees: S,
    setPointLeft: g,
    currentLeft: I,
    rgbaArr: c,
    hslArr: B,
    previousColors: y,
    getGradientObject: X
  };
};
Ot.useColorPicker = ui;
(function(e) {
  function t(n) {
    "@babel/helpers - typeof";
    return t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
      return typeof r;
    } : function(r) {
      return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
    }, t(n);
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var a = {};
  e.default = void 0;
  var v = w(we), p = E(Te), S = E(Br), j = Ot;
  Object.keys(j).forEach(function(n) {
    n === "default" || n === "__esModule" || Object.prototype.hasOwnProperty.call(a, n) || n in e && e[n] === j[n] || Object.defineProperty(e, n, {
      enumerable: !0,
      get: function() {
        return j[n];
      }
    });
  });
  function E(n) {
    return n && n.__esModule ? n : { default: n };
  }
  function z(n) {
    if (typeof WeakMap != "function")
      return null;
    var r = /* @__PURE__ */ new WeakMap(), o = /* @__PURE__ */ new WeakMap();
    return (z = function(x) {
      return x ? o : r;
    })(n);
  }
  function w(n, r) {
    if (!r && n && n.__esModule)
      return n;
    if (n === null || t(n) !== "object" && typeof n != "function")
      return { default: n };
    var o = z(r);
    if (o && o.has(n))
      return o.get(n);
    var s = {}, x = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var f in n)
      if (f !== "default" && Object.prototype.hasOwnProperty.call(n, f)) {
        var _ = x ? Object.getOwnPropertyDescriptor(n, f) : null;
        _ && (_.get || _.set) ? Object.defineProperty(s, f, _) : s[f] = n[f];
      }
    return s.default = n, o && o.set(n, s), s;
  }
  function P(n, r) {
    var o = Object.keys(n);
    if (Object.getOwnPropertySymbols) {
      var s = Object.getOwnPropertySymbols(n);
      r && (s = s.filter(function(x) {
        return Object.getOwnPropertyDescriptor(n, x).enumerable;
      })), o.push.apply(o, s);
    }
    return o;
  }
  function L(n) {
    for (var r = 1; r < arguments.length; r++) {
      var o = arguments[r] != null ? arguments[r] : {};
      r % 2 ? P(Object(o), !0).forEach(function(s) {
        I(n, s, o[s]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(o)) : P(Object(o)).forEach(function(s) {
        Object.defineProperty(n, s, Object.getOwnPropertyDescriptor(o, s));
      });
    }
    return n;
  }
  function I(n, r, o) {
    return r = T(r), r in n ? Object.defineProperty(n, r, { value: o, enumerable: !0, configurable: !0, writable: !0 }) : n[r] = o, n;
  }
  function T(n) {
    var r = A(n, "string");
    return t(r) === "symbol" ? r : String(r);
  }
  function A(n, r) {
    if (t(n) !== "object" || n === null)
      return n;
    var o = n[Symbol.toPrimitive];
    if (o !== void 0) {
      var s = o.call(n, r || "default");
      if (t(s) !== "object")
        return s;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (r === "string" ? String : Number)(n);
  }
  function y(n, r) {
    return b(n) || U(n, r) || X(n, r) || R();
  }
  function R() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function X(n, r) {
    if (n) {
      if (typeof n == "string")
        return Q(n, r);
      var o = Object.prototype.toString.call(n).slice(8, -1);
      if (o === "Object" && n.constructor && (o = n.constructor.name), o === "Map" || o === "Set")
        return Array.from(n);
      if (o === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o))
        return Q(n, r);
    }
  }
  function Q(n, r) {
    (r == null || r > n.length) && (r = n.length);
    for (var o = 0, s = new Array(r); o < r; o++)
      s[o] = n[o];
    return s;
  }
  function U(n, r) {
    var o = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
    if (o != null) {
      var s, x, f, _, d = [], u = !0, h = !1;
      try {
        if (f = (o = o.call(n)).next, r === 0) {
          if (Object(o) !== o)
            return;
          u = !1;
        } else
          for (; !(u = (s = f.call(o)).done) && (d.push(s.value), d.length !== r); u = !0)
            ;
      } catch (O) {
        h = !0, x = O;
      } finally {
        try {
          if (!u && o.return != null && (_ = o.return(), Object(_) !== _))
            return;
        } finally {
          if (h)
            throw x;
        }
      }
      return d;
    }
  }
  function b(n) {
    if (Array.isArray(n))
      return n;
  }
  function C(n) {
    var r = n.value, o = r === void 0 ? "rgba(175, 51, 242, 1)" : r, s = n.onChange, x = s === void 0 ? function() {
    } : s, f = n.hideControls, _ = f === void 0 ? !1 : f, d = n.hideInputs, u = d === void 0 ? !1 : d, h = n.hideOpacity, O = h === void 0 ? !1 : h, M = n.hidePresets, q = M === void 0 ? !1 : M, W = n.hideHue, Z = W === void 0 ? !1 : W, K = n.presets, J = K === void 0 ? [] : K, $ = n.hideEyeDrop, D = $ === void 0 ? !1 : $, Y = n.hideAdvancedSliders, ee = Y === void 0 ? !1 : Y, ne = n.hideColorGuide, ae = ne === void 0 ? !1 : ne, N = n.hideInputType, te = N === void 0 ? !1 : N, fe = n.hideColorTypeBtns, l = fe === void 0 ? !1 : fe, g = n.hideGradientType, c = g === void 0 ? !1 : g, B = n.hideGradientAngle, H = B === void 0 ? !1 : B, k = n.hideGradientStop, V = k === void 0 ? !1 : k, ie = n.hideGradientControls, re = ie === void 0 ? !1 : ie, ce = n.width, he = ce === void 0 ? 294 : ce, F = n.height, G = F === void 0 ? 294 : F, oe = n.style, le = oe === void 0 ? {} : oe, se = n.className, ge = (0, v.useRef)(null), ye = (0, v.useState)({}), xe = y(ye, 2), _e = xe[0], We = xe[1];
    return (0, v.useEffect)(function() {
      var Ge;
      We(ge == null || (Ge = ge.current) === null || Ge === void 0 ? void 0 : Ge.getBoundingClientRect());
    }, []), /* @__PURE__ */ v.default.createElement("div", {
      ref: ge,
      style: L(L({}, le), {}, {
        width: he
      }),
      className: se
    }, /* @__PURE__ */ v.default.createElement(p.default, {
      bounds: _e,
      value: o,
      onChange: x,
      squareSize: he,
      squareHeight: G,
      hideOpacity: O
    }, /* @__PURE__ */ v.default.createElement(S.default, {
      hideControls: _,
      hideInputs: u,
      hidePresets: q,
      hideOpacity: O,
      hideHue: Z,
      presets: J,
      hideEyeDrop: D,
      hideAdvancedSliders: ee,
      hideColorGuide: ae,
      hideInputType: te,
      hideColorTypeBtns: l,
      hideGradientType: c,
      hideGradientAngle: H,
      hideGradientStop: V,
      hideGradientControls: re
    })));
  }
  var i = C;
  e.default = i;
})(Yt);
const ci = /* @__PURE__ */ Hr(Yt);
var Jr = Symbol.for("immer-nothing"), Er = Symbol.for("immer-draftable"), ke = Symbol.for("immer-state"), si = process.env.NODE_ENV !== "production" ? [
  // All error codes, starting by 0:
  function(e) {
    return `The plugin for '${e}' has not been loaded into Immer. To enable the plugin, import and call \`enable${e}()\` when initializing your application.`;
  },
  function(e) {
    return `produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '${e}'`;
  },
  "This object has been frozen and should not be mutated",
  function(e) {
    return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + e;
  },
  "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
  "Immer forbids circular references",
  "The first or second argument to `produce` must be a function",
  "The third argument to `produce` must be a function or undefined",
  "First argument to `createDraft` must be a plain object, an array, or an immerable object",
  "First argument to `finishDraft` must be a draft returned by `createDraft`",
  function(e) {
    return `'current' expects a draft, got: ${e}`;
  },
  "Object.defineProperty() cannot be used on an Immer draft",
  "Object.setPrototypeOf() cannot be used on an Immer draft",
  "Immer only supports deleting array indices",
  "Immer only supports setting array indices and the 'length' property",
  function(e) {
    return `'original' expects a draft, got: ${e}`;
  }
  // Note: if more errors are added, the errorOffset in Patches.ts should be increased
  // See Patches.ts for additional errors
] : [];
function Pe(e, ...t) {
  if (process.env.NODE_ENV !== "production") {
    const a = si[e], v = typeof a == "function" ? a.apply(null, t) : a;
    throw new Error(`[Immer] ${v}`);
  }
  throw new Error(
    `[Immer] minified error nr: ${e}. Full error at: https://bit.ly/3cXEKWf`
  );
}
var Ke = Object.getPrototypeOf;
function Ye(e) {
  return !!e && !!e[ke];
}
function qe(e) {
  var t;
  return e ? Qr(e) || Array.isArray(e) || !!e[Er] || !!((t = e.constructor) != null && t[Er]) || Ct(e) || At(e) : !1;
}
var fi = Object.prototype.constructor.toString();
function Qr(e) {
  if (!e || typeof e != "object")
    return !1;
  const t = Ke(e);
  if (t === null)
    return !0;
  const a = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
  return a === Object ? !0 : typeof a == "function" && Function.toString.call(a) === fi;
}
function ut(e, t) {
  Pt(e) === 0 ? Object.entries(e).forEach(([a, v]) => {
    t(a, v, e);
  }) : e.forEach((a, v) => t(v, a, e));
}
function Pt(e) {
  const t = e[ke];
  return t ? t.type_ : Array.isArray(e) ? 1 : Ct(e) ? 2 : At(e) ? 3 : 0;
}
function $t(e, t) {
  return Pt(e) === 2 ? e.has(t) : Object.prototype.hasOwnProperty.call(e, t);
}
function en(e, t, a) {
  const v = Pt(e);
  v === 2 ? e.set(t, a) : v === 3 ? e.add(a) : e[t] = a;
}
function di(e, t) {
  return e === t ? e !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
function Ct(e) {
  return e instanceof Map;
}
function At(e) {
  return e instanceof Set;
}
function $e(e) {
  return e.copy_ || e.base_;
}
function qt(e, t) {
  if (Ct(e))
    return new Map(e);
  if (At(e))
    return new Set(e);
  if (Array.isArray(e))
    return Array.prototype.slice.call(e);
  if (!t && Qr(e))
    return Ke(e) ? { ...e } : Object.assign(/* @__PURE__ */ Object.create(null), e);
  const a = Object.getOwnPropertyDescriptors(e);
  delete a[ke];
  let v = Reflect.ownKeys(a);
  for (let p = 0; p < v.length; p++) {
    const S = v[p], j = a[S];
    j.writable === !1 && (j.writable = !0, j.configurable = !0), (j.get || j.set) && (a[S] = {
      configurable: !0,
      writable: !0,
      // could live with !!desc.set as well here...
      enumerable: j.enumerable,
      value: e[S]
    });
  }
  return Object.create(Ke(e), a);
}
function ct(e, t = !1) {
  return Et(e) || Ye(e) || !qe(e) || (Pt(e) > 1 && (e.set = e.add = e.clear = e.delete = pi), Object.freeze(e), t && ut(e, (a, v) => ct(v, !0))), e;
}
function pi() {
  Pe(2);
}
function Et(e) {
  return Object.isFrozen(e);
}
var vi = {};
function Ne(e) {
  const t = vi[e];
  return t || Pe(0, e), t;
}
var st;
function tn() {
  return st;
}
function hi(e, t) {
  return {
    drafts_: [],
    parent_: e,
    immer_: t,
    // Whenever the modified draft contains a draft from another scope, we
    // need to prevent auto-freezing so the unowned draft can be finalized.
    canAutoFreeze_: !0,
    unfinalizedDrafts_: 0
  };
}
function kr(e, t) {
  t && (Ne("Patches"), e.patches_ = [], e.inversePatches_ = [], e.patchListener_ = t);
}
function Nt(e) {
  Vt(e), e.drafts_.forEach(gi), e.drafts_ = null;
}
function Vt(e) {
  e === st && (st = e.parent_);
}
function jr(e) {
  return st = hi(st, e);
}
function gi(e) {
  const t = e[ke];
  t.type_ === 0 || t.type_ === 1 ? t.revoke_() : t.revoked_ = !0;
}
function Tr(e, t) {
  t.unfinalizedDrafts_ = t.drafts_.length;
  const a = t.drafts_[0];
  return e !== void 0 && e !== a ? (a[ke].modified_ && (Nt(t), Pe(4)), qe(e) && (e = _t(t, e), t.parent_ || xt(t, e)), t.patches_ && Ne("Patches").generateReplacementPatches_(
    a[ke].base_,
    e,
    t.patches_,
    t.inversePatches_
  )) : e = _t(t, a, []), Nt(t), t.patches_ && t.patchListener_(t.patches_, t.inversePatches_), e !== Jr ? e : void 0;
}
function _t(e, t, a) {
  if (Et(t))
    return t;
  const v = t[ke];
  if (!v)
    return ut(
      t,
      (p, S) => Ir(e, v, t, p, S, a)
    ), t;
  if (v.scope_ !== e)
    return t;
  if (!v.modified_)
    return xt(e, v.base_, !0), v.base_;
  if (!v.finalized_) {
    v.finalized_ = !0, v.scope_.unfinalizedDrafts_--;
    const p = v.copy_;
    let S = p, j = !1;
    v.type_ === 3 && (S = new Set(p), p.clear(), j = !0), ut(
      S,
      (E, z) => Ir(e, v, p, E, z, a, j)
    ), xt(e, p, !1), a && e.patches_ && Ne("Patches").generatePatches_(
      v,
      a,
      e.patches_,
      e.inversePatches_
    );
  }
  return v.copy_;
}
function Ir(e, t, a, v, p, S, j) {
  if (process.env.NODE_ENV !== "production" && p === a && Pe(5), Ye(p)) {
    const E = S && t && t.type_ !== 3 && // Set objects are atomic since they have no keys.
    !$t(t.assigned_, v) ? S.concat(v) : void 0, z = _t(e, p, E);
    if (en(a, v, z), Ye(z))
      e.canAutoFreeze_ = !1;
    else
      return;
  } else
    j && a.add(p);
  if (qe(p) && !Et(p)) {
    if (!e.immer_.autoFreeze_ && e.unfinalizedDrafts_ < 1)
      return;
    _t(e, p), (!t || !t.scope_.parent_) && xt(e, p);
  }
}
function xt(e, t, a = !1) {
  !e.parent_ && e.immer_.autoFreeze_ && e.canAutoFreeze_ && ct(t, a);
}
function yi(e, t) {
  const a = Array.isArray(e), v = {
    type_: a ? 1 : 0,
    // Track which produce call this is associated with.
    scope_: t ? t.scope_ : tn(),
    // True for both shallow and deep changes.
    modified_: !1,
    // Used during finalization.
    finalized_: !1,
    // Track which properties have been assigned (true) or deleted (false).
    assigned_: {},
    // The parent draft state.
    parent_: t,
    // The base state.
    base_: e,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: !1
  };
  let p = v, S = Qt;
  a && (p = [v], S = ft);
  const { revoke: j, proxy: E } = Proxy.revocable(p, S);
  return v.draft_ = E, v.revoke_ = j, E;
}
var Qt = {
  get(e, t) {
    if (t === ke)
      return e;
    const a = $e(e);
    if (!$t(a, t))
      return mi(e, a, t);
    const v = a[t];
    return e.finalized_ || !qe(v) ? v : v === Gt(e.base_, t) ? (Wt(e), e.copy_[t] = Kt(v, e)) : v;
  },
  has(e, t) {
    return t in $e(e);
  },
  ownKeys(e) {
    return Reflect.ownKeys($e(e));
  },
  set(e, t, a) {
    const v = rn($e(e), t);
    if (v != null && v.set)
      return v.set.call(e.draft_, a), !0;
    if (!e.modified_) {
      const p = Gt($e(e), t), S = p == null ? void 0 : p[ke];
      if (S && S.base_ === a)
        return e.copy_[t] = a, e.assigned_[t] = !1, !0;
      if (di(a, p) && (a !== void 0 || $t(e.base_, t)))
        return !0;
      Wt(e), Ut(e);
    }
    return e.copy_[t] === a && // special case: handle new props with value 'undefined'
    (a !== void 0 || t in e.copy_) || // special case: NaN
    Number.isNaN(a) && Number.isNaN(e.copy_[t]) || (e.copy_[t] = a, e.assigned_[t] = !0), !0;
  },
  deleteProperty(e, t) {
    return Gt(e.base_, t) !== void 0 || t in e.base_ ? (e.assigned_[t] = !1, Wt(e), Ut(e)) : delete e.assigned_[t], e.copy_ && delete e.copy_[t], !0;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(e, t) {
    const a = $e(e), v = Reflect.getOwnPropertyDescriptor(a, t);
    return v && {
      writable: !0,
      configurable: e.type_ !== 1 || t !== "length",
      enumerable: v.enumerable,
      value: a[t]
    };
  },
  defineProperty() {
    Pe(11);
  },
  getPrototypeOf(e) {
    return Ke(e.base_);
  },
  setPrototypeOf() {
    Pe(12);
  }
}, ft = {};
ut(Qt, (e, t) => {
  ft[e] = function() {
    return arguments[0] = arguments[0][0], t.apply(this, arguments);
  };
});
ft.deleteProperty = function(e, t) {
  return process.env.NODE_ENV !== "production" && isNaN(parseInt(t)) && Pe(13), ft.set.call(this, e, t, void 0);
};
ft.set = function(e, t, a) {
  return process.env.NODE_ENV !== "production" && t !== "length" && isNaN(parseInt(t)) && Pe(14), Qt.set.call(this, e[0], t, a, e[0]);
};
function Gt(e, t) {
  const a = e[ke];
  return (a ? $e(a) : e)[t];
}
function mi(e, t, a) {
  var p;
  const v = rn(t, a);
  return v ? "value" in v ? v.value : (
    // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (p = v.get) == null ? void 0 : p.call(e.draft_)
  ) : void 0;
}
function rn(e, t) {
  if (!(t in e))
    return;
  let a = Ke(e);
  for (; a; ) {
    const v = Object.getOwnPropertyDescriptor(a, t);
    if (v)
      return v;
    a = Ke(a);
  }
}
function Ut(e) {
  e.modified_ || (e.modified_ = !0, e.parent_ && Ut(e.parent_));
}
function Wt(e) {
  e.copy_ || (e.copy_ = qt(
    e.base_,
    e.scope_.immer_.useStrictShallowCopy_
  ));
}
var bi = class {
  constructor(e) {
    this.autoFreeze_ = !0, this.useStrictShallowCopy_ = !1, this.produce = (t, a, v) => {
      if (typeof t == "function" && typeof a != "function") {
        const S = a;
        a = t;
        const j = this;
        return function(z = S, ...w) {
          return j.produce(z, (P) => a.call(this, P, ...w));
        };
      }
      typeof a != "function" && Pe(6), v !== void 0 && typeof v != "function" && Pe(7);
      let p;
      if (qe(t)) {
        const S = jr(this), j = Kt(t, void 0);
        let E = !0;
        try {
          p = a(j), E = !1;
        } finally {
          E ? Nt(S) : Vt(S);
        }
        return kr(S, v), Tr(p, S);
      } else if (!t || typeof t != "object") {
        if (p = a(t), p === void 0 && (p = t), p === Jr && (p = void 0), this.autoFreeze_ && ct(p, !0), v) {
          const S = [], j = [];
          Ne("Patches").generateReplacementPatches_(t, p, S, j), v(S, j);
        }
        return p;
      } else
        Pe(1, t);
    }, this.produceWithPatches = (t, a) => {
      if (typeof t == "function")
        return (j, ...E) => this.produceWithPatches(j, (z) => t(z, ...E));
      let v, p;
      return [this.produce(t, a, (j, E) => {
        v = j, p = E;
      }), v, p];
    }, typeof (e == null ? void 0 : e.autoFreeze) == "boolean" && this.setAutoFreeze(e.autoFreeze), typeof (e == null ? void 0 : e.useStrictShallowCopy) == "boolean" && this.setUseStrictShallowCopy(e.useStrictShallowCopy);
  }
  createDraft(e) {
    qe(e) || Pe(8), Ye(e) && (e = wi(e));
    const t = jr(this), a = Kt(e, void 0);
    return a[ke].isManual_ = !0, Vt(t), a;
  }
  finishDraft(e, t) {
    const a = e && e[ke];
    (!a || !a.isManual_) && Pe(9);
    const { scope_: v } = a;
    return kr(v, t), Tr(void 0, v);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(e) {
    this.autoFreeze_ = e;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(e) {
    this.useStrictShallowCopy_ = e;
  }
  applyPatches(e, t) {
    let a;
    for (a = t.length - 1; a >= 0; a--) {
      const p = t[a];
      if (p.path.length === 0 && p.op === "replace") {
        e = p.value;
        break;
      }
    }
    a > -1 && (t = t.slice(a + 1));
    const v = Ne("Patches").applyPatches_;
    return Ye(e) ? v(e, t) : this.produce(
      e,
      (p) => v(p, t)
    );
  }
};
function Kt(e, t) {
  const a = Ct(e) ? Ne("MapSet").proxyMap_(e, t) : At(e) ? Ne("MapSet").proxySet_(e, t) : yi(e, t);
  return (t ? t.scope_ : tn()).drafts_.push(a), a;
}
function wi(e) {
  return Ye(e) || Pe(10, e), nn(e);
}
function nn(e) {
  if (!qe(e) || Et(e))
    return e;
  const t = e[ke];
  let a;
  if (t) {
    if (!t.modified_)
      return t.base_;
    t.finalized_ = !0, a = qt(e, t.scope_.immer_.useStrictShallowCopy_);
  } else
    a = qt(e, !0);
  return ut(a, (v, p) => {
    en(a, v, nn(p));
  }), t && (t.finalized_ = !1), a;
}
var je = new bi(), Si = je.produce;
je.produceWithPatches.bind(
  je
);
je.setAutoFreeze.bind(je);
je.setUseStrictShallowCopy.bind(je);
je.applyPatches.bind(je);
je.createDraft.bind(je);
je.finishDraft.bind(je);
function _i(e) {
  var t = St(function() {
    return ct(typeof e == "function" ? e() : e, !0);
  }), a = t[1];
  return [t[0], ta(function(v) {
    a(typeof v == "function" ? Si(v) : ct(v));
  }, [])];
}
const xi = ({ color: e = "" }) => /^#[0-9A-F]{6}$/i.test(e) ? /* @__PURE__ */ m.jsx(Lt, { spacing: 0, columns: 5, children: Object.entries(ca(e)).map(([a, v]) => /* @__PURE__ */ m.jsx(Mr, { background: v, py: 2, px: 3, children: /* @__PURE__ */ m.jsx(de, { fontSize: "xs", children: a }) }, `primary-color-${a}`)) }) : /* @__PURE__ */ m.jsx(de, { textAlign: "center", children: "Invalid Hex Color." }), Bt = [
  {
    id: 1,
    name: "color1",
    default: "#18A2AD",
    hex: null,
    rgb: null,
    active: !0
  },
  {
    id: 2,
    name: "color2",
    default: "#FF3838",
    hex: null,
    rgb: null,
    active: !1
  },
  {
    id: 3,
    name: "color3",
    default: "#152532",
    hex: null,
    rgb: null,
    active: !1
  },
  {
    id: 4,
    name: "color4",
    default: "#2ECC71",
    hex: null,
    rgb: null,
    active: !1
  },
  {
    id: 5,
    name: "color5",
    default: "#e9dd41",
    hex: null,
    rgb: null,
    active: !1
  }
], Le = ({ title: e, colorValue: t = "#000", colorCode: a, type: v }) => {
  var T, A;
  const { data: p, updateConfig: S } = Gr(), [, j] = _i({
    collection: [...Bt],
    activeColorId: (T = Bt.find((y) => y.active)) == null ? void 0 : T.id,
    currentColor: (A = Bt.find((y) => y.active)) == null ? void 0 : A.default
  }), [E, z] = St(t), { valueToHex: w, isGradient: P } = Yt.useColorPicker(E, z), L = w(), I = (y, R, X) => {
    const Q = setTimeout(() => {
      j((U) => {
        const b = U.collection.find((C) => C.id === U.activeColorId);
        U.currentColor = y, b && (b.hex = y), S(!P && v === "solid" ? He(X, a, L) : He(X, a, y));
      }), z(y);
    }, 100);
    return () => {
      clearTimeout(Q);
    };
  };
  return /* @__PURE__ */ m.jsxs(m.Fragment, { children: [
    /* @__PURE__ */ m.jsxs(it, { children: [
      /* @__PURE__ */ m.jsx(ot, { children: e }),
      /* @__PURE__ */ m.jsx(
        Ue,
        {
          height: "20px",
          width: "100px",
          value: t,
          onChange: (y) => {
            S(He(p, a, y.target.value));
          }
        }
      )
    ] }),
    v !== "gradient" && /* @__PURE__ */ m.jsx(xi, { color: t }),
    /* @__PURE__ */ m.jsx(zt, { allowToggle: !0, children: /* @__PURE__ */ m.jsxs(nt, { children: [
      /* @__PURE__ */ m.jsx("h2", { children: /* @__PURE__ */ m.jsxs(Rr, { children: [
        /* @__PURE__ */ m.jsx(Re, { as: "span", flex: "1", textAlign: "left", children: "Color Picker" }),
        /* @__PURE__ */ m.jsx(Dr, {})
      ] }) }),
      /* @__PURE__ */ m.jsx(at, { pb: 4, children: /* @__PURE__ */ m.jsx(
        ci,
        {
          value: L,
          onChange: (y) => I(y, a, p),
          hideGradientControls: !P && v === "solid",
          hideGradientType: !P && v === "solid",
          hideGradientAngle: !P && v === "solid",
          hideGradientStop: !P && v === "solid",
          hideControls: !P && v === "solid"
        }
      ) })
    ] }) })
  ] });
}, Oi = [
  { locale: "en-US" },
  { locale: "zh-Hant-TW" },
  { locale: "th-TH" },
  { locale: "ko-KR" },
  { locale: "ms-MY" }
], Zi = ({
  enabled: e = !1,
  placement: t = "left",
  size: a = "xl"
}) => {
  var _, d, u, h, O, M, q, W, Z, K, J, $, D, Y, ee, ne, ae, N, te, fe, l, g, c, B, H, k, V, ie, re, ce, he, F;
  const v = En(), { data: p, updateConfig: S, refetchConfig: j, saveConfig: E, conf: z } = Gr(), { languagesAvailable: w } = p, { onCopy: P, hasCopied: L } = kn(JSON.stringify(p, null, 2)), [I, T] = St("Translations"), [A] = ra({ authorization: "", token: "", id: "" }), [y, R] = St(), { isOn: X } = oa("devtools"), {
    // isEnabled,
    // updateIsEnabled,
    module: Q,
    // updateActiveLanguage,
    language: U,
    updateIsEditingMode: b,
    isEditingMode: C,
    updateIsDevToolsOpen: i,
    isDevToolsEnabled: n,
    updateIsDevToolsEnabled: r,
    isKeyShown: o,
    setIsKeyShown: s
  } = Qn(), f = na() ? aa() : ia();
  return It(() => {
    i(v.isOpen);
  }, [v]), It(() => {
    (async () => {
      var le;
      const oe = await ((le = mr.getStringManagerInstance(U)) == null ? void 0 : le.getGroup(
        "Global"
      ));
      R(oe);
    })();
  }, [I, U]), It(() => {
    r(X && e);
  }, [e, X]), !e || !n ? null : /* @__PURE__ */ m.jsxs(m.Fragment, { children: [
    /* @__PURE__ */ m.jsxs(jn, { placement: t, size: a, ...v, children: [
      /* @__PURE__ */ m.jsx(Tn, {}),
      /* @__PURE__ */ m.jsxs(In, { minH: "300px", pt: "60px", children: [
        /* @__PURE__ */ m.jsx(Rn, { mt: "60px" }),
        /* @__PURE__ */ m.jsxs(Dn, { pt: 0, children: [
          /* @__PURE__ */ m.jsxs(Mn, { py: 4, children: [
            /* @__PURE__ */ m.jsx(ur, { children: /* @__PURE__ */ m.jsx(de, { fontWeight: "bold", letterSpacing: "tight", children: "MyAsurion DevTools" }) }),
            /* @__PURE__ */ m.jsx(ur, { children: /* @__PURE__ */ m.jsxs(Hn, { children: [
              /* @__PURE__ */ m.jsx(Gn, { as: Wn, children: I }),
              /* @__PURE__ */ m.jsxs(Bn, { children: [
                /* @__PURE__ */ m.jsx(
                  cr,
                  {
                    onClick: () => {
                      T("Translations");
                    },
                    children: "Translations"
                  }
                ),
                /* @__PURE__ */ m.jsx(
                  cr,
                  {
                    onClick: () => {
                      T("Config");
                    },
                    children: "Config"
                  }
                )
              ] })
            ] }) })
          ] }),
          /* @__PURE__ */ m.jsxs(Lt, { w: "full", columns: 2, mb: 4, gap: 4, children: [
            /* @__PURE__ */ m.jsxs(
              Ce,
              {
                px: 3,
                py: 2,
                bg: "primary.200",
                justify: "space-between",
                borderRadius: "md",
                gap: 2,
                align: "center",
                children: [
                  /* @__PURE__ */ m.jsx(de, { fontSize: "xs", color: "onPrimary.500", letterSpacing: "wider", children: "PARTNER" }),
                  /* @__PURE__ */ m.jsx(de, { fontSize: "sm", fontWeight: "bold", color: "onPrimary.500", children: p == null ? void 0 : p.partner })
                ]
              }
            ),
            /* @__PURE__ */ m.jsxs(
              Ce,
              {
                px: 3,
                py: 2,
                bg: "primary.200",
                justify: "space-between",
                borderRadius: "md",
                gap: 2,
                align: "center",
                children: [
                  /* @__PURE__ */ m.jsx(de, { fontSize: "xs", color: "onPrimary.500", letterSpacing: "wider", children: "PROGRAM" }),
                  /* @__PURE__ */ m.jsx(de, { fontSize: "sm", fontWeight: "bold", color: "onPrimary.500", children: p == null ? void 0 : p.program })
                ]
              }
            )
          ] }),
          I === "Config" && /* @__PURE__ */ m.jsx(Re, { children: /* @__PURE__ */ m.jsxs(zt, { children: [
            /* @__PURE__ */ m.jsxs(nt, { children: [
              /* @__PURE__ */ m.jsx(mt, { children: "Global Theme" }),
              /* @__PURE__ */ m.jsx(at, { pb: 6, children: /* @__PURE__ */ m.jsxs(
                Ae,
                {
                  gap: 2,
                  divider: /* @__PURE__ */ m.jsx(Ln, { borderColor: "gray.200" }),
                  children: [
                    /* @__PURE__ */ m.jsxs(Ae, { gap: 2, children: [
                      /* @__PURE__ */ m.jsxs(it, { children: [
                        /* @__PURE__ */ m.jsx(ot, { children: "Logo" }),
                        /* @__PURE__ */ m.jsx(
                          Ue,
                          {
                            height: "20px",
                            width: "full",
                            maxW: "300px",
                            value: ((_ = p == null ? void 0 : p.theme) == null ? void 0 : _.logo) || "",
                            onChange: (G) => {
                              S(
                                He(
                                  p,
                                  "theme.logo",
                                  G.target.value
                                )
                              );
                            }
                          }
                        )
                      ] }),
                      /* @__PURE__ */ m.jsx(
                        sr,
                        {
                          src: (d = p == null ? void 0 : p.theme) == null ? void 0 : d.logo,
                          height: "100%",
                          maxHeight: "60px",
                          border: "1px solid",
                          borderColor: "gray.200",
                          borderRadius: "md",
                          overflow: "hidden",
                          w: "full",
                          h: "52px",
                          objectFit: "contain"
                        }
                      )
                    ] }),
                    /* @__PURE__ */ m.jsx(Ae, { gap: 2, children: /* @__PURE__ */ m.jsx(
                      Le,
                      {
                        title: "Primary Color",
                        colorValue: ((h = (u = p == null ? void 0 : p.theme) == null ? void 0 : u.colors) == null ? void 0 : h.primary) || "",
                        colorCode: "theme.colors.primary",
                        type: "solid"
                      }
                    ) }),
                    /* @__PURE__ */ m.jsx(Ae, { gap: 2, children: /* @__PURE__ */ m.jsx(
                      Le,
                      {
                        title: "On Primary Color",
                        colorValue: ((M = (O = p == null ? void 0 : p.theme) == null ? void 0 : O.colors) == null ? void 0 : M.onPrimary) || "",
                        colorCode: "theme.colors.onPrimary",
                        type: "solid"
                      }
                    ) }),
                    /* @__PURE__ */ m.jsx(Ae, { gap: 2, children: /* @__PURE__ */ m.jsx(
                      Le,
                      {
                        title: "Accent Color",
                        colorValue: ((W = (q = p == null ? void 0 : p.theme) == null ? void 0 : q.colors) == null ? void 0 : W.accent) || "",
                        colorCode: "theme.colors.accent",
                        type: "solid"
                      }
                    ) }),
                    /* @__PURE__ */ m.jsx(Ae, { gap: 2, children: /* @__PURE__ */ m.jsx(
                      Le,
                      {
                        title: "Body Text Color",
                        colorValue: ((Z = p == null ? void 0 : p.theme) == null ? void 0 : Z.colors.bodyTextColor) || (($ = (J = (K = ea) == null ? void 0 : K.semanticTokens) == null ? void 0 : J.colors) == null ? void 0 : $["chakra-body-text"]._light),
                        colorCode: "theme.colors.bodyTextColor",
                        type: "solid"
                      }
                    ) }),
                    /* @__PURE__ */ m.jsx(Ae, { gap: 2, children: /* @__PURE__ */ m.jsx(
                      Le,
                      {
                        title: "Banner Gradient",
                        colorValue: ((Y = (D = p == null ? void 0 : p.theme) == null ? void 0 : D.colors) == null ? void 0 : Y.bannerGradient) || "",
                        colorCode: "theme.colors.bannerGradient",
                        type: "gradient"
                      }
                    ) }),
                    /* @__PURE__ */ m.jsx(Ae, { gap: 2, children: /* @__PURE__ */ m.jsx(
                      Le,
                      {
                        title: "Banner Color",
                        colorValue: ((ne = (ee = p == null ? void 0 : p.theme) == null ? void 0 : ee.colors) == null ? void 0 : ne.bannerColor) || "",
                        colorCode: "theme.colors.bannerColor",
                        type: "solid"
                      }
                    ) }),
                    /* @__PURE__ */ m.jsx(Ae, { gap: 2, children: /* @__PURE__ */ m.jsx(
                      Le,
                      {
                        title: "Feedback Gradient",
                        colorValue: ((N = (ae = p == null ? void 0 : p.theme) == null ? void 0 : ae.colors) == null ? void 0 : N.feedbackGradient) || "",
                        colorCode: "theme.colors.feedbackGradient",
                        type: "gradient"
                      }
                    ) }),
                    /* @__PURE__ */ m.jsx(Ae, { gap: 2, children: /* @__PURE__ */ m.jsx(
                      Le,
                      {
                        title: "Header Theme",
                        colorValue: ((fe = (te = p == null ? void 0 : p.theme) == null ? void 0 : te.header) == null ? void 0 : fe.bg) || "",
                        colorCode: "theme.header.bg",
                        type: "solid"
                      }
                    ) }),
                    /* @__PURE__ */ m.jsxs(Ae, { gap: 2, children: [
                      /* @__PURE__ */ m.jsxs(it, { children: [
                        /* @__PURE__ */ m.jsx(ot, { children: "Header Logo" }),
                        /* @__PURE__ */ m.jsx(
                          Ue,
                          {
                            height: "20px",
                            width: "full",
                            maxW: "300px",
                            value: ((l = p == null ? void 0 : p.theme) == null ? void 0 : l.header.logo) || "",
                            onChange: (G) => {
                              S(
                                He(
                                  p,
                                  "theme.header.logo",
                                  G.target.value
                                )
                              );
                            }
                          }
                        )
                      ] }),
                      /* @__PURE__ */ m.jsx(
                        sr,
                        {
                          src: (g = p == null ? void 0 : p.theme) == null ? void 0 : g.header.logo,
                          height: "100%",
                          maxHeight: "60px",
                          border: "1px solid",
                          borderColor: "gray.200",
                          borderRadius: "md",
                          overflow: "hidden",
                          w: "full",
                          h: "52px",
                          objectFit: "contain"
                        }
                      )
                    ] }),
                    /* @__PURE__ */ m.jsxs(Ae, { gap: 2, children: [
                      /* @__PURE__ */ m.jsx(wt, { fontSize: "lg", children: "Button Settings" }),
                      /* @__PURE__ */ m.jsx(
                        Mr,
                        {
                          p: 4,
                          borderRadius: "md",
                          bg: "gray.50",
                          w: "full",
                          children: /* @__PURE__ */ m.jsx(et, { children: "Click me!" })
                        }
                      ),
                      /* @__PURE__ */ m.jsxs(it, { children: [
                        /* @__PURE__ */ m.jsx(ot, { children: "Uppercase Text" }),
                        /* @__PURE__ */ m.jsx(
                          zn,
                          {
                            isChecked: ((H = (B = (c = p == null ? void 0 : p.theme) == null ? void 0 : c.baseComponents) == null ? void 0 : B.Button) == null ? void 0 : H.textTransform) === "uppercase",
                            onChange: (G) => {
                              S(
                                He(
                                  p,
                                  "theme.baseComponents.Button.textTransform",
                                  G.target.checked ? "uppercase" : "none"
                                )
                              );
                            }
                          }
                        )
                      ] }),
                      /* @__PURE__ */ m.jsxs(it, { children: [
                        /* @__PURE__ */ m.jsx(ot, { children: "Letter Spacing" }),
                        /* @__PURE__ */ m.jsx(
                          Fn,
                          {
                            value: ((ie = (V = (k = p == null ? void 0 : p.theme) == null ? void 0 : k.baseComponents) == null ? void 0 : V.Button) == null ? void 0 : ie.letterSpacing) || "normal",
                            onChange: (G) => {
                              S(
                                He(
                                  p,
                                  "theme.baseComponents.Button.letterSpacing",
                                  G.target.value
                                )
                              );
                            },
                            children: [
                              "tighter",
                              "tight",
                              "normal",
                              "wide",
                              "wider",
                              "widest"
                            ].map((G) => /* @__PURE__ */ m.jsx("option", { value: G, children: G }, G))
                          }
                        )
                      ] })
                    ] })
                  ]
                }
              ) })
            ] }),
            /* @__PURE__ */ m.jsxs(nt, { children: [
              /* @__PURE__ */ m.jsx(mt, { children: "Custom Component Styles" }),
              /* @__PURE__ */ m.jsx(at, { pb: 6, children: /* @__PURE__ */ m.jsxs(Ae, { gap: 2, children: [
                /* @__PURE__ */ m.jsxs(
                  Re,
                  {
                    gap: 2,
                    py: 4,
                    px: 3,
                    borderRadius: "md",
                    bg: "gray.50",
                    children: [
                      /* @__PURE__ */ m.jsx(wt, { fontSize: "md", children: "favicon" }),
                      /* @__PURE__ */ m.jsxs(fr, { variant: "striped", size: "sm", mt: 4, children: [
                        /* @__PURE__ */ m.jsx(dr, { children: /* @__PURE__ */ m.jsxs(Ve, { children: [
                          /* @__PURE__ */ m.jsx(yt, { children: "Feature" }),
                          /* @__PURE__ */ m.jsx(yt, { children: "Value" })
                        ] }) }),
                        /* @__PURE__ */ m.jsx(pr, { children: /* @__PURE__ */ m.jsxs(Ve, { children: [
                          /* @__PURE__ */ m.jsx(Be, { children: "favicon" }),
                          /* @__PURE__ */ m.jsx(Be, { children: /* @__PURE__ */ m.jsx(
                            Ue,
                            {
                              height: "20px",
                              value: ((re = p == null ? void 0 : p.theme) == null ? void 0 : re.favicon) || "",
                              onChange: (G) => {
                                S(
                                  He(
                                    p,
                                    "theme.favicon",
                                    G.target.value
                                  )
                                );
                              }
                            }
                          ) })
                        ] }, "component-styles--favicon") })
                      ] })
                    ]
                  },
                  "component-styles-fav"
                ),
                Object.entries(((ce = p == null ? void 0 : p.theme) == null ? void 0 : ce.components) ?? {}).map(
                  ([G, oe]) => /* @__PURE__ */ m.jsxs(
                    Re,
                    {
                      gap: 2,
                      py: 4,
                      px: 3,
                      borderRadius: "md",
                      bg: "gray.50",
                      children: [
                        /* @__PURE__ */ m.jsx(wt, { fontSize: "md", children: G }),
                        /* @__PURE__ */ m.jsxs(
                          fr,
                          {
                            variant: "striped",
                            size: "sm",
                            mt: 4,
                            children: [
                              /* @__PURE__ */ m.jsx(dr, { children: /* @__PURE__ */ m.jsxs(Ve, { children: [
                                /* @__PURE__ */ m.jsx(yt, { children: "Feature" }),
                                /* @__PURE__ */ m.jsx(yt, { children: "Value" })
                              ] }) }),
                              /* @__PURE__ */ m.jsx(pr, { children: Object.entries(
                                oe ?? {}
                              ).map(([le, se]) => {
                                var ge;
                                return typeof se == "object" && se !== null ? /* @__PURE__ */ m.jsxs(
                                  Ve,
                                  {
                                    children: [
                                      /* @__PURE__ */ m.jsx(Be, { children: le }),
                                      (ge = Object.entries(
                                        se
                                      )) == null ? void 0 : ge.map(
                                        ([
                                          ye,
                                          xe
                                        ]) => /* @__PURE__ */ m.jsxs(
                                          Ve,
                                          {
                                            children: [
                                              /* @__PURE__ */ m.jsx(Be, {}),
                                              /* @__PURE__ */ m.jsx(Be, { children: ye }),
                                              /* @__PURE__ */ m.jsx(
                                                Be,
                                                {
                                                  children: /* @__PURE__ */ m.jsx(
                                                    Ue,
                                                    {
                                                      height: "20px",
                                                      value: xe,
                                                      onChange: (_e) => {
                                                        S(
                                                          He(
                                                            p,
                                                            `theme.components.${G}.${le}.${ye}`,
                                                            _e.target.value
                                                          )
                                                        );
                                                      }
                                                    }
                                                  )
                                                },
                                                ye
                                              )
                                            ]
                                          },
                                          ye
                                        )
                                      )
                                    ]
                                  },
                                  `component-styles-${G}-${le}`
                                ) : /* @__PURE__ */ m.jsxs(
                                  Ve,
                                  {
                                    children: [
                                      /* @__PURE__ */ m.jsx(Be, { children: le }),
                                      /* @__PURE__ */ m.jsx(Be, { children: /* @__PURE__ */ m.jsx(
                                        Ue,
                                        {
                                          height: "20px",
                                          value: se,
                                          onChange: (ye) => {
                                            S(
                                              He(
                                                p,
                                                `theme.components.${G}.${le}`,
                                                ye.target.value
                                              )
                                            );
                                          }
                                        }
                                      ) })
                                    ]
                                  },
                                  `component-styles-${G}-${le}`
                                );
                              }) })
                            ]
                          }
                        )
                      ]
                    },
                    `component-styles-${G}`
                  )
                )
              ] }) })
            ] })
          ] }) }),
          I === "Translations" && /* @__PURE__ */ m.jsx(Re, { children: /* @__PURE__ */ m.jsxs(
            $n,
            {
              display: "flex",
              flexFlow: "column nowrap",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              children: [
                /* @__PURE__ */ m.jsx(de, { as: "h2", fontSize: "xl", fontWeight: "bold", children: "Translations" }),
                /* @__PURE__ */ m.jsx(de, { as: "h3", fontWeight: "bold", children: "Current Active Language:" }),
                /* @__PURE__ */ m.jsx(de, { as: "h4", children: ((F = (he = w || Oi) == null ? void 0 : he.find(
                  (G) => G.locale === U
                )) == null ? void 0 : F.name) ?? U }),
                /* @__PURE__ */ m.jsx(de, { as: "h3", fontWeight: "bold", children: "Toggle Supported Mode:" }),
                /* @__PURE__ */ m.jsxs(vr, { display: "flex", alignItems: "center", children: [
                  /* @__PURE__ */ m.jsx(hr, { htmlFor: "toggle-editing", mb: "0", children: "Enable editing mode?" }),
                  /* @__PURE__ */ m.jsx(
                    gr,
                    {
                      id: "toggle-editing",
                      isChecked: C,
                      onChange: () => {
                        C || s(!1), b(!C);
                      }
                    }
                  )
                ] }),
                /* @__PURE__ */ m.jsxs(vr, { display: "flex", alignItems: "center", children: [
                  /* @__PURE__ */ m.jsx(hr, { htmlFor: "toggle-key-shown", mb: "0", children: "Toggle translation key" }),
                  /* @__PURE__ */ m.jsx(
                    gr,
                    {
                      id: "toggle-key-shown",
                      isChecked: C ? !1 : o,
                      onChange: () => s(!o)
                    }
                  ),
                  /* @__PURE__ */ m.jsx(qn, { label: "Translation keys will be shown when editing mode is turned off", children: /* @__PURE__ */ m.jsx(Nn, { as: Cn, mx: "1rem", opacity: 0.75 }) })
                ] }),
                /* @__PURE__ */ m.jsxs(
                  Re,
                  {
                    as: "ul",
                    display: "flex",
                    flexFlow: "column nowrap",
                    gap: "2",
                    w: "full",
                    py: 4,
                    children: [
                      /* @__PURE__ */ m.jsx(de, { as: "h3", fontWeight: "bold", children: "Translations Taxonomy:" }),
                      /* @__PURE__ */ m.jsxs(zt, { allowMultiple: !0, py: 2, children: [
                        y && /* @__PURE__ */ m.jsxs(nt, { children: [
                          /* @__PURE__ */ m.jsx(mt, { children: "Global" }),
                          /* @__PURE__ */ m.jsx(at, { children: y && y.strings && y.strings.map((G, oe) => /* @__PURE__ */ m.jsxs(
                            Re,
                            {
                              as: "li",
                              style: {
                                listStyle: "none"
                              },
                              boxShadow: "md",
                              borderRadius: "base",
                              py: "4",
                              px: "4",
                              w: "full",
                              children: [
                                /* @__PURE__ */ m.jsxs(Ce, { flexFlow: "column nowrap", children: [
                                  /* @__PURE__ */ m.jsx(
                                    de,
                                    {
                                      as: "h3",
                                      fontSize: "md",
                                      fontWeight: "bold",
                                      children: "Text:"
                                    }
                                  ),
                                  /* @__PURE__ */ m.jsx(de, { as: "p", children: /* @__PURE__ */ m.jsx(
                                    yr,
                                    {
                                      text: G.value.content ?? "",
                                      translationKey: G.value.id.replace(
                                        `${f}-`,
                                        ""
                                      ),
                                      isFull: !0
                                    }
                                  ) })
                                ] }),
                                /* @__PURE__ */ m.jsx(Re, { mt: "2", children: /* @__PURE__ */ m.jsxs(
                                  Ce,
                                  {
                                    flexFlow: "column nowrap",
                                    gap: "2",
                                    children: [
                                      /* @__PURE__ */ m.jsxs(Ce, { flexFlow: "column nowrap", children: [
                                        /* @__PURE__ */ m.jsx(
                                          de,
                                          {
                                            as: "h4",
                                            fontSize: "md",
                                            fontWeight: "bold",
                                            children: "Module:"
                                          }
                                        ),
                                        /* @__PURE__ */ m.jsx(
                                          de,
                                          {
                                            as: "p",
                                            fontSize: "md",
                                            children: "global"
                                          }
                                        )
                                      ] }),
                                      /* @__PURE__ */ m.jsxs(Ce, { flexFlow: "column nowrap", children: [
                                        /* @__PURE__ */ m.jsx(
                                          de,
                                          {
                                            as: "h4",
                                            fontSize: "md",
                                            fontWeight: "bold",
                                            children: "Section:"
                                          }
                                        ),
                                        /* @__PURE__ */ m.jsx(
                                          de,
                                          {
                                            as: "p",
                                            fontSize: "md",
                                            children: G.value.sectionId
                                          }
                                        )
                                      ] }),
                                      /* @__PURE__ */ m.jsxs(Ce, { flexFlow: "column nowrap", children: [
                                        /* @__PURE__ */ m.jsx(
                                          de,
                                          {
                                            as: "h4",
                                            fontSize: "md",
                                            fontWeight: "bold",
                                            children: "Path/id:"
                                          }
                                        ),
                                        /* @__PURE__ */ m.jsx(
                                          de,
                                          {
                                            as: "p",
                                            fontSize: "md",
                                            children: G.value.id.replace(
                                              `${f}-`,
                                              ""
                                            )
                                          }
                                        )
                                      ] })
                                    ]
                                  }
                                ) })
                              ]
                            },
                            `${G.key}-${oe}`
                          )) })
                        ] }),
                        mr.getScriptManager(
                          f,
                          Q,
                          U
                        ).scripts.filter(
                          (G) => G.value.languageCode === U && G.value.sectionId !== "Global"
                        ).reduce(
                          (G, oe) => {
                            const le = G.find(
                              (se) => se.sectionId === oe.value.sectionId
                            );
                            return le ? le.values.push(oe) : G.push({
                              sectionId: oe.value.sectionId,
                              values: [oe]
                            }), G;
                          },
                          []
                        ).map((G, oe) => /* @__PURE__ */ m.jsxs(
                          nt,
                          {
                            children: [
                              /* @__PURE__ */ m.jsx(mt, { children: G.sectionId }),
                              /* @__PURE__ */ m.jsx(at, { children: G.values.map(
                                (le, se) => /* @__PURE__ */ m.jsxs(
                                  Re,
                                  {
                                    as: "li",
                                    style: {
                                      listStyle: "none"
                                    },
                                    boxShadow: "md",
                                    borderRadius: "base",
                                    py: "4",
                                    px: "4",
                                    w: "full",
                                    children: [
                                      /* @__PURE__ */ m.jsxs(Ce, { flexFlow: "column nowrap", children: [
                                        /* @__PURE__ */ m.jsx(
                                          de,
                                          {
                                            as: "h3",
                                            fontSize: "md",
                                            fontWeight: "bold",
                                            children: "Text:"
                                          }
                                        ),
                                        /* @__PURE__ */ m.jsx(de, { as: "p", children: /* @__PURE__ */ m.jsx(
                                          yr,
                                          {
                                            text: le.value.text,
                                            translationKey: le.value.id,
                                            isFull: !0
                                          }
                                        ) })
                                      ] }),
                                      /* @__PURE__ */ m.jsx(Re, { mt: "2", children: /* @__PURE__ */ m.jsxs(
                                        Ce,
                                        {
                                          flexFlow: "column nowrap",
                                          gap: "2",
                                          children: [
                                            /* @__PURE__ */ m.jsxs(Ce, { flexFlow: "column nowrap", children: [
                                              /* @__PURE__ */ m.jsx(
                                                de,
                                                {
                                                  as: "h4",
                                                  fontSize: "md",
                                                  fontWeight: "bold",
                                                  children: "Module:"
                                                }
                                              ),
                                              /* @__PURE__ */ m.jsx(
                                                de,
                                                {
                                                  as: "p",
                                                  fontSize: "md",
                                                  children: le.value.moduleId
                                                }
                                              )
                                            ] }),
                                            /* @__PURE__ */ m.jsxs(Ce, { flexFlow: "column nowrap", children: [
                                              /* @__PURE__ */ m.jsx(
                                                de,
                                                {
                                                  as: "h4",
                                                  fontSize: "md",
                                                  fontWeight: "bold",
                                                  children: "Section:"
                                                }
                                              ),
                                              /* @__PURE__ */ m.jsx(
                                                de,
                                                {
                                                  as: "p",
                                                  fontSize: "md",
                                                  children: le.value.sectionId
                                                }
                                              )
                                            ] }),
                                            /* @__PURE__ */ m.jsxs(Ce, { flexFlow: "column nowrap", children: [
                                              /* @__PURE__ */ m.jsx(
                                                de,
                                                {
                                                  as: "h4",
                                                  fontSize: "md",
                                                  fontWeight: "bold",
                                                  children: "Path/id:"
                                                }
                                              ),
                                              /* @__PURE__ */ m.jsx(
                                                de,
                                                {
                                                  as: "p",
                                                  fontSize: "md",
                                                  children: le.value.id
                                                }
                                              )
                                            ] }),
                                            /* @__PURE__ */ m.jsxs(Ce, { flexFlow: "column nowrap", children: [
                                              /* @__PURE__ */ m.jsx(
                                                de,
                                                {
                                                  as: "h4",
                                                  fontSize: "md",
                                                  fontWeight: "bold",
                                                  children: "Status"
                                                }
                                              ),
                                              /* @__PURE__ */ m.jsx(
                                                de,
                                                {
                                                  as: "p",
                                                  fontSize: "md",
                                                  children: le.status === "changed" ? `${le.status} - queued for publishing` : le.status
                                                }
                                              )
                                            ] })
                                          ]
                                        }
                                      ) })
                                    ]
                                  },
                                  se + le.value.id
                                )
                              ) })
                            ]
                          },
                          oe + G.sectionId
                        ))
                      ] })
                    ]
                  }
                )
              ]
            }
          ) })
        ] }),
        I === "Config" && /* @__PURE__ */ m.jsx(Vn, { children: /* @__PURE__ */ m.jsxs(Lt, { gap: 4, columns: 3, w: "full", children: [
          /* @__PURE__ */ m.jsx(
            et,
            {
              colorScheme: "primary",
              variant: "outline",
              onClick: () => {
                j();
              },
              children: "Reset"
            }
          ),
          /* @__PURE__ */ m.jsx(et, { colorScheme: "primary", onClick: P, children: L ? "Copied!" : "Copy Config" }),
          /* @__PURE__ */ m.jsx(
            et,
            {
              colorScheme: "primary",
              onClick: () => E({
                url: z.baseApi,
                hmacKey: z.hmacKey,
                authToken: A,
                dataConfig: p
              }),
              children: "Publish"
            }
          )
        ] }) })
      ] })
    ] }),
    /* @__PURE__ */ m.jsx(
      et,
      {
        "aria-label": "dev-tools",
        boxSize: "42px",
        borderRadius: "100%",
        pos: "fixed",
        bottom: "24px",
        left: "24px",
        zIndex: 1e3,
        colorScheme: "primary",
        onClick: v.onOpen,
        children: "</>"
      }
    )
  ] });
};
export {
  Zi as MyAsurionDevTools
};
